import React, { useState, Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import { useStateIfMounted } from 'use-state-if-mounted';
import PrevisualizarAchivoComponent from './PrevisualizarArchivoComponent';
import estilos from './AtencionAClientesFC_01Component.module.css';
import GetAppIcon from '@mui/icons-material/GetApp';
import IconButton from '@mui/material/IconButton';
import { v4 as uuidv4 } from 'uuid';
import Draggable from 'react-draggable';
import PaginacionAtencionAClientesComponent from '../../App/PaginacionAtencionAClientesComponent';
import moment from 'moment'
const { useRef } = React;
import { useReactToPrint } from "react-to-print";
import { Paper, Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import BotonVerArchivoComponent from '../../App/BotonVerArchivoComponent';
import Collapsible from 'react-collapsible';
import {
    guardarVigenciasDocumentacion, agregarMapFC_01Accion, actualizarFC_01Estatus,
    actualizarFC_01,
    actualizarMapsDocumentacion,
    actualizarMapFC_01Accion,
    aceptarSolicitudFC_01,
    obtenerSolicitudFC_01ParaAceptar,
    enviarCorreo,
    generarDocumentos,
    obtenerFolio,
    actualizarFolioOficio,
    actualizarLogin,
    setModoVerDetalle, resetDataFC_01, obtenerRevisor,
    actualizarFC_01NumSocio, obtenerClientePorNoSocio,
    agregarRelaciones,
    AgregarDOMMap, actualizarDOMap, actualizarFC_01Formulario,
    actualizarTipoUsuario
} from '../../../redux/DucksAtencionACliente/FC_01AtencionAClienteDucks';
import FormularioDocumentacion from '../../formatos/FormularioDocumentacion';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';
import { obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado, obtenerTodasLasSolicitudesWithStatusEnviado } from '../../../redux/DucksAtencionACliente/AtencionAClienteDucks'
import Tooltip from '@mui/material/Tooltip';
import { obtenerLogin } from '../../../redux/UsuarioDucks';
import { ArchivoComponent } from '../../ArchivosComponents/ArchivoComponent';
import { actualizarFileFC_01, agregarFileFC_01, eliminarFileFC_01 } from '../../../redux/DucksBeneficiario/FC_01Ducks';
import { crearMetricas } from '../../../redux/DuckMetricas/MetricasDuck.js';
const styleIncorrecto = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(100%, -10%)',
    width: 330,
    height: 220,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 0,
    p: 3,
    'overflowY': 'scroll',
};
const styleCorrecto = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(90%, -35%)',
    width: 350,
    height: 450,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 3,
    p: 3,
    // background:'black',
    opacity: 1,
    'overflowY': 'scroll',
};
const styleParaModalDeDocumentos = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1000,
    height: 600,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    color: 'black',
    p: 4,
    'overflowY': 'scroll',
};
import SaveIcon from '@mui/icons-material/Save';
function FC_01AtencionAClientesComponent(props) {

    const dataUser = useSelector(store => store.Usuario.user)
    console.log("dataUser", dataUser)
    const currentUser = useSelector(store => store.Usuario.data)
    const [solicitud, setSolicitud] = React.useState(useSelector(store => store.FC_01SolicitudAtencionACliente.fc_01))
    const modoRecibidasCorregidas = useSelector(store => store.FC_01SolicitudAtencionACliente.modoRecibidasCorregidas)
    const modoVerDetalle = useSelector(store => store.FC_01SolicitudAtencionACliente.modoVerDetalle)
    const modoProceso = useSelector(store => store.FC_01SolicitudAtencionACliente.modoProceso)
    const estadosDenominacionOrigen = useSelector(store => store.FC_01SolicitudAtencionACliente.estadosDenominacionOrigen)
    const estadosDenominacion = useSelector(store => store.FC_01SolicitudAtencionACliente.estadosDenominacion)
    const municipiosTamaulipas = useSelector(store => store.FC_01SolicitudAtencionACliente.municipiosTamaulipas)
    const municipiosGuanajuato = useSelector(store => store.FC_01SolicitudAtencionACliente.municipiosGuanajuato)
    const municipiosMichoacan = useSelector(store => store.FC_01SolicitudAtencionACliente.municipiosMichoacan)
    const municipiosPuebla = useSelector(store => store.FC_01SolicitudAtencionACliente.municipiosPuebla)
    const [asociado, setasociado] = React.useState(solicitud.asociado)
    const [noasociado, setnoasociado] = React.useState(solicitud.noasociado)
    const [inscrito, setinscrito] = React.useState(solicitud.inscrito)
    const [numerosocio, setnumerosocio] = React.useState(solicitud.numerosocio)
    // if (solicitud.asociado === true) {
    //     setnoasociado(true)
    // }
    // if (solicitud.noasociado === true) {
    //     setasociado(true)
    // }
    // if (solicitud.inscrito === true) {
    //     setinscrito(true)
    //     setnumerosocio(solicitud.numerosocio)
    // }
    const nodeRef = React.useRef(null);
    const dispatch = useDispatch()

    React.useEffect(() => {
        let filtro = solicitud.fc_01_anexos.filter(anexo => anexo.nameid === 'DGDO')
        let fileDoc = []
        if (filtro.length > 0) {
            if (solicitud.opciondom !== null) setopcionDom(solicitud.opciondom)
            if (solicitud.numerodom !== null) setnumeroDom(solicitud.numerodom)
            setFechaInicioDom(moment(filtro?.[0]?.fechainicio).format('YYYY-MM-DD'))
            setFechaFinDom(moment(filtro?.[0]?.fechafin).format('YYYY-MM-DD'))
            setEstatusDom(filtro?.[0].estatus)
            if (filtro?.[0]?.fc_01_anexosmap.length > 0) {
                setFileMap(filtro?.[0]?.fc_01_anexosmap)
                setObservacionesDom(filtro?.[0]?.fc_01_anexosmap?.[0]?.nameid)

            }
            let nameFile = null
            const array = filtro[0].ruta.split("/")
            nameFile = array[array.length - 1]
            const data = {
                id: filtro[0].nameid,
                file: { name: nameFile },
                idAnexo: filtro[0].idfc01_anexos,
                idAnexoFK: filtro[0].idfc01_solicitudregistro,
                estatus: true,
            }
            fileDoc.push(data)
        }
        setFile(fileDoc)
    }, [])

    React.useEffect(() => {
        if (modoRecibidasCorregidas) {
        } else if (modoProceso) {
        }
    }, [])
    React.useEffect(() => {
        if (JSON.stringify({}) === JSON.stringify(solicitud)) {
            props.history.push('/AtencionAClientesComponent')
        }
    }, [])
    // let cadenaProductiva = ''
    // if (solicitud.viverista) cadenaProductiva += 'Viverista, '
    // if (solicitud.productormaguey) cadenaProductiva += 'Productor de maguey, '
    // if (solicitud.productormezcal) cadenaProductiva += 'Productor de mezcal, '
    // if (solicitud.envasador) cadenaProductiva += 'Envasador, '
    // if (solicitud.comercializadormezcal) cadenaProductiva += 'Comercializador de mezcal, '
    // if (solicitud.comercializadorbebidasconmezcal) cadenaProductiva += 'comercializador de bebidas con mezcal, '

    let cadenaProductiva = ''
    const arrayCadena = []
    if (solicitud.viverista) arrayCadena.push('Viverista')
    if (solicitud.productormaguey) arrayCadena.push('Productor de maguey')
    if (solicitud.productormezcal) arrayCadena.push('Productor de mezcal')
    if (solicitud.envasador) arrayCadena.push('Envasador')
    if (solicitud.comercializadormezcal) arrayCadena.push('Comercializador de mezcal')
    if (solicitud.comercializadorbebidasconmezcal) arrayCadena.push('Comercializador de productos con mezcal')
    if (arrayCadena.length > 1) {
        for (const i in arrayCadena) {
            if (Number(i) === 0) {
                cadenaProductiva += arrayCadena[i]
            } else if (Number(i) + Number(1) === arrayCadena.length) {
                cadenaProductiva += ' y ' + arrayCadena[i]
            } else {
                cadenaProductiva += ', ' + arrayCadena[i]
            }
        }
    } else {
        cadenaProductiva = arrayCadena[0]
    }

    let calleSolicitud = solicitud.calle
    if (solicitud.calle === 'Otro') calleSolicitud = solicitud.otracalle
    let domicilioFiscal = calleSolicitud + ';' + solicitud.numerointerior + ';' + solicitud.numeroexterior + ';' + solicitud.colonia
        + ';' + solicitud.localidad + ';' + solicitud.municipioalcaldia + ';' + solicitud.estado + ';' + solicitud.codigopostal
    let socio = []
    let principal = []
    let apoderadoLegal = []
    let personaAutorizada = []
    let domicilioCadena = []
    if (solicitud.asociado & !solicitud.inscrito) {
        socio.push(
            {
                id: uuidv4(), Campo: 'Tipo de inscripción', valor: solicitud.asociado ? 'Cliente Asociado' : '',
                observaciones: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.tipocliente : '',
                correcto: solicitud.fc_01_solicitudderegistromap ? !solicitud.fc_01_solicitudderegistromap[0]?.tipoclientecheck : false,
                incorrecto: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.tipoclientecheck : false,

            },
        )
    }
    if (solicitud.noasociado & !solicitud.inscrito) {
        socio.push(
            {
                id: uuidv4(), Campo: 'Tipo de inscripción', valor: solicitud.noasociado ? 'Cliente No Asociado' : '',
                observaciones: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.tipocliente : '',
                correcto: solicitud.fc_01_solicitudderegistromap ? !solicitud.fc_01_solicitudderegistromap[0]?.tipoclientecheck : false,
                incorrecto: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.tipoclientecheck : false,

            },
        )
    }
    if (solicitud.inscrito) {
        socio.push(
            {
                id: uuidv4(), Campo: 'Tipo de inscripción', valor: solicitud.inscrito ? 'Ya se encuentra inscrito' : '',
                observaciones: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.tipocliente : '',
                correcto: solicitud.fc_01_solicitudderegistromap ? !solicitud.fc_01_solicitudderegistromap[0]?.tipoclientecheck : false,
                incorrecto: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.tipoclientecheck : false,

            },
            //  {
            //     id: uuidv4(), Campo: 'Número de socio', valor: solicitud.numerosocio,
            //     observaciones: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.numerosocio : '',
            //     correcto: solicitud.fc_01_solicitudderegistromap ? !solicitud.fc_01_solicitudderegistromap[0]?.numerosociocheck : false,
            //     incorrecto: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.numerosociocheck : false,

            // },
        )
    }


    const documentacionGeneral = []
    // const documentacion = []
    if (solicitud.personamoral) {
        principal.push(
            {
                id: uuidv4(), Campo: 'Razón Social', valor: solicitud.nombrerazonsocial,
                observaciones: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.nombrerazonsocial : '',
                correcto: solicitud.fc_01_solicitudderegistromap ? !solicitud.fc_01_solicitudderegistromap[0]?.nombrerazonsocialcheck : false,
                incorrecto: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.nombrerazonsocialcheck : false,
                dataDocumentacion: {
                    tabla: 'fc_01_anexos',
                    nombreId: 'idfc01_solicitudregistro',
                    idSolicitud: solicitud.idfc01_solicitudregistro,
                    nameid: `DGAC`,
                },
            },
            {
                id: uuidv4(), Campo: 'Rfc', valor: solicitud.rfc,
                observaciones: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.rfc : '',
                correcto: solicitud.fc_01_solicitudderegistromap ? !solicitud.fc_01_solicitudderegistromap[0]?.rfccheck : false,
                incorrecto: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.rfccheck : false,
                dataDocumentacion: {
                    tabla: 'fc_01_anexos',
                    nombreId: 'idfc01_solicitudregistro',
                    idSolicitud: solicitud.idfc01_solicitudregistro,
                    nameid: `DGRFC`,
                },
            },
            {
                id: uuidv4(), Campo: 'Teléfono', valor: solicitud.telefono,
                observaciones: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.telefono : '',
                correcto: solicitud.fc_01_solicitudderegistromap ? !solicitud.fc_01_solicitudderegistromap[0]?.telefonocheck : false,
                incorrecto: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.telefonocheck : false,
                documentacion: ''
            },
            {
                id: uuidv4(), Campo: 'Correo Electrónico', valor: solicitud.correoelectronico,
                observaciones: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.correoelectronico : '',
                correcto: solicitud.fc_01_solicitudderegistromap ? !solicitud.fc_01_solicitudderegistromap[0]?.correoelectronicocheck : false,
                incorrecto: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.correoelectronicocheck : false,
                documentacion: ''
            },
            {
                id: uuidv4(), Campo: 'Representante Legal', valor: solicitud.representantelegal,
                observaciones: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.representantelegal : '',
                correcto: solicitud.fc_01_solicitudderegistromap ? !solicitud.fc_01_solicitudderegistromap[0]?.representantelegalcheck : false,
                incorrecto: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.representantelegalcheck : false,
                documentacion: '', dataDocumentacion: {
                    tabla: 'fc_01_anexos',
                    nombreId: 'idfc01_solicitudregistro',
                    idSolicitud: solicitud.idfc01_solicitudregistro,
                    nameid: `DGIOVREP`,
                },
            },
        )
        if (solicitud.certificacionsi) principal.push({
            id: uuidv4(), Campo: 'Empresa Certificadora', valor: solicitud.empresacertificadora,
            observaciones: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.empresacertificadora : '',
            correcto: solicitud.fc_01_solicitudderegistromap ? !solicitud.fc_01_solicitudderegistromap[0]?.empresacertificadoracheck : false,
            incorrecto: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.empresacertificadoracheck : false,
            documentacion: ''
        })
        documentacionGeneral.push({ id: uuidv4(), nameDoc: 'DOCUMENTACIÓN GENERAL' })

        documentacionGeneral.push({
            id: uuidv4(),
            observaciones: solicitud.DGAC?.nameid !== undefined ? solicitud.DGAC.nameid : '',
            correcto: solicitud.DGAC?.nameidcheck !== undefined ? !solicitud.DGAC.nameidcheck : false,
            incorrecto: solicitud.DGAC?.nameidcheck !== undefined ? solicitud.DGAC.nameidcheck : false,
            fechaInicio: solicitud.DGAC ? solicitud?.DGAC?.fechainicio?.substring(0, 10) : '',
            fechaTermino: solicitud.DGAC ? solicitud?.DGAC?.fechafin?.substring(0, 10) : '',
            estatus: solicitud.DGAC ? solicitud.DGAC.estatus : 'Agregar',
            idMap: solicitud.DGAC ? solicitud.DGAC.idMap : '',
            idFK: solicitud.DGAC ? solicitud.DGAC.idFK : '',
            tabla: 'fc_01_anexos', nombreId: 'idfc01_solicitudregistro', idSolicitud: solicitud.idfc01_solicitudregistro, nameid: `DGAC`, nameDoc: 'Acta constitutiva notariada'
        })

        documentacionGeneral.push({
            id: uuidv4(),
            observaciones: solicitud.DGPN ? solicitud.DGPN.nameid : '',
            correcto: solicitud.DGPN ? !solicitud.DGPN.nameidcheck : false,
            incorrecto: solicitud.DGPN ? solicitud.DGPN.nameidcheck : false,
            fechaInicio: solicitud.DGPN ? solicitud?.DGPN?.fechainicio?.substring(0, 10) : '',
            fechaTermino: solicitud.DGPN ? solicitud?.DGPN?.fechafin?.substring(0, 10) : '',
            estatus: solicitud.DGPN ? solicitud.DGPN.estatus : 'Agregar',
            idMap: solicitud.DGPN ? solicitud.DGPN.idMap : '',
            idFK: solicitud.DGPN ? solicitud.DGPN.idFK : '',
            tabla: 'fc_01_anexos', nombreId: 'idfc01_solicitudregistro', idSolicitud: solicitud.idfc01_solicitudregistro, nameid: `DGPN`, nameDoc: 'Poder notarial del representante legal o última acta de asamblea notariada.'
        })

        documentacionGeneral.push({
            id: uuidv4(),
            observaciones: solicitud.DGIOVREP ? solicitud.DGIOVREP.nameid : '',
            correcto: solicitud.DGIOVREP ? !solicitud.DGIOVREP.nameidcheck : false,
            incorrecto: solicitud.DGIOVREP ? solicitud.DGIOVREP.nameidcheck : false,
            fechaInicio: solicitud.DGIOVREP ? solicitud?.DGIOVREP?.fechainicio?.substring(0, 10) : '',
            fechaTermino: solicitud.DGIOVREP ? solicitud?.DGIOVREP?.fechafin?.substring(0, 10) : '',
            estatus: solicitud.DGIOVREP ? solicitud.DGIOVREP.estatus : 'Agregar',
            idMap: solicitud.DGIOVREP ? solicitud.DGIOVREP.idMap : '',
            idFK: solicitud.DGIOVREP ? solicitud.DGIOVREP.idFK : '',
            tabla: 'fc_01_anexos', nombreId: 'idfc01_solicitudregistro', idSolicitud: solicitud.idfc01_solicitudregistro, nameid: `DGIOVREP`, nameDoc: 'Identificación oficial vigente del representante legal: ' + solicitud.representantelegal
        })


        for (const apoderado of solicitud.fc_01_anexorepresentantelegal) {
            const arrayDocumentacion = []
            for (const i in apoderado.fc_01_anexosrepresentantelegal) {
                const documentacion = {
                    tabla: 'fc_01_anexosrepresentantelegal',
                    nombreId: 'idfc01_anexorepresentantelegal',
                    idSolicitud: apoderado.fc_01_anexosrepresentantelegal[i].idfc01_anexorepresentantelegal,
                    nameid: apoderado.fc_01_anexosrepresentantelegal[i].nameid,
                }

                let nameDoc = ''
                if ((apoderado.fc_01_anexosrepresentantelegal[i].nameid).includes('DGIOVAP')) nameDoc = 'Identificación oficial vigente'
                else if ((apoderado.fc_01_anexosrepresentantelegal[i].nameid).includes('DGPNAP')) nameDoc = 'Poder notarial'

                documentacionGeneral.push({
                    id: uuidv4(),
                    observaciones: apoderado.fc_01_anexosrepresentantelegal[i].fc_01_anexosrepresentantelegalmap ? apoderado.fc_01_anexosrepresentantelegal[i].fc_01_anexosrepresentantelegalmap?.observacion : '',
                    correcto: apoderado.fc_01_anexosrepresentantelegal[i].fc_01_anexosrepresentantelegalmap ? !apoderado.fc_01_anexosrepresentantelegal[i].fc_01_anexosrepresentantelegalmap?.estatuscheck : false,
                    incorrecto: apoderado.fc_01_anexosrepresentantelegal[i].fc_01_anexosrepresentantelegalmap ? apoderado.fc_01_anexosrepresentantelegal[i].fc_01_anexosrepresentantelegalmap?.estatuscheck : false,
                    fechaInicio: apoderado.fc_01_anexosrepresentantelegal[i].fechainicio !== null ? apoderado.fc_01_anexosrepresentantelegal[i].fechainicio?.substring(0, 10) : '',
                    fechaTermino: apoderado.fc_01_anexosrepresentantelegal[i].fechafin !== null ? apoderado.fc_01_anexosrepresentantelegal[i].fechafin?.substring(0, 10) : '',
                    estatus: apoderado.fc_01_anexosrepresentantelegal[i].estatus !== null ? apoderado.fc_01_anexosrepresentantelegal[i].estatus : 'Agregar',
                    idMap: apoderado.fc_01_anexosrepresentantelegal[i].fc_01_anexosrepresentantelegalmap ? apoderado.fc_01_anexosrepresentantelegal[i].fc_01_anexosrepresentantelegalmap?.idfc01_anexorepresentantelegalmap : '',
                    tabla: 'fc_01_anexosrepresentantelegal', nombreId: 'idfc01_anexorepresentantelegal', idSolicitud: apoderado.fc_01_anexosrepresentantelegal[i].idfc01_anexorepresentantelegal,
                    nameid: apoderado.fc_01_anexosrepresentantelegal[i].nameid, nameDoc: nameDoc + ' del apoderado legal ' + apoderado.representantelegal,
                    // idFK:apoderado.fc_01_anexosrepresentantelegal[i]?.idanexorepresentantelegal,
                    idAnexo: apoderado.fc_01_anexosrepresentantelegal[i].idanexorepresentantelegal
                })


                arrayDocumentacion.push(documentacion)
            }

            apoderadoLegal.push({
                id: uuidv4(), idfc01_anexorepresentantelegal: apoderado.idfc01_anexorepresentantelegal, Campo: 'Apoderado Legal', valor: apoderado.representantelegal,
                observaciones: apoderado.fc_01_anexorepresentantelegalmap ? apoderado.fc_01_anexorepresentantelegalmap[0]?.representantelegal : '',
                correcto: apoderado.fc_01_anexorepresentantelegalmap ? !apoderado.fc_01_anexorepresentantelegalmap[0]?.representantelegalcheck : false,
                incorrecto: apoderado.fc_01_anexorepresentantelegalmap ? apoderado.fc_01_anexorepresentantelegalmap[0]?.representantelegalcheck : false,
                idMap: apoderado.fc_01_anexorepresentantelegalmap?.[0]?.idfc01_anexorepresentantelegalmap,
                arrayDocumentacion
            })
        }

        for (const i in solicitud.fc_01_anexopersonaautorizadatramites) {
            const { ...representante } = solicitud.fc_01_anexopersonaautorizadatramites[i]

            personaAutorizada.push({
                id: uuidv4(), idfc01_anexopersonaatorizadatramites: representante.idfc01_anexopersonaatorizadatramites, Campo: 'Persona Autorizada', valor: representante.personaautoriazadaparatramites,
                observaciones: representante.fc_01_anexopersonaautorizadatramitesmap ? representante.fc_01_anexopersonaautorizadatramitesmap[0]?.personaautoriazadaparatramites : '',
                correcto: representante.fc_01_anexopersonaautorizadatramitesmap ? !representante.fc_01_anexopersonaautorizadatramitesmap[0]?.personaautoriazadaparatramitescheck : false,
                incorrecto: representante.fc_01_anexopersonaautorizadatramitesmap ? representante.fc_01_anexopersonaautorizadatramitesmap[0]?.personaautoriazadaparatramitescheck : false,
                idMap: representante.fc_01_anexopersonaautorizadatramitesmap?.[0]?.idfc01_anexopersonaatorizadatramitesmap,
                dataDocumentacion: {
                    tabla: 'fc_01_anexospersonaautorizada',
                    nombreId: 'idfc01_anexopersonaatorizadatramites',
                    idSolicitud: representante.fc_01_anexospersonaautorizada[0]?.idfc01_anexopersonaatorizadatramites,
                    nameid: representante.fc_01_anexospersonaautorizada[0]?.nameid,
                },
            })

            documentacionGeneral.push({
                id: uuidv4(),
                observaciones: representante.fc_01_anexospersonaautorizada[0]?.fc_01_anexospersonaautorizadamap[0] ? representante.fc_01_anexospersonaautorizada[0]?.fc_01_anexospersonaautorizadamap[0]?.observacion : '',
                correcto: representante.fc_01_anexospersonaautorizada[0]?.fc_01_anexospersonaautorizadamap[0] ? !representante.fc_01_anexospersonaautorizada[0]?.fc_01_anexospersonaautorizadamap[0]?.estatuscheck : false,
                incorrecto: representante.fc_01_anexospersonaautorizada[0]?.fc_01_anexospersonaautorizadamap[0] ? representante.fc_01_anexospersonaautorizada[0]?.fc_01_anexospersonaautorizadamap[0]?.estatuscheck : false,
                fechaInicio: representante.fc_01_anexospersonaautorizada[0]?.fechainicio !== null ? representante.fc_01_anexospersonaautorizada[0]?.fechainicio?.substring(0, 10) : '',
                fechaTermino: representante.fc_01_anexospersonaautorizada[0]?.fechafin !== null ? representante.fc_01_anexospersonaautorizada[0]?.fechafin?.substring(0, 10) : '',
                estatus: representante.fc_01_anexospersonaautorizada[0]?.estatus !== null ? representante.fc_01_anexospersonaautorizada[0]?.estatus : 'Agregar',
                idMap: representante.fc_01_anexospersonaautorizada?.[0]?.fc_01_anexospersonaautorizadamap[0] ? representante.fc_01_anexospersonaautorizada[0]?.fc_01_anexospersonaautorizadamap[0]?.idfc01_anexospersonaautorizadamap : '',
                tabla: 'fc_01_anexospersonaautorizada', nombreId: 'idfc01_anexopersonaatorizadatramites', idSolicitud: representante.fc_01_anexospersonaautorizada[0]?.idfc01_anexopersonaatorizadatramites,
                nameid: representante.fc_01_anexospersonaautorizada[0]?.nameid, nameDoc: 'Identificación oficial vigente de la persona autorizada: ' + representante.personaautoriazadaparatramites,
                idAnexo: representante.fc_01_anexospersonaautorizada[0]?.idanexopersonaautorizada,
                idFK: representante.fc_01_anexospersonaautorizada[0]?.idanexopersonaautorizada,
            })
        }

        domicilioCadena.push(
            // { id: uuidv4(), Campo: 'Persona Autorizada', valor: solicitud.representantelegal, observaciones: '', correcto: false, incorrecto: false, },
            {
                id: uuidv4(), Campo: 'Cadena Productiva', valor: cadenaProductiva,
                observaciones: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.cadenaproductiva : '',
                correcto: solicitud.fc_01_solicitudderegistromap ? !solicitud.fc_01_solicitudderegistromap[0]?.cadenaproductivacheck : false,
                incorrecto: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.cadenaproductivacheck : false,
                documentacion: ''
            },
            {
                id: uuidv4(), Campo: 'Domicilio Fiscal', valor: domicilioFiscal,
                observaciones: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.domiciliofiscal : '',
                correcto: solicitud.fc_01_solicitudderegistromap ? !solicitud.fc_01_solicitudderegistromap[0]?.domiciliofiscalcheck : false,
                incorrecto: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.domiciliofiscalcheck : false,
                dataDocumentacion: {
                    tabla: 'fc_01_anexos',
                    nombreId: 'idfc01_solicitudregistro',
                    idSolicitud: solicitud.idfc01_solicitudregistro,
                    nameid: `DGCDF`,
                },
            }
        )
        documentacionGeneral.push({
            id: uuidv4(),
            observaciones: solicitud.DGCDF ? solicitud.DGCDF.nameid : '',
            correcto: solicitud.DGCDF ? !solicitud.DGCDF.nameidcheck : false,
            incorrecto: solicitud.DGCDF ? solicitud.DGCDF.nameidcheck : false,
            fechaInicio: solicitud.DGCDF ? solicitud.DGCDF.fechafin?.substring(0, 10) : '',
            fechaTermino: solicitud.DGCDF ? solicitud.DGCDF.fechainicio?.substring(0, 10) : '',
            estatus: solicitud.DGCDF ? solicitud.DGCDF.estatus : 'Agregar',
            idMap: solicitud.DGCDF ? solicitud.DGCDF.idMap : '',
            idFK: solicitud.DGCDF ? solicitud.DGCDF.idFK : '',
            tabla: 'fc_01_anexos', nombreId: 'idfc01_solicitudregistro', idSolicitud: solicitud.idfc01_solicitudregistro, nameid: `DGCDF`, nameDoc: 'Comprobante de domicilio Fiscal'
        })
        if (!(solicitud.productormaguey && !solicitud.viverista && !solicitud.productormezcal && !solicitud.envasador && !solicitud.comercializadorbebidasconmezcal && !solicitud.comercializadormezcal)) {
            documentacionGeneral.push({
                id: uuidv4(),
                observaciones: solicitud.DGRFC ? solicitud.DGRFC.nameid : '',
                correcto: solicitud.DGRFC ? !solicitud.DGRFC.nameidcheck : false,
                incorrecto: solicitud.DGRFC ? solicitud.DGRFC.nameidcheck : false,
                fechaInicio: solicitud.DGRFC ? solicitud.DGRFC.fechafin?.substring(0, 10) : '',
                fechaTermino: solicitud.DGRFC ? solicitud.DGRFC.fechainicio?.substring(0, 10) : '',
                estatus: solicitud.DGRFC ? solicitud.DGRFC.estatus : 'Agregar',
                idMap: solicitud.DGRFC ? solicitud.DGRFC.idMap : '',
                idFK: solicitud.DGRFC ? solicitud.DGRFC.idFK : '',
                tabla: 'fc_01_anexos', nombreId: 'idfc01_solicitudregistro', idSolicitud: solicitud.idfc01_solicitudregistro, nameid: `DGRFC`, nameDoc: 'Constancia de situación fiscal (RFC)'
            })
        }
        if (solicitud.certificacionsi) documentacionGeneral.push({
            id: uuidv4(),
            observaciones: solicitud.DGC ? solicitud.DGC.nameid : '',
            correcto: solicitud.DGC ? !solicitud.DGC.nameidcheck : false,
            incorrecto: solicitud.DGC ? solicitud.DGC.nameidcheck : false,
            fechaInicio: solicitud.DGC ? solicitud.DGC.fechafin?.substring(0, 10) : '',
            fechaTermino: solicitud.DGC ? solicitud.DGC.fechainicio?.substring(0, 10) : '',
            estatus: solicitud.DGC ? solicitud.DGC.estatus : 'Agregar',
            idMap: solicitud.DGC ? solicitud.DGC.idMap : '',
            idFK: solicitud.DGC ? solicitud.DGC.idFK : '',
            tabla: 'fc_01_anexos', nombreId: 'idfc01_solicitudregistro', idSolicitud: solicitud.idfc01_solicitudregistro, nameid: `DGC`, nameDoc: 'Certificación de la empresa: ' + solicitud.empresacertificadora
        })

        if ((solicitud.viverista || solicitud.productormaguey) &&
            solicitud.productormezcal === false && solicitud.envasador == false &&
            solicitud.comercializadormezcal == false && solicitud.comercializadorbebidasconmezcal == false) {
        } else {
            documentacionGeneral.push({
                id: uuidv4(),
                observaciones: (solicitud.comprobantepago !== null && solicitud.comprobantepagotext !== null) ? solicitud.comprobantepagotext : '',
                correcto: solicitud.comprobantepago !== null ? !solicitud.comprobantepago : false,
                incorrecto: solicitud.comprobantepago !== null ? solicitud.comprobantepago : false,
                fechaInicio: solicitud.DGCP ? solicitud.DGCP.fechainicio?.substring(0, 10) : '',
                fechaTermino: solicitud.DGCP ? solicitud.DGCP.fechafin?.substring(0, 10) : '',
                estatus: solicitud.DGCP ? solicitud.DGCP.estatus : 'Agregar',
                idMap: solicitud.DGCP ? solicitud.DGCP.idMap : '',
                idFK: solicitud.DGCP ? solicitud.DGCP.idFK : '',
                tabla: 'fc_01_anexos', nombreId: 'idfc01_solicitudregistro', idSolicitud: solicitud.idfc01_solicitudregistro, nameid: `DGCP`, nameDoc: 'Comprobante de pago. '
            })
        }
    } else {
        principal.push(
            {
                id: uuidv4(), Campo: 'Nombre Completo',
                observaciones: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.nombrerazonsocial : '',
                correcto: solicitud.fc_01_solicitudderegistromap ? !solicitud.fc_01_solicitudderegistromap[0]?.nombrerazonsocialcheck : false,
                incorrecto: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.nombrerazonsocialcheck : false,
                valor: solicitud.nombrerazonsocial, dataDocumentacion: {
                    tabla: 'fc_01_anexos',
                    nombreId: 'idfc01_solicitudregistro',
                    idSolicitud: solicitud.idfc01_solicitudregistro,
                    nameid: `DGIOV`,
                },
            },
            {
                id: uuidv4(), Campo: 'Rfc', valor: solicitud.rfc,
                observaciones: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.rfc : '',
                correcto: solicitud.fc_01_solicitudderegistromap ? !solicitud.fc_01_solicitudderegistromap[0]?.rfccheck : false,
                incorrecto: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.rfccheck : false,
                dataDocumentacion: {
                    tabla: 'fc_01_anexos',
                    nombreId: 'idfc01_solicitudregistro',
                    idSolicitud: solicitud.idfc01_solicitudregistro,
                    nameid: `DGRFC`,
                },
            },
            {
                id: uuidv4(), Campo: 'Teléfono', valor: solicitud.telefono,
                observaciones: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.telefono : '',
                correcto: solicitud.fc_01_solicitudderegistromap ? !solicitud.fc_01_solicitudderegistromap[0]?.telefonocheck : false,
                incorrecto: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.telefonocheck : false,
                documentacion: ''
            },
            {
                id: uuidv4(), Campo: 'Correo Electrónico', valor: solicitud.correoelectronico,
                observaciones: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.correoelectronico : '',
                correcto: solicitud.fc_01_solicitudderegistromap ? !solicitud.fc_01_solicitudderegistromap[0]?.correoelectronicocheck : false,
                incorrecto: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.correoelectronicocheck : false,
                documentacion: ''
            },
        )
        if (solicitud.representantelegalsi) principal.push({
            id: uuidv4(), Campo: 'Apoderado Legal', valor: solicitud.representantelegal,
            observaciones: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.representantelegal : '',
            correcto: solicitud.fc_01_solicitudderegistromap ? !solicitud.fc_01_solicitudderegistromap[0]?.representantelegalcheck : false,
            incorrecto: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.representantelegalcheck : false,
            dataDocumentacion: {
                tabla: 'fc_01_anexos',
                nombreId: 'idfc01_solicitudregistro',
                idSolicitud: solicitud.idfc01_solicitudregistro,
                nameid: `DGIOVREP`,
            },
        })

        if (solicitud.certificacionsi) principal.push({
            id: uuidv4(), Campo: 'Empresa Certificadora', valor: solicitud.empresacertificadora,
            observaciones: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.empresacertificadora : '',
            correcto: solicitud.fc_01_solicitudderegistromap ? !solicitud.fc_01_solicitudderegistromap[0]?.empresacertificadoracheck : false,
            incorrecto: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.empresacertificadoracheck : false,
            documentacion: ''
        })

        documentacionGeneral.push({ id: uuidv4(), nameDoc: 'DOCUMENTACIÓN GENERAL' })
        documentacionGeneral.push({
            id: uuidv4(),
            observaciones: solicitud.DGIOV ? solicitud.DGIOV.nameid : '',
            correcto: solicitud.DGIOV ? !solicitud.DGIOV.nameidcheck : false,
            incorrecto: solicitud.DGIOV ? solicitud.DGIOV.nameidcheck : false,
            fechaInicio: solicitud.DGIOV ? solicitud.DGIOV.fechafin?.substring(0, 10) : '',
            fechaTermino: solicitud.DGIOV ? solicitud.DGIOV.fechainicio?.substring(0, 10) : '',
            estatus: solicitud.DGIOV ? solicitud.DGIOV.estatus : 'Agregar',
            idMap: solicitud.DGIOV ? solicitud.DGIOV.idMap : '',
            idFK: solicitud.DGIOV ? solicitud.DGIOV.idFK : '',
            tabla: 'fc_01_anexos', nombreId: 'idfc01_solicitudregistro', idSolicitud: solicitud.idfc01_solicitudregistro, nameid: `DGIOV`, nameDoc: 'Identificación oficial vigente del solicitante: ' + solicitud.nombrerazonsocial
        })
        documentacionGeneral.push({
            id: uuidv4(),
            observaciones: solicitud.DGCDF ? solicitud.DGCDF.nameid : '',
            correcto: solicitud.DGCDF ? !solicitud.DGCDF.nameidcheck : false,
            incorrecto: solicitud.DGCDF ? solicitud.DGCDF.nameidcheck : false,
            fechaInicio: solicitud.DGCDF ? solicitud.DGCDF.fechafin?.substring(0, 10) : '',
            fechaTermino: solicitud.DGCDF ? solicitud.DGCDF.fechainicio?.substring(0, 10) : '',
            estatus: solicitud.DGCDF ? solicitud.DGCDF.estatus : 'Agregar',
            idMap: solicitud.DGCDF ? solicitud.DGCDF.idMap : '',
            idFK: solicitud.DGCDF ? solicitud.DGCDF.idFK : '',
            tabla: 'fc_01_anexos', nombreId: 'idfc01_solicitudregistro', idSolicitud: solicitud.idfc01_solicitudregistro, nameid: `DGCDF`, nameDoc: 'Comprobante de domicilio Fiscal'
        })
        if (!(solicitud.productormaguey && !solicitud.viverista && !solicitud.productormezcal && !solicitud.envasador && !solicitud.comercializadorbebidasconmezcal && !solicitud.comercializadormezcal)) {
            documentacionGeneral.push({
                id: uuidv4(),
                observaciones: solicitud.DGRFC ? solicitud.DGRFC.nameid : '',
                correcto: solicitud.DGRFC ? !solicitud.DGRFC.nameidcheck : false,
                incorrecto: solicitud.DGRFC ? solicitud.DGRFC.nameidcheck : false,
                fechaInicio: solicitud.DGRFC ? solicitud.DGRFC.fechafin?.substring(0, 10) : '',
                fechaTermino: solicitud.DGRFC ? solicitud.DGRFC.fechainicio?.substring(0, 10) : '',
                estatus: solicitud.DGRFC ? solicitud.DGRFC.estatus : 'Agregar',
                idMap: solicitud.DGRFC ? solicitud.DGRFC.idMap : '',
                idFK: solicitud.DGRFC ? solicitud.DGRFC.idFK : '',
                tabla: 'fc_01_anexos', nombreId: 'idfc01_solicitudregistro', idSolicitud: solicitud.idfc01_solicitudregistro, nameid: `DGRFC`, nameDoc: 'Constancia de situación fiscal (RFC)'
            })
        }
        if (solicitud.representantelegalsi) documentacionGeneral.push({
            id: uuidv4(),
            observaciones: solicitud.DGIOVREP ? solicitud.DGIOVREP.nameid : '',
            correcto: solicitud.DGIOVREP ? !solicitud.DGIOVREP.nameidcheck : false,
            incorrecto: solicitud.DGIOVREP ? solicitud.DGIOVREP.nameidcheck : false,
            fechaInicio: solicitud.DGIOVREP ? solicitud.DGIOVREP.fechafin?.substring(0, 10) : '',
            fechaTermino: solicitud.DGIOVREP ? solicitud.DGIOVREP.fechainicio?.substring(0, 10) : '',
            estatus: solicitud.DGIOVREP ? solicitud.DGIOVREP.estatus : 'Agregar',
            idMap: solicitud.DGIOVREP ? solicitud.DGIOVREP.idMap : '',
            idFK: solicitud.DGIOVREP ? solicitud.DGIOVREP.idFK : '',
            tabla: 'fc_01_anexos', nombreId: 'idfc01_solicitudregistro', idSolicitud: solicitud.idfc01_solicitudregistro, nameid: `DGIOVREP`, nameDoc: 'Identificación oficial vigente del apoderado legal: ' + solicitud.representantelegal
        })

        // let personaCont = 0
        for (const i in solicitud.fc_01_anexopersonaautorizadatramites) {
            const { ...apoderado } = solicitud.fc_01_anexopersonaautorizadatramites[i]
        }
        for (const i in solicitud.fc_01_anexopersonaautorizadatramites) {
            const { ...apoderado } = solicitud.fc_01_anexopersonaautorizadatramites[i]
            personaAutorizada.push({
                id: uuidv4(), idfc01_anexopersonaatorizadatramites: apoderado.idfc01_anexopersonaatorizadatramites, Campo: 'Persona Autorizada', valor: apoderado.personaautoriazadaparatramites,
                observaciones: apoderado.fc_01_anexopersonaautorizadatramitesmap ? apoderado.fc_01_anexopersonaautorizadatramitesmap[0]?.personaautoriazadaparatramites : '',
                correcto: apoderado.fc_01_anexopersonaautorizadatramitesmap ? !apoderado.fc_01_anexopersonaautorizadatramitesmap[0]?.personaautoriazadaparatramitescheck : false,
                incorrecto: apoderado.fc_01_anexopersonaautorizadatramitesmap ? apoderado.fc_01_anexopersonaautorizadatramitesmap[0]?.personaautoriazadaparatramitescheck : false,
                idMap: apoderado.fc_01_anexopersonaautorizadatramitesmap?.[0]?.idfc01_anexopersonaatorizadatramitesmap,
                dataDocumentacion: {
                    tabla: 'fc_01_anexospersonaautorizada',
                    nombreId: 'idfc01_anexopersonaatorizadatramites',
                    idSolicitud: apoderado.fc_01_anexospersonaautorizada?.[0]?.idfc01_anexopersonaatorizadatramites,
                    nameid: apoderado.fc_01_anexospersonaautorizada?.[0]?.nameid,
                },
            })
            documentacionGeneral.push({
                id: uuidv4(),
                observaciones: apoderado.fc_01_anexospersonaautorizada[0]?.fc_01_anexospersonaautorizadamap[0] ? apoderado.fc_01_anexospersonaautorizada[0]?.fc_01_anexospersonaautorizadamap[0]?.observacion : '',
                correcto: apoderado.fc_01_anexospersonaautorizada[0]?.fc_01_anexospersonaautorizadamap[0] ? !apoderado.fc_01_anexospersonaautorizada[0]?.fc_01_anexospersonaautorizadamap[0]?.estatuscheck : false,
                incorrecto: apoderado.fc_01_anexospersonaautorizada[0]?.fc_01_anexospersonaautorizadamap[0] ? apoderado.fc_01_anexospersonaautorizada[0]?.fc_01_anexospersonaautorizadamap[0]?.estatuscheck : false,
                fechaInicio: apoderado.fc_01_anexospersonaautorizada[0]?.fechainicio !== null ? apoderado.fc_01_anexospersonaautorizada[0]?.fechainicio?.substring(0, 10) : '',
                fechaTermino: apoderado.fc_01_anexospersonaautorizada[0]?.fechafin !== null ? apoderado.fc_01_anexospersonaautorizada[0]?.fechafin?.substring(0, 10) : '',
                estatus: apoderado.fc_01_anexospersonaautorizada[0]?.estatus !== null ? apoderado.fc_01_anexospersonaautorizada[0]?.estatus : 'Agregar',
                idMap: apoderado.fc_01_anexospersonaautorizada?.[0]?.fc_01_anexospersonaautorizadamap[0] ? apoderado.fc_01_anexospersonaautorizada[0]?.fc_01_anexospersonaautorizadamap[0]?.idfc01_anexospersonaautorizadamap : '',
                tabla: 'fc_01_anexospersonaautorizada', nombreId: 'idfc01_anexopersonaatorizadatramites', idSolicitud: apoderado.fc_01_anexospersonaautorizada[0]?.idfc01_anexopersonaatorizadatramites, nameid: apoderado.fc_01_anexospersonaautorizada[0]?.nameid,
                nameDoc: 'Identificación oficial vigente de la persona autorizada: ' + apoderado.personaautoriazadaparatramites,
                idAnexo: apoderado.fc_01_anexospersonaautorizada[0]?.idanexopersonaautorizada
            })
            // personaCont++
        }
        domicilioCadena.push(
            // { id: uuidv4(), Campo: 'Persona Autorizada', valor: solicitud.representantelegal },
            {
                id: uuidv4(), Campo: 'Cadena Productiva', valor: cadenaProductiva,
                observaciones: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.cadenaproductiva : '',
                correcto: solicitud.fc_01_solicitudderegistromap ? !solicitud.fc_01_solicitudderegistromap[0]?.cadenaproductivacheck : false,
                incorrecto: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.cadenaproductivacheck : false,
                documentacion: ''
            },
            {
                id: uuidv4(), Campo: 'Domicilio Fiscal', valor: domicilioFiscal,
                observaciones: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.domiciliofiscal : '',
                correcto: solicitud.fc_01_solicitudderegistromap ? !solicitud.fc_01_solicitudderegistromap[0]?.domiciliofiscalcheck : false,
                incorrecto: solicitud.fc_01_solicitudderegistromap ? solicitud.fc_01_solicitudderegistromap[0]?.domiciliofiscalcheck : false,
                dataDocumentacion: {
                    tabla: 'fc_01_anexos',
                    nombreId: 'idfc01_solicitudregistro',
                    idSolicitud: solicitud.idfc01_solicitudregistro,
                    nameid: `DGCDF`,
                },
            }
        )
        if (solicitud.certificacionsi) documentacionGeneral.push({
            id: uuidv4(),
            observaciones: solicitud.DGC ? solicitud.DGC.nameid : '',
            correcto: solicitud.DGC ? !solicitud.DGC.nameidcheck : false,
            incorrecto: solicitud.DGC ? solicitud.DGC.nameidcheck : false,
            fechaInicio: solicitud.DGC ? solicitud.DGC.fechafin?.substring(0, 10) : '',
            fechaTermino: solicitud.DGC ? solicitud.DGC.fechainicio?.substring(0, 10) : '',
            estatus: solicitud.DGC ? solicitud.DGC.estatus : 'Agregar',
            idMap: solicitud.DGC ? solicitud.DGC.idMap : '',
            tabla: 'fc_01_anexos', nombreId: 'idfc01_solicitudregistro', idSolicitud: solicitud.idfc01_solicitudregistro, nameid: `DGC`, nameDoc: 'Certificación de la empresa: ' + solicitud.empresacertificadora
        })

        if ((solicitud.viverista || solicitud.productormaguey) &&
            solicitud.productormezcal === false && solicitud.envasador == false &&
            solicitud.comercializadormezcal == false && solicitud.comercializadorbebidasconmezcal == false) {
        } else {
            documentacionGeneral.push({
                id: uuidv4(),
                observaciones: (solicitud.comprobantepago !== null && solicitud.comprobantepagotext !== null) ? solicitud.comprobantepagotext : '',
                correcto: solicitud.comprobantepago !== null ? !solicitud.comprobantepago : false,
                incorrecto: solicitud.comprobantepago !== null ? solicitud.comprobantepago : false,
                fechaInicio: solicitud.DGCP ? solicitud.DGCP.fechainicio?.substring(0, 10) : '',
                fechaTermino: solicitud.DGCP ? solicitud.DGCP.fechafin?.substring(0, 10) : '',
                estatus: solicitud.DGCP ? solicitud.DGCP.estatus : 'Agregar',
                idMap: solicitud.DGCP ? solicitud.DGCP.idMap : '',
                tabla: 'fc_01_anexos', nombreId: 'idfc01_solicitudregistro', idSolicitud: solicitud.idfc01_solicitudregistro, nameid: `DGCP`, nameDoc: 'Comprobante de pago. '
            })
        }
    }
    let [rowsPrincipal, setRowsPrincipal] = React.useState([...socio, ...principal, ...apoderadoLegal, ...personaAutorizada, ...domicilioCadena])



    const documentacionViveristaPredio = []
    const vivero = []
    let nameViveroPredio = ''
    if (solicitud?.fc_01_anexovivero?.length !== 0) {
        nameViveroPredio = 'DOCUMENTACIÓN DE VIVERISTA'
    }
    if (solicitud?.fc_01_anexovivero?.length === 0 && solicitud?.fc_01_anexoproductor?.length !== 0) {
        nameViveroPredio = 'DOCUMENTACIÓN DE PRODUCTOR MAGUEY'
    } else if (solicitud?.fc_01_anexovivero?.length !== 0 && solicitud?.fc_01_anexoproductor?.length !== 0) {
        nameViveroPredio += '/PRODUCTOR MAGUEY'
    }

    documentacionGeneral.push({ id: uuidv4(), nameDoc: nameViveroPredio })

    for (const index in solicitud.fc_01_anexovivero) {
        const { ...prop } = solicitud.fc_01_anexovivero[index]
        const arrayDocumentacion = []
        for (const i in prop.fc_01_archivosviveros) {
            const documentacion = {
                tabla: 'fc_01_archivosviveros',
                nombreId: 'idfc01_anexopredios',
                idSolicitud: prop.fc_01_archivosviveros[i].idfc01_anexopredios,
                nameid: prop.fc_01_archivosviveros[i].nameid,
            }
            const nameId = prop.fc_01_archivosviveros[i].nameid
            let nameDoc = ''
            if ((nameId).includes('COPIAESC')) nameDoc = 'Copia de escritura'
            else if ((nameId).includes('CONSPOS')) nameDoc = 'Constancia de posesión'
            else if ((nameId).includes('CONARREN')) nameDoc = 'Contrato de arrendamiento'
            else if ((nameId).includes('IOVARREN')) nameDoc = 'Identificación oficial vigente de arrendador'
            else if ((nameId).includes('IOVCOMPR')) nameDoc = 'Identificación oficial vigente de comprador'
            else if ((nameId).includes('CONCOMPR')) nameDoc = 'Contrato de compraventa'
            else if ((nameId).includes('CONCOMODA')) nameDoc = 'Contrato de comodato'
            else if ((nameId).includes('IOVCOMTE')) nameDoc = 'Identificación oficial vigente de comodante'
            else if ((nameId).includes('IOVCOMRIO')) nameDoc = 'Identificación oficial vigente de comodatario'

            arrayDocumentacion.push(documentacion)

            documentacionGeneral.push({
                id: uuidv4(),
                observaciones: prop.fc_01_archivosviveros[i].fc_01_archivosviverosmap[0] ? prop.fc_01_archivosviveros[i].fc_01_archivosviverosmap[0]?.observacion : '',
                correcto: prop.fc_01_archivosviveros[i].fc_01_archivosviverosmap[0] ? !prop.fc_01_archivosviveros[i].fc_01_archivosviverosmap[0]?.estatuscheck : false,
                incorrecto: prop.fc_01_archivosviveros[i].fc_01_archivosviverosmap[0] ? prop.fc_01_archivosviveros[i].fc_01_archivosviverosmap[0]?.estatuscheck : false,
                fechaInicio: prop.fc_01_archivosviveros[i].fechainicio !== null ? prop.fc_01_archivosviveros[i].fechainicio?.substring(0, 10) : '',
                fechaTermino: prop.fc_01_archivosviveros[i].fechafin !== null ? prop.fc_01_archivosviveros[i].fechafin?.substring(0, 10) : '',
                estatus: prop.fc_01_archivosviveros[i].estatus !== null ? prop.fc_01_archivosviveros[i].estatus : 'Agregar',
                idMap: prop.fc_01_archivosviveros[i].fc_01_archivosviverosmap[0] ? prop.fc_01_archivosviveros[i].fc_01_archivosviverosmap[0]?.idfc01_archivosviverosmap : '',
                tabla: 'fc_01_archivosviveros',
                nombreId: 'idfc01_anexopredios', idSolicitud: prop.fc_01_archivosviveros[i].idfc01_anexopredios, nameid: nameId, nameDoc: nameDoc + ' del paraje: ' + prop.nombreparaje,
                idAnexo: prop.fc_01_archivosviveros[i].idarchivosvivero
            })
        }
        let primeraLetra = prop.nombreparaje.charAt(0).toUpperCase()
        let cadena = primeraLetra + prop.nombreparaje.substring(1, prop.nombreparaje.length)
        vivero.push({
            id: uuidv4(), valor: 'VIVERO: ' + cadena, align: 'center'
        })
        vivero.push({
            id: uuidv4(), idfc01_anexopredios: prop.idfc01_anexopredios, Campo: `Domicilio`, valor: prop.calle + ';' + prop.numeroexterior + ';' + prop.codigopostal + ';' + prop.localidad
                + ';' + prop.municipio + ';' + prop.distrito + ';' + prop.estado,
            observaciones: prop.fc_01_anexoprediosmap ? prop.fc_01_anexoprediosmap[0]?.domicilio : '',
            correcto: prop.fc_01_anexoprediosmap ? !prop.fc_01_anexoprediosmap[0]?.domiciliocheck : false,
            incorrecto: prop.fc_01_anexoprediosmap ? prop.fc_01_anexoprediosmap[0]?.domiciliocheck : false,
            idMap: prop.fc_01_anexoprediosmap?.[0]?.idfc01_anexoprediosmap,
            arrayDocumentacion
        })

        // contPredio++
    }
    let [rowsVivero, setRowsVivero] = React.useState([...vivero])

    const productor = []
    for (const index in solicitud.fc_01_anexoproductor) {
        const { ...prop } = solicitud.fc_01_anexoproductor[index]
        const arrayDocumentacion = []
        for (const i in prop.fc_01_archivospredios) {
            const documentacion = {
                tabla: 'fc_01_archivospredios',
                nombreId: 'idfc01_anexoproductor',
                idSolicitud: prop.fc_01_archivospredios[i].idfc01_anexoproductor,
                nameid: prop.fc_01_archivospredios[i].nameid,
            }
            const nameId = prop.fc_01_archivospredios[i].nameid
            let nameDoc = ''
            if ((nameId).includes('COPIAESC')) nameDoc = 'Copia de escritura'
            else if ((nameId).includes('CONSPOS')) nameDoc = 'Constancia de posesión'
            else if ((nameId).includes('CONARREN')) nameDoc = 'Contrato de arrendamiento'
            else if ((nameId).includes('IOVARREN')) nameDoc = 'Identificación oficial vigente de arrendador'
            else if ((nameId).includes('IOVCOMPR')) nameDoc = 'Identificación oficial vigente de comprador'
            else if ((nameId).includes('CONCOMPR')) nameDoc = 'Contrato de compraventa'
            else if ((nameId).includes('CONCOMODA')) nameDoc = 'Contrato de comodato'
            else if ((nameId).includes('IOVCOMTE')) nameDoc = 'Identificación oficial vigente de comodante'
            else if ((nameId).includes('IOVCOMRIO')) nameDoc = 'Identificación oficial vigente de comodatario'

            arrayDocumentacion.push(documentacion)
            documentacionGeneral.push({
                id: uuidv4(),
                observaciones: prop.fc_01_archivospredios[i].fc_01_archivosprediosmap[0] ? prop.fc_01_archivospredios[i].fc_01_archivosprediosmap[0]?.observacion : '',
                correcto: prop.fc_01_archivospredios[i].fc_01_archivosprediosmap[0] ? !prop.fc_01_archivospredios[i].fc_01_archivosprediosmap[0]?.estatuscheck : false,
                incorrecto: prop.fc_01_archivospredios[i].fc_01_archivosprediosmap[0] ? prop.fc_01_archivospredios[i].fc_01_archivosprediosmap[0]?.estatuscheck : false,
                fechaInicio: prop.fc_01_archivospredios[i].fechainicio !== null ? prop.fc_01_archivospredios[i].fechainicio?.substring(0, 10) : '',
                fechaTermino: prop.fc_01_archivospredios[i].fechafin !== null ? prop.fc_01_archivospredios[i].fechafin?.substring(0, 10) : '',
                estatus: prop.fc_01_archivospredios[i].estatus !== null ? prop.fc_01_archivospredios[i].estatus : 'Agregar',
                idMap: prop.fc_01_archivospredios[i].fc_01_archivosprediosmap[0] ? prop.fc_01_archivospredios[i].fc_01_archivosprediosmap[0]?.idfc01_archivosprediosmap : '',
                tabla: 'fc_01_archivospredios',
                nombreId: 'idfc01_anexoproductor', idSolicitud: prop.fc_01_archivospredios[i].idfc01_anexoproductor, nameid: nameId, nameDoc: nameDoc + ' del paraje: ' + prop.nombreparaje,
                idAnexo: prop.fc_01_archivospredios[i].idarchivospredio
            })
        }
        let primeraLetra = prop.nombreparaje.charAt(0).toUpperCase()
        let cadena = primeraLetra + prop.nombreparaje.substring(1, prop.nombreparaje.length)
        productor.push({
            id: uuidv4(), valor: 'PREDIO: ' + cadena, align: 'center'
        })

        productor.push({
            id: uuidv4(), idfc01_anexoproductor: prop.idfc01_anexoproductor, Campo: `Domicilio`, valor: prop.localidad + ';' + prop.municipio + ';' + prop.distrito + ';' + prop.estado,
            observaciones: prop.fc_01_anexoproductormap ? prop.fc_01_anexoproductormap[0]?.domicilio : '',
            correcto: prop.fc_01_anexoproductormap ? !prop.fc_01_anexoproductormap[0]?.domiciliocheck : false,
            incorrecto: prop.fc_01_anexoproductormap ? prop.fc_01_anexoproductormap[0]?.domiciliocheck : false,
            idMap: prop.fc_01_anexoproductormap?.[0]?.idfc01_anexoproductormap,
            arrayDocumentacion
        })
    }
    let [rowsProductor, setRowsProductor] = React.useState([...productor])

    const marcaDeMezcal = []
    const documentacionMarcas = []
    if (solicitud.fc_01_anexomarcas?.length !== 0) documentacionGeneral.push({ id: uuidv4(), nameDoc: 'DOCUMENTACIÓN DE MARCAS' })
    for (const index in solicitud.fc_01_anexomarcas) {
        const { ...prop } = solicitud.fc_01_anexomarcas[index]
        const arrayDocumentacion = []
        const convenioCorresponsabilidad = []
        const contratoMaquila = []
        for (const i in prop.fc_01_anexosmarca) {

            if ((prop.fc_01_anexosmarca[i].nameid).includes('MARCAMEZCALCONVENIO')) {
                const dataArchivo = {
                    tabla: 'fc_01_anexosmarca',
                    nombreId: 'idfc01_anexomarcas',
                    idSolicitud: prop.fc_01_anexosmarca[i].idfc01_anexomarcas,
                    nameid: prop.fc_01_anexosmarca[i].nameid,
                    nameDoc: 'Convenio',
                }
                convenioCorresponsabilidad.push(dataArchivo)
                documentacionGeneral.push({
                    id: uuidv4(),
                    observaciones: prop.fc_01_anexosmarca[i].fc_01_anexosmarcamap[0] ? prop.fc_01_anexosmarca[i].fc_01_anexosmarcamap[0]?.observacion : '',
                    correcto: prop.fc_01_anexosmarca[i].fc_01_anexosmarcamap[0] ? !prop.fc_01_anexosmarca[i].fc_01_anexosmarcamap[0]?.estatuscheck : false,
                    incorrecto: prop.fc_01_anexosmarca[i].fc_01_anexosmarcamap[0] ? prop.fc_01_anexosmarca[i].fc_01_anexosmarcamap[0]?.estatuscheck : false,
                    fechaInicio: prop.fc_01_anexosmarca[i].fechainicio !== null ? prop.fc_01_anexosmarca[i].fechainicio?.substring(0, 10) : '',
                    fechaTermino: prop.fc_01_anexosmarca[i].fechafin !== null ? prop.fc_01_anexosmarca[i].fechafin?.substring(0, 10) : '',
                    estatus: prop.fc_01_anexosmarca[i].estatus !== null ? prop.fc_01_anexosmarca[i].estatus : 'Agregar',
                    idMap: prop.fc_01_anexosmarca[i].fc_01_anexosmarcamap[0] ? prop.fc_01_anexosmarca[i].fc_01_anexosmarcamap[0]?.idfc01_anexosmarcamap : '',
                    tabla: 'fc_01_anexosmarca', nombreId: 'idfc01_anexomarcas', idSolicitud: prop.fc_01_anexosmarca[i].idfc01_anexomarcas, nameid: prop.fc_01_anexosmarca[i].nameid, nameDoc: 'Convenio de corresponsabilidad autorizado por el IMPI de la marca: ' + prop.marca,
                    idAnexo: prop.fc_01_anexosmarca[i].idanexomarca
                })
            } else if ((prop.fc_01_anexosmarca[i].nameid).includes('MARCAMEZCALCONTRATO')) {
                const dataArchivo = {
                    tabla: 'fc_01_anexosmarca',
                    nombreId: 'idfc01_anexomarcas',
                    idSolicitud: prop.fc_01_anexosmarca[i].idfc01_anexomarcas,
                    nameid: prop.fc_01_anexosmarca[i].nameid,
                    nameDoc: 'Contrato',
                }
                contratoMaquila.push(dataArchivo)
                documentacionGeneral.push({
                    id: uuidv4(),
                    observaciones: prop.fc_01_anexosmarca[i].fc_01_anexosmarcamap[0] ? prop.fc_01_anexosmarca[i].fc_01_anexosmarcamap[0]?.observacion : '',
                    correcto: prop.fc_01_anexosmarca[i].fc_01_anexosmarcamap[0] ? !prop.fc_01_anexosmarca[i].fc_01_anexosmarcamap[0]?.estatuscheck : false,
                    incorrecto: prop.fc_01_anexosmarca[i].fc_01_anexosmarcamap[0] ? prop.fc_01_anexosmarca[i].fc_01_anexosmarcamap[0]?.estatuscheck : false,
                    fechaInicio: prop.fc_01_anexosmarca[i].fechainicio !== null ? prop.fc_01_anexosmarca[i].fechainicio?.substring(0, 10) : '',
                    fechaTermino: prop.fc_01_anexosmarca[i].fechafin !== null ? prop.fc_01_anexosmarca[i].fechafin?.substring(0, 10) : '',
                    estatus: prop.fc_01_anexosmarca[i].estatus !== null ? prop.fc_01_anexosmarca[i].estatus : 'Agregar',
                    idMap: prop.fc_01_anexosmarca[i].fc_01_anexosmarcamap[0] ? prop.fc_01_anexosmarca[i].fc_01_anexosmarcamap[0]?.idfc01_anexosmarcamap : '',
                    tabla: 'fc_01_anexosmarca', nombreId: 'idfc01_anexomarcas', idSolicitud: prop.fc_01_anexosmarca[i].idfc01_anexomarcas,
                    nameid: prop.fc_01_anexosmarca[i].nameid, nameDoc: 'Contrato de maquila con un envasador de la marca: ' + prop.marca,
                    idAnexo: prop.fc_01_anexosmarca[i].idanexomarca
                })
            } else {
                const documentacion = {
                    tabla: 'fc_01_anexosmarca',
                    nombreId: 'idfc01_anexomarcas',
                    idSolicitud: prop.fc_01_anexosmarca[i].idfc01_anexomarcas,
                    nameid: prop.fc_01_anexosmarca[i].nameid,
                }
                const nameId = documentacion.nameid
                let nameDoc = ''
                if ((nameId).includes('TITULO')) nameDoc = 'Título'
                else if ((nameId).includes('LICAUT')) nameDoc = 'Licencia de uso autorizada'
                else if ((nameId).includes('CESAUT')) nameDoc = 'Cesión de derechos autorizada'
                else if ((nameId).includes('LICT')) nameDoc = 'Licencia de uso en trámite'
                else if ((nameId).includes('CRLT')) nameDoc = 'Carta responsiva de licencia de uso en trámite'
                else if ((nameId).includes('CESMT')) nameDoc = 'Cesión de derechos en trámite'
                else if ((nameId).includes('CRCDMT')) nameDoc = 'Carta responsiva de cesión de derechos en trámite'
                else if ((nameId).includes('CM')) nameDoc = 'Comprobante en trámite'
                else if ((nameId).includes('CRMT')) nameDoc = 'Carta responsiva en trámite'
                else if ((nameId).includes('CRMLT')) nameDoc = 'Carta responsiva y licencia de uso en trámite'
                else if ((nameId).includes('CEST')) nameDoc = 'Comprobante de cesión de derechos en trámite'
                else if ((nameId).includes('CRMCT')) nameDoc = 'Carta responsiva y cesión de derechos en trámite'
                else if ((nameId).includes('JE')) nameDoc = 'Juego de etiquetas'


                arrayDocumentacion.push(documentacion)
                documentacionGeneral.push({
                    id: uuidv4(),
                    observaciones: prop.fc_01_anexosmarca[i].fc_01_anexosmarcamap[0] ? prop.fc_01_anexosmarca[i].fc_01_anexosmarcamap[0]?.observacion : '',
                    correcto: prop.fc_01_anexosmarca[i].fc_01_anexosmarcamap[0] ? !prop.fc_01_anexosmarca[i].fc_01_anexosmarcamap[0]?.estatuscheck : false,
                    incorrecto: prop.fc_01_anexosmarca[i].fc_01_anexosmarcamap[0] ? prop.fc_01_anexosmarca[i].fc_01_anexosmarcamap[0]?.estatuscheck : false,
                    fechaInicio: prop.fc_01_anexosmarca[i].fechainicio !== null ? prop.fc_01_anexosmarca[i].fechainicio?.substring(0, 10) : '',
                    fechaTermino: prop.fc_01_anexosmarca[i].fechafin !== null ? prop.fc_01_anexosmarca[i].fechafin?.substring(0, 10) : '',
                    estatus: prop.fc_01_anexosmarca[i].estatus !== null ? prop.fc_01_anexosmarca[i].estatus : 'Agregar',
                    idMap: prop.fc_01_anexosmarca[i].fc_01_anexosmarcamap[0] ? prop.fc_01_anexosmarca[i].fc_01_anexosmarcamap[0]?.idfc01_anexosmarcamap : '',
                    tabla: 'fc_01_anexosmarca', nombreId: 'idfc01_anexomarcas', idSolicitud: prop.fc_01_anexosmarca[i].idfc01_anexomarcas, nameid: nameId, nameDoc: nameDoc + ' de la marca: ' + prop.marca,
                    idAnexo: prop.fc_01_anexosmarca[i].idanexomarca
                })
            }
        }

        marcaDeMezcal.push({
            id: uuidv4(), idfc01_anexomarcas: prop.idfc01_anexomarcas, Campo: 'Nombre de la marca', valor: prop.marca,
            observaciones: prop.fc_01_anexomarcasmap ? prop.fc_01_anexomarcasmap[0]?.marca : '',
            correcto: prop.fc_01_anexomarcasmap ? !prop.fc_01_anexomarcasmap[0]?.marcacheck : false,
            incorrecto: prop.fc_01_anexomarcasmap ? prop.fc_01_anexomarcasmap[0]?.marcacheck : false,
            idMap: prop.fc_01_anexomarcasmap?.[0]?.idfc01_anexomarcasmap,
            arrayDocumentacion, anexoexistente: prop.anexoexistente !== null ? prop.anexoexistente : false
        })
        if (prop.registrosi) marcaDeMezcal.push({
            id: uuidv4(), idfc01_anexomarcas: prop.idfc01_anexomarcas, Campo: 'Número de registro', valor: prop.numeroderegistroimpi,
            observaciones: prop.fc_01_anexomarcasmap ? prop.fc_01_anexomarcasmap[0]?.numeroderegistroimpi : '',
            correcto: prop.fc_01_anexomarcasmap ? !prop.fc_01_anexomarcasmap[0]?.numeroderegistroimpicheck : false,
            incorrecto: prop.fc_01_anexomarcasmap ? prop.fc_01_anexomarcasmap[0]?.numeroderegistroimpicheck : false,
        })
        else marcaDeMezcal.push({
            id: uuidv4(), idfc01_anexomarcas: prop.idfc01_anexomarcas, Campo: 'Número de expediente', valor: prop.numeroderegistroimpi,
            observaciones: prop.fc_01_anexomarcasmap ? prop.fc_01_anexomarcasmap[0]?.numeroderegistroimpi : '',
            correcto: prop.fc_01_anexomarcasmap ? !prop.fc_01_anexomarcasmap[0]?.numeroderegistroimpicheck : false,
            incorrecto: prop.fc_01_anexomarcasmap ? prop.fc_01_anexomarcasmap[0]?.numeroderegistroimpicheck : false,
        })
        let tipoMarca = ''
        if (prop.idtipomarca === 1) tipoMarca = 'Mixta'
        if (prop.idtipomarca === 2) tipoMarca = 'Nominativa'
        if (prop.idtipomarca === 3) tipoMarca = 'Tridimencional'
        marcaDeMezcal.push({
            id: uuidv4(), idfc01_anexomarcas: prop.idfc01_anexomarcas, Campo: 'Tipo de la marca',
            valor: tipoMarca,
            observaciones: prop.fc_01_anexomarcasmap ? prop.fc_01_anexomarcasmap[0]?.idtipomarca : '',
            correcto: prop.fc_01_anexomarcasmap ? !prop.fc_01_anexomarcasmap[0]?.idtipomarcacheck : false,
            incorrecto: prop.fc_01_anexomarcasmap ? prop.fc_01_anexomarcasmap[0]?.idtipomarcacheck : false,
        })
        let tirularidad = ''
        if (prop.idtitularidaddemarca === 1) tirularidad = 'Marca propia'
        if (prop.idtitularidaddemarca === 2) tirularidad = 'Marca propia en tramite'
        if (prop.idtitularidaddemarca === 3) tirularidad = 'Marca de licencia de uso autorizado'
        if (prop.idtitularidaddemarca === 4) tirularidad = 'Marca cesion de derechos autorizada'
        if (prop.idtitularidaddemarca === 5) tirularidad = 'Marca de licencia de uso en tramite'
        if (prop.idtitularidaddemarca === 6) tirularidad = 'Marca cesion de derechos  en tramite'
        marcaDeMezcal.push({
            id: uuidv4(), idfc01_anexomarcas: prop.idfc01_anexomarcas, Campo: 'Titularidad de la marca', valor: tirularidad,
            observaciones: prop.fc_01_anexomarcasmap ? prop.fc_01_anexomarcasmap[0]?.idtitularidaddemarca : '',
            correcto: prop.fc_01_anexomarcasmap ? !prop.fc_01_anexomarcasmap[0]?.idtitularidaddemarcacheck : false,
            incorrecto: prop.fc_01_anexomarcasmap ? prop.fc_01_anexomarcasmap[0]?.idtitularidaddemarcacheck : false,
        })
        if (prop.productor.length > 0) marcaDeMezcal.push({
            id: uuidv4(), idfc01_anexomarcas: prop.idfc01_anexomarcas, Campo: 'Productor autorizado', valor: prop.productor,
            observaciones: prop.fc_01_anexomarcasmap ? prop.fc_01_anexomarcasmap[0]?.productor : '',
            correcto: prop.fc_01_anexomarcasmap ? !prop.fc_01_anexomarcasmap[0]?.productorcheck : false,
            incorrecto: prop.fc_01_anexomarcasmap ? prop.fc_01_anexomarcasmap[0]?.productorcheck : false,
            arrayDocumentacion: convenioCorresponsabilidad, nombreMarca: prop.marca
        })
        if (prop.maquilador.length > 0) marcaDeMezcal.push({
            id: uuidv4(), idfc01_anexomarcas: prop.idfc01_anexomarcas, Campo: 'Maquilador autorizado', valor: prop.maquilador,
            observaciones: prop.fc_01_anexomarcasmap ? prop.fc_01_anexomarcasmap[0]?.maquilador : '',
            correcto: prop.fc_01_anexomarcasmap ? !prop.fc_01_anexomarcasmap[0]?.maquiladorcheck : false,
            incorrecto: prop.fc_01_anexomarcasmap ? prop.fc_01_anexomarcasmap[0]?.maquiladorcheck : false,
            arrayDocumentacion: contratoMaquila, nombreMarca: prop.marca
        })
    }
    let [rowsMarcaDeMezcal, setRowsMarcaDeMezcal] = React.useState([...marcaDeMezcal])
    const marcaProductosConMezcal = []
    for (const index in solicitud.fc_01_anexomarcasproductoconmezcal) {
        const { ...prop } = solicitud.fc_01_anexomarcasproductoconmezcal[index]
        const arrayDocumentacion = []
        const convenioCorresponsabilidad = []
        const contratoMaquila = []
        for (const i in prop.fc_01_archivosmarcasproducto) {
            if ((prop.fc_01_archivosmarcasproducto[i].nameid).includes('MARCACONMEZCALCONVENIO')) {
                const dataArchivo = {
                    tabla: 'fc_01_archivosmarcasproducto',
                    nombreId: 'idfc01_anexomarcasproductoconmezcal',
                    idSolicitud: prop.fc_01_archivosmarcasproducto[i].idfc01_anexomarcasproductoconmezcal,
                    nameid: prop.fc_01_archivosmarcasproducto[i].nameid,
                    nameDoc: 'Convenio',
                }
                convenioCorresponsabilidad.push(dataArchivo)
                documentacionGeneral.push({
                    id: uuidv4(),
                    observaciones: prop.fc_01_archivosmarcasproducto[i].fc_01_archivosmarcasproductomap[0] ? prop.fc_01_archivosmarcasproducto[i].fc_01_archivosmarcasproductomap[0]?.observacion : '',
                    correcto: prop.fc_01_archivosmarcasproducto[i].fc_01_archivosmarcasproductomap[0] ? !prop.fc_01_archivosmarcasproducto[i].fc_01_archivosmarcasproductomap[0]?.estatuscheck : false,
                    incorrecto: prop.fc_01_archivosmarcasproducto[i].fc_01_archivosmarcasproductomap[0] ? prop.fc_01_archivosmarcasproducto[i].fc_01_archivosmarcasproductomap[0]?.estatuscheck : false,
                    fechaInicio: prop.fc_01_archivosmarcasproducto[i].fechainicio !== null ? prop.fc_01_archivosmarcasproducto[i].fechainicio?.substring(0, 10) : '',
                    fechaTermino: prop.fc_01_archivosmarcasproducto[i].fechafin !== null ? prop.fc_01_archivosmarcasproducto[i].fechafin?.substring(0, 10) : '',
                    estatus: prop.fc_01_archivosmarcasproducto[i].estatus !== null ? prop.fc_01_archivosmarcasproducto[i].estatus : 'Agregar',
                    idMap: prop.fc_01_archivosmarcasproducto[i].fc_01_archivosmarcasproductomap[0] ? prop.fc_01_archivosmarcasproducto[i].fc_01_archivosmarcasproductomap[0]?.idfc01_archivosmarcasproductomap : '',
                    tabla: 'fc_01_archivosmarcasproducto', nombreId: 'idfc01_anexomarcasproductoconmezcal', idSolicitud: prop.fc_01_archivosmarcasproducto[i].idfc01_anexomarcasproductoconmezcal,
                    nameid: prop.fc_01_archivosmarcasproducto[i].nameid, nameDoc: 'Convenio de corresponsabilidad autorizado por el IMPI de la marca: ' + prop.marca,
                    idAnexo: prop.fc_01_archivosmarcasproducto[i].idarchivosmarcaproducto
                })
            } else if ((prop.fc_01_archivosmarcasproducto[i].nameid).includes('MARCACONMEZCALCONTRATO')) {
                const dataArchivo = {
                    tabla: 'fc_01_archivosmarcasproducto',
                    nombreId: 'idfc01_anexomarcasproductoconmezcal',
                    idSolicitud: prop.fc_01_archivosmarcasproducto[i].idfc01_anexomarcasproductoconmezcal,
                    nameid: prop.fc_01_archivosmarcasproducto[i].nameid,
                    nameDoc: 'Contrato',
                }
                contratoMaquila.push(dataArchivo)
                documentacionGeneral.push({
                    id: uuidv4(),
                    observaciones: prop.fc_01_archivosmarcasproducto[i].fc_01_archivosmarcasproductomap[0] ? prop.fc_01_archivosmarcasproducto[i].fc_01_archivosmarcasproductomap[0]?.observacion : '',
                    correcto: prop.fc_01_archivosmarcasproducto[i].fc_01_archivosmarcasproductomap[0] ? !prop.fc_01_archivosmarcasproducto[i].fc_01_archivosmarcasproductomap[0]?.estatuscheck : false,
                    incorrecto: prop.fc_01_archivosmarcasproducto[i].fc_01_archivosmarcasproductomap[0] ? prop.fc_01_archivosmarcasproducto[i].fc_01_archivosmarcasproductomap[0]?.estatuscheck : false,
                    fechaInicio: prop.fc_01_archivosmarcasproducto[i].fechainicio !== null ? prop.fc_01_archivosmarcasproducto[i].fechainicio?.substring(0, 10) : '',
                    fechaTermino: prop.fc_01_archivosmarcasproducto[i].fechafin !== null ? prop.fc_01_archivosmarcasproducto[i].fechafin?.substring(0, 10) : '',
                    estatus: prop.fc_01_archivosmarcasproducto[i].estatus !== null ? prop.fc_01_archivosmarcasproducto[i].estatus : 'Agregar',
                    idMap: prop.fc_01_archivosmarcasproducto[i].fc_01_archivosmarcasproductomap[0] ? prop.fc_01_archivosmarcasproducto[i].fc_01_archivosmarcasproductomap[0]?.idfc01_archivosmarcasproductomap : '',
                    tabla: 'fc_01_archivosmarcasproducto',
                    nombreId: 'idfc01_anexomarcasproductoconmezcal', idSolicitud: prop.fc_01_archivosmarcasproducto[i].idfc01_anexomarcasproductoconmezcal, nameid: prop.fc_01_archivosmarcasproducto[i].nameid,
                    nameDoc: 'Contrato de maquila con un envasador de la marca: ' + prop.marca,
                    idAnexo: prop.fc_01_archivosmarcasproducto[i].idarchivosmarcaproducto
                })
            } else {
                const documentacion = {
                    tabla: 'fc_01_archivosmarcasproducto',
                    nombreId: 'idfc01_anexomarcasproductoconmezcal',
                    idSolicitud: prop.fc_01_archivosmarcasproducto[i].idfc01_anexomarcasproductoconmezcal,
                    nameid: prop.fc_01_archivosmarcasproducto[i].nameid,
                }
                const nameId = prop.fc_01_archivosmarcasproducto[i].nameid
                let nameDoc = ''
                if ((nameId).includes('TITULO')) nameDoc = 'Título'
                else if ((nameId).includes('LICAUT')) nameDoc = 'Licencia de uso autorizada'
                else if ((nameId).includes('CESAUT')) nameDoc = 'Cesión de derechos autorizada'
                else if ((nameId).includes('LICT')) nameDoc = 'Licencia de uso en trámite'
                else if ((nameId).includes('CRLT')) nameDoc = 'Carta responsiva de licencia de uso en trámite'
                else if ((nameId).includes('CESMT')) nameDoc = 'Cesión de derechos en trámite'
                else if ((nameId).includes('CRCDMT')) nameDoc = 'Carta responsiva de cesión de derechos en trámite'
                else if ((nameId).includes('CM')) nameDoc = 'Comprobante en trámite'
                else if ((nameId).includes('CRMT')) nameDoc = 'Carta responsiva en trámite'
                else if ((nameId).includes('CRMLT')) nameDoc = 'Carta responsiva y licencia de uso en trámite'
                else if ((nameId).includes('CEST')) nameDoc = 'Comprobante de cesión de derechos en trámite'
                else if ((nameId).includes('CRMCT')) nameDoc = 'Carta responsiva y cesión de derechos en trámite'
                else if ((nameId).includes('JE')) nameDoc = 'Juego de etiquetas'

                arrayDocumentacion.push(documentacion)
                documentacionGeneral.push({
                    id: uuidv4(),
                    observaciones: prop.fc_01_archivosmarcasproducto[i].fc_01_archivosmarcasproductomap[0] ? prop.fc_01_archivosmarcasproducto[i].fc_01_archivosmarcasproductomap[0]?.observacion : '',
                    correcto: prop.fc_01_archivosmarcasproducto[i].fc_01_archivosmarcasproductomap[0] ? !prop.fc_01_archivosmarcasproducto[i].fc_01_archivosmarcasproductomap[0]?.estatuscheck : false,
                    incorrecto: prop.fc_01_archivosmarcasproducto[i].fc_01_archivosmarcasproductomap[0] ? prop.fc_01_archivosmarcasproducto[i].fc_01_archivosmarcasproductomap[0]?.estatuscheck : false,
                    fechaInicio: prop.fc_01_archivosmarcasproducto[i].fechainicio !== null ? prop.fc_01_archivosmarcasproducto[i].fechainicio?.substring(0, 10) : '',
                    fechaTermino: prop.fc_01_archivosmarcasproducto[i].fechafin !== null ? prop.fc_01_archivosmarcasproducto[i].fechafin?.substring(0, 10) : '',
                    estatus: prop.fc_01_archivosmarcasproducto[i].estatus !== null ? prop.fc_01_archivosmarcasproducto[i].estatus : 'Agregar',
                    idMap: prop.fc_01_archivosmarcasproducto[i].fc_01_archivosmarcasproductomap[0] ? prop.fc_01_archivosmarcasproducto[i].fc_01_archivosmarcasproductomap[0]?.idfc01_archivosmarcasproductomap : '',
                    tabla: 'fc_01_archivosmarcasproducto',
                    nombreId: 'idfc01_anexomarcasproductoconmezcal', idSolicitud: prop.fc_01_archivosmarcasproducto[i].idfc01_anexomarcasproductoconmezcal, nameid: nameId, nameDoc: nameDoc + ' de la marca: ' + prop.marca,
                    idAnexo: prop.fc_01_archivosmarcasproducto[i].idarchivosmarcaproducto
                })
            }
        }

        marcaProductosConMezcal.push({
            id: uuidv4(), idfc01_anexomarcasproductoconmezcal: prop.idfc01_anexomarcasproductoconmezcal, Campo: 'Nombre de la marca', valor: prop.marca, arrayDocumentacion,
            observaciones: prop.fc_01_anexomarcasproductoconmezcalmap ? prop.fc_01_anexomarcasproductoconmezcalmap[0]?.marca : '',
            correcto: prop.fc_01_anexomarcasproductoconmezcalmap ? !prop.fc_01_anexomarcasproductoconmezcalmap[0]?.marcacheck : false,
            incorrecto: prop.fc_01_anexomarcasproductoconmezcalmap ? prop.fc_01_anexomarcasproductoconmezcalmap[0]?.marcacheck : false,
            idMap: prop.fc_01_anexomarcasproductoconmezcalmap?.[0]?.idfc01_anexomarcasproductoconmezcalmap,
            fechaInicio: '', fechaTermino: '', anexoexistente: prop.anexoexistente !== null ? prop.anexoexistente : false
        })
        if (prop.registrosi) marcaProductosConMezcal.push({
            id: uuidv4(), idfc01_anexomarcasproductoconmezcal: prop.idfc01_anexomarcasproductoconmezcal, Campo: 'Número de registro', valor: prop.numeroderegistroimpi,
            observaciones: prop.fc_01_anexomarcasproductoconmezcalmap ? prop.fc_01_anexomarcasproductoconmezcalmap[0]?.numeroderegistroimpi : '',
            correcto: prop.fc_01_anexomarcasproductoconmezcalmap ? !prop.fc_01_anexomarcasproductoconmezcalmap[0]?.numeroderegistroimpicheck : false,
            incorrecto: prop.fc_01_anexomarcasproductoconmezcalmap ? prop.fc_01_anexomarcasproductoconmezcalmap[0]?.numeroderegistroimpicheck : false,
        })
        else marcaProductosConMezcal.push({
            id: uuidv4(), idfc01_anexomarcasproductoconmezcal: prop.idfc01_anexomarcasproductoconmezcal, Campo: 'Número de expediente', valor: prop.numeroderegistroimpi,
            observaciones: prop.fc_01_anexomarcasproductoconmezcalmap ? prop.fc_01_anexomarcasproductoconmezcalmap[0]?.numeroderegistroimpi : '',
            correcto: prop.fc_01_anexomarcasproductoconmezcalmap ? !prop.fc_01_anexomarcasproductoconmezcalmap[0]?.numeroderegistroimpicheck : false,
            incorrecto: prop.fc_01_anexomarcasproductoconmezcalmap ? prop.fc_01_anexomarcasproductoconmezcalmap[0]?.numeroderegistroimpicheck : false,
        })
        let tipoMarca = ''
        if (prop.idtipomarca === 1) tipoMarca = 'Mixta'
        if (prop.idtipomarca === 2) tipoMarca = 'Nominativa'
        if (prop.idtipomarca === 3) tipoMarca = 'Tridimencional'
        marcaProductosConMezcal.push({
            id: uuidv4(), idfc01_anexomarcasproductoconmezcal: prop.idfc01_anexomarcasproductoconmezcal, Campo: 'Tipo de la marca', valor: tipoMarca,
            observaciones: prop.fc_01_anexomarcasproductoconmezcalmap ? prop.fc_01_anexomarcasproductoconmezcalmap[0]?.idtipomarca : '',
            correcto: prop.fc_01_anexomarcasproductoconmezcalmap ? !prop.fc_01_anexomarcasproductoconmezcalmap[0]?.idtipomarcacheck : false,
            incorrecto: prop.fc_01_anexomarcasproductoconmezcalmap ? prop.fc_01_anexomarcasproductoconmezcalmap[0]?.idtipomarcacheck : false,
        })
        let tirularidad = ''
        if (prop.idtitularidaddemarca === 1) tirularidad = 'Marca propia'
        if (prop.idtitularidaddemarca === 2) tirularidad = 'Marca propia en tramite'
        if (prop.idtitularidaddemarca === 3) tirularidad = 'Marca de licencia de uso autorizado'
        if (prop.idtitularidaddemarca === 4) tirularidad = 'Marca cesion de derechos autorizada'
        if (prop.idtitularidaddemarca === 5) tirularidad = 'Marca de licencia de uso en tramite'
        if (prop.idtitularidaddemarca === 6) tirularidad = 'Marca cesion de derechos en tramite'
        marcaProductosConMezcal.push({
            id: uuidv4(), idfc01_anexomarcasproductoconmezcal: prop.idfc01_anexomarcasproductoconmezcal, Campo: 'Titularidad de la marca', valor: tirularidad,
            observaciones: prop.fc_01_anexomarcasproductoconmezcalmap ? prop.fc_01_anexomarcasproductoconmezcalmap[0]?.idtitularidaddemarca : '',
            correcto: prop.fc_01_anexomarcasproductoconmezcalmap ? !prop.fc_01_anexomarcasproductoconmezcalmap[0]?.idtitularidaddemarcacheck : false,
            incorrecto: prop.fc_01_anexomarcasproductoconmezcalmap ? prop.fc_01_anexomarcasproductoconmezcalmap[0]?.idtitularidaddemarcacheck : false,
        })
        if (prop.productor.length > 0) marcaProductosConMezcal.push({
            id: uuidv4(), idfc01_anexomarcasproductoconmezcal: prop.idfc01_anexomarcasproductoconmezcal, Campo: 'Productor autorizado', valor: prop.productor,
            observaciones: prop.fc_01_anexomarcasproductoconmezcalmap ? prop.fc_01_anexomarcasproductoconmezcalmap[0]?.productor : '',
            correcto: prop.fc_01_anexomarcasproductoconmezcalmap ? !prop.fc_01_anexomarcasproductoconmezcalmap[0]?.productorcheck : false,
            incorrecto: prop.fc_01_anexomarcasproductoconmezcalmap ? prop.fc_01_anexomarcasproductoconmezcalmap[0]?.productorcheck : false,
            arrayDocumentacion: convenioCorresponsabilidad, nombreMarca: prop.marca
        })
        if (prop.maquilador.length > 0) marcaProductosConMezcal.push({
            id: uuidv4(), idfc01_anexomarcasproductoconmezcal: prop.idfc01_anexomarcasproductoconmezcal, Campo: 'Maquilador autorizado', valor: prop.maquilador,
            observaciones: prop.fc_01_anexomarcasproductoconmezcalmap ? prop.fc_01_anexomarcasproductoconmezcalmap[0]?.maquilador : '',
            correcto: prop.fc_01_anexomarcasproductoconmezcalmap ? !prop.fc_01_anexomarcasproductoconmezcalmap[0]?.maquiladorcheck : false,
            incorrecto: prop.fc_01_anexomarcasproductoconmezcalmap ? prop.fc_01_anexomarcasproductoconmezcalmap[0]?.maquiladorcheck : false,
            arrayDocumentacion: contratoMaquila, nombreMarca: prop.marca
        })
    }
    let [rowsMarcaProductosConMezcal, setRowsMarcaProductosConMezcal] = React.useState([...marcaProductosConMezcal])

    const anexos = []
    const documentacionInstalaciones = []
    if (solicitud.anexo?.length !== 0) documentacionGeneral.push({ id: uuidv4(), nameDoc: 'DOCUMENTACIÓN DE INSTALACIONES' })
    for (const index in solicitud.anexo) {
        const { ...prop } = solicitud.anexo[index]
        anexos.push({
            id: uuidv4(), valor: (prop.tipoanexo.descripcion + ', alias: ' + prop.informaciongeneral.alias).toUpperCase(), align: 'center'
        })
        documentacionGeneral.push({ id: uuidv4(), nameDoc: (prop.tipoanexo.descripcion + ', alias: ' + prop.informaciongeneral.alias).toUpperCase() })
        const arrayDocumentacion = []
        for (const i in prop.fc_01_archivosinstalaciones) {
            const documentacion = {
                tabla: 'fc_01_archivosinstalaciones',
                nombreId: 'idanexo',
                idSolicitud: prop.fc_01_archivosinstalaciones[i].idanexo,
                nameid: prop.fc_01_archivosinstalaciones[i].nameid,
            }
            const nameId = prop.fc_01_archivosinstalaciones[i].nameid
            let nameDoc = ''
            if ((nameId).includes('TITULOINS')) nameDoc = 'Copia del título de propiedad a nombre del solicitante'
            else if ((nameId).includes('CAINS')) nameDoc = 'Contrato de arrendamiento'
            else if ((nameId).includes('IOVRINS')) nameDoc = 'Identificación oficial vigente Arrendador'
            else if ((nameId).includes('IOVOINS')) nameDoc = 'Identificación oficial vigente Arrendatario'
            else if ((nameId).includes('CCINS')) nameDoc = 'Contrato comodato'
            else if ((nameId).includes('IOVEINS')) nameDoc = 'Identificación oficial vigente del comodante'

            arrayDocumentacion.push(documentacion)
            let unidad = ''
            if (prop.tipoanexo.descripcion == 'Unidad de produccion') unidad = 'Unidad de producción'
            if (prop.tipoanexo.descripcion == 'Unidad de envasado') unidad = 'Unidad de envasado'
            if (prop.tipoanexo.descripcion == 'Unidad de almacen') unidad = 'Unidad de almacén'
            documentacionGeneral.push({
                id: uuidv4(),
                observaciones: prop.fc_01_archivosinstalaciones[i].fc_01_archivosinstalacionesmap[0] ? prop.fc_01_archivosinstalaciones[i].fc_01_archivosinstalacionesmap[0]?.observacion : '',
                correcto: prop.fc_01_archivosinstalaciones[i].fc_01_archivosinstalacionesmap[0] ? !prop.fc_01_archivosinstalaciones[i].fc_01_archivosinstalacionesmap[0]?.estatuscheck : false,
                incorrecto: prop.fc_01_archivosinstalaciones[i].fc_01_archivosinstalacionesmap[0] ? prop.fc_01_archivosinstalaciones[i].fc_01_archivosinstalacionesmap[0]?.estatuscheck : false,
                fechaInicio: prop.fc_01_archivosinstalaciones[i].fechainicio !== null ? prop.fc_01_archivosinstalaciones[i].fechainicio?.substring(0, 10) : '',
                fechaTermino: prop.fc_01_archivosinstalaciones[i].fechafin !== null ? prop.fc_01_archivosinstalaciones[i].fechafin?.substring(0, 10) : '',
                estatus: prop.fc_01_archivosinstalaciones[i].estatus !== null ? prop.fc_01_archivosinstalaciones[i].estatus : 'Agregar',
                idMap: prop.fc_01_archivosinstalaciones[i].fc_01_archivosinstalacionesmap[0] ? prop.fc_01_archivosinstalaciones[i].fc_01_archivosinstalacionesmap[0]?.idfc01_archivosinstalacionesmap : '',
                tabla: 'fc_01_archivosinstalaciones',
                nombreId: 'idanexo', idSolicitud: prop.fc_01_archivosinstalaciones[i].idanexo, nameid: nameId, nameDoc: nameDoc + ' de la instalación ' + unidad + ' : ' + prop.informaciongeneral.alias,
                idAnexo: prop.fc_01_archivosinstalaciones[i].idarchivosinstalacion
            })
        }
        let calleInstalacion = prop.informaciongeneral.calle
        if (prop.informaciongeneral.calle === 'Otro') calleInstalacion = prop.informaciongeneral.otracalle

        anexos.push({
            id: uuidv4(), idiformaciongeneral: prop.informaciongeneral.idiformaciongeneral, Campo: 'Domicilio de instalación', valor: calleInstalacion + ';' +
                prop.informaciongeneral.numerointerior + ';' + prop.informaciongeneral.numeroexterior + ';' + prop.informaciongeneral.colonia
                + ';' + prop.informaciongeneral.codigopostal + ';' + prop.informaciongeneral.localidad + ';' + prop.informaciongeneral.municipio
                + ';' + prop.informaciongeneral.estado,
            observaciones: prop.informaciongeneral.informaciongeneralmap ? prop.informaciongeneral.informaciongeneralmap[0]?.domicilio : '',
            correcto: prop.informaciongeneral.informaciongeneralmap ? !prop.informaciongeneral.informaciongeneralmap[0]?.domiciliocheck : false,
            incorrecto: prop.informaciongeneral.informaciongeneralmap ? prop.informaciongeneral.informaciongeneralmap[0]?.domiciliocheck : false,
            idMap: prop.informaciongeneral.informaciongeneralmap?.[0]?.idiformaciongeneralmap,
            estatusDomicilio: prop.informaciongeneral.domiciliodenominacionorigen,
            arrayDocumentacion, anexoexistente: prop.informaciongeneral.anexoexistente !== null ? prop.informaciongeneral.anexoexistente : false
        })
        for (const dato of prop.informaciongeneral.responsablesdeinstalacion) {
            const arrayDocument = []

            for (const i in dato.fc_01_archivosresposansables) {
                const documentacion = {
                    tabla: 'fc_01_archivosresposansables',
                    nombreId: 'idresponsabledeinstalacion',
                    idSolicitud: dato.fc_01_archivosresposansables[i].idresponsabledeinstalacion,
                    nameid: dato.fc_01_archivosresposansables[i].nameid,
                }
                if ((documentacion.nameid).includes('INSTREP')) documentacion.nameDoc = 'INE'

                arrayDocument.push(documentacion)
                documentacionGeneral.push({
                    id: uuidv4(),
                    observaciones: dato.fc_01_archivosresposansables[i].fc_01_archivosresposansablesmap[0] ? dato.fc_01_archivosresposansables[i].fc_01_archivosresposansablesmap[0]?.observacion : '',
                    correcto: dato.fc_01_archivosresposansables[i].fc_01_archivosresposansablesmap[0] ? !dato.fc_01_archivosresposansables[i].fc_01_archivosresposansablesmap[0]?.estatuscheck : false,
                    incorrecto: dato.fc_01_archivosresposansables[i].fc_01_archivosresposansablesmap[0] ? dato.fc_01_archivosresposansables[i].fc_01_archivosresposansablesmap[0]?.estatuscheck : false,
                    fechaInicio: dato.fc_01_archivosresposansables[i].fechainicio !== null ? dato.fc_01_archivosresposansables[i].fechainicio?.substring(0, 10) : '',
                    fechaTermino: dato.fc_01_archivosresposansables[i].fechafin !== null ? dato.fc_01_archivosresposansables[i].fechafin?.substring(0, 10) : '',
                    estatus: dato.fc_01_archivosresposansables[i].estatus !== null ? dato.fc_01_archivosresposansables[i].estatus : 'Agregar',
                    idMap: dato.fc_01_archivosresposansables[i].fc_01_archivosresposansablesmap[0] ? dato.fc_01_archivosresposansables[i].fc_01_archivosresposansablesmap[0]?.idfc01_archivosresposansablesmap : '',
                    tabla: 'fc_01_archivosresposansables', nombreId: 'idresponsabledeinstalacion', idSolicitud: dato.fc_01_archivosresposansables[i].idresponsabledeinstalacion,
                    nameid: dato.fc_01_archivosresposansables[i].nameid, nameDoc: 'Identificación oficial vigente del responsable: ' + dato.nombreresponsable,
                    idAnexo: dato.fc_01_archivosresposansables[i].idarchivosresponsables
                })
            }
            anexos.push({
                id: uuidv4(), idresponsabledeinstalacion: dato.idresponsabledeinstalacion, Campo: 'Nombre del responsable', valor: dato.nombreresponsable,
                observaciones: dato.responsablesdeinstalacionmap ? dato.responsablesdeinstalacionmap[0]?.nombreresponsable : '',
                correcto: dato.responsablesdeinstalacionmap ? !dato.responsablesdeinstalacionmap[0]?.nombreresponsablecheck : false,
                incorrecto: dato.responsablesdeinstalacionmap ? dato.responsablesdeinstalacionmap[0]?.nombreresponsablecheck : false,
                idMap: dato.responsablesdeinstalacionmap?.[0]?.idresponsabledeinstalacionmap,
                arrayDocumentacion: arrayDocument
            })
        }
    }
    let [rowsAnexos, setRowsAnexos] = React.useState([...anexos])

    const [rowDocumentacion, setRowDocumentacion] = React.useState([...documentacionGeneral])
    const columns = [
        { field: 'Campo', headerName: 'Campo', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 250, sortable: false },
        {
            field: 'valor', headerName: 'Valor', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 680, sortable: false, editable: false,
            renderCell: (params) =>
            (
                <Fragment>
                    {
                        params.row.Campo === 'Cadena Productiva' ?
                            <div>
                                <Tooltip title={`${params.row.valor}`} arrow>
                                    <label>{`${params.row.valor} `}</label>
                                </Tooltip>
                            </div>
                            :
                            params.row.estatusDomicilio === false ?
                                <div className='col-md-12'>
                                    <label className={`${estilos.domicilioFueraDenominacion}`}>{`${params.row.valor}`}</label>
                                </div>
                                :
                                params.row.Campo ?
                                    <div>
                                        <label>{`${params.row.valor}`}</label>
                                    </div>
                                    :
                                    <div className='col-md-12'>
                                        <label className={`${estilos.divisionDocumentacion}`}>{`${params.row.valor}`}</label>
                                    </div>
                    }
                </Fragment>
            )
        },
        {
            field: 'accion', headerName: 'Acción', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 220, sortable: false,

            renderCell: (params) =>
            (
                <Fragment>
                    {
                        params.row.Campo !== undefined &&
                        <>
                            {params.row.Campo === 'Domicilio de instalación' || params.row.Campo === 'Nombre de la marca' ? <>
                                <button className={params.row.correcto ? ('btn btn-success ms-2') : ('btn btn-outline-success ms-2')} onClick={() => handleOpenModalCorrecto(params)}>✓</button>
                                <button className={params.row.incorrecto ? ('btn btn-danger ms-3') : ('btn btn-outline-danger ms-3')} onClick={() => handleOpenModalIncorrecto(params)}>X</button>
                                <button className={params.row.anexoexistente ? ('btn btn-warning ms-3') : ('btn btn-outline-warning ms-3')} onClick={() => botonAsignacion(params)}>{params.row.anexoexistente ? 'Registrada' : 'Nueva'}</button>
                            </> :
                                params.row.Campo === 'Productor autorizado' || params.row.Campo === 'Maquilador autorizado' ?
                                    <>
                                        <button className={params.row.correcto ? ('btn btn-success ms-2') : ('btn btn-outline-success ms-2')} onClick={() => handleOpenModalCorrecto(params)}>✓</button>
                                        <button className={params.row.incorrecto ? ('btn btn-danger ms-3') : ('btn btn-outline-danger ms-3')} onClick={() => handleOpenModalIncorrecto(params)}>X</button>
                                        <button className={'btn btn-outline-warning ms-3'} onClick={() => handleOpenModalRelacion(params)}>Registrar</button>
                                    </>
                                    :
                                    <>
                                        <button className={params.row.correcto ? ('btn btn-success ms-5') : ('btn btn-outline-success ms-5')} onClick={() => handleOpenModalCorrecto(params)}>✓</button>
                                        <button className={params.row.incorrecto ? ('btn btn-danger ms-3') : ('btn btn-outline-danger ms-3')} onClick={() => handleOpenModalIncorrecto(params)}>X</button>
                                    </>}
                        </>

                    }
                </Fragment >
            )
        },
    ]
    const columnsRelacion = [
        { field: 'numero', headerName: 'numero Socio', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 100, sortable: false },
        { field: 'tipo', headerName: 'Tipo Relacion', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 100, sortable: false, editable: false, },
        { field: 'marca', headerName: 'Marca', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 70, sortable: false, },
    ]


    const botonAsignacion = (params) => {
        if (params.row.Campo === 'Domicilio de instalación') {
            for (const cambio of rowsAnexos) {
                if (cambio.id === params.row.id) {
                    if (cambio.anexoexistente === true) {
                        cambio.anexoexistente = false
                    } else {
                        cambio.anexoexistente = true
                    }
                }
            }
        }
        if (params.row.Campo === 'Nombre de la marca') {
            for (const cambio of rowsMarcaDeMezcal) {
                if (cambio.id === params.row.id) {
                    if (cambio.anexoexistente === true) {
                        cambio.anexoexistente = false
                    } else {
                        cambio.anexoexistente = true
                    }
                }
            }
            for (const cambio of rowsMarcaProductosConMezcal) {
                if (cambio.id === params.row.id) {
                    if (cambio.anexoexistente === true) {
                        cambio.anexoexistente = false
                    } else {
                        cambio.anexoexistente = true
                    }
                }
            }
        }
    }

    const columnsDocumentacion = [
        {
            field: 'nameDoc', headerName: 'Documentacion', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 850, sortable: false,
            renderCell: (params) =>
            (
                <Fragment>
                    {
                        params.row.tabla ?
                            <div>
                                <label>{`${params.row.nameDoc}`}</label>
                            </div>
                            :
                            <div className='col-md-12'>
                                <label className={`${estilos.divisionDocumentacion}`}>{`${params.row.nameDoc}`}</label>
                            </div>
                    }
                </Fragment>
            )
        },
        {
            field: 'archivo', headerName: 'Archivo', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 120, sortable: false,

            renderCell: (params) =>
            (
                <Fragment>
                    {
                        params.row.tabla &&
                        <BotonVerArchivoComponent tabla={params.row?.tabla} nombreId={params.row?.nombreId} idSolicitud={params.row?.idSolicitud} nameid={params.row?.nameid} />
                    }
                </Fragment>
            )
        },
        {
            field: 'accion', headerName: 'Acción', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 150, sortable: false,

            renderCell: (params) =>
            (
                <Fragment>
                    {
                        params.row.tabla &&
                        <>
                            <button className={params.row.correcto ? ('btn btn-success') : ('btn btn-outline-success')} onClick={() => handleOpenModalCorrecto(params)}>✓</button>
                            <button className={params.row.incorrecto ? ('btn btn-danger ms-3') : ('btn btn-outline-danger ms-3')} onClick={() => handleOpenModalIncorrecto(params)}>X</button>
                        </>
                    }
                </Fragment>
            )
        },
    ]
    const [vigencia, setVigencia] = React.useState(false);
    const botonVigencia = () => {
        setVigencia(true)
    }
    const botonCerrarVigencia = () => {
        obtenerVigencia()
        setVigencia(false)
    }

    const [openModalIncorrecto, setOpenModalIncorrecto] = React.useState(false);
    const handleOpenModalIncorrecto = (params) => {
        setId(params.row.id)
        setIncorrecto(true)
        setCorrecto(false)
        setCampo(params.row.Campo)
        setValor(params.row.valor)
        setObservaciones(params.row.observaciones)
        setOpenModalIncorrecto(true)
    }
    const handleCloseModalIncorrecto = () => {
        setOpenModalIncorrecto(false)

    }
    const modalComponentIncorrecto = () => {
        return (
            <div>
                <Modal
                    open={openModalIncorrecto}
                    onClose={handleCloseModalIncorrecto}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    hideBackdrop={true}
                >
                    <Box sx={styleIncorrecto}>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 0 }} className='text-center'>
                            <label className='text-center'>Observaciones</label>
                            <textarea className="form-control" id="exampleFormControlTextarea1" rows="3"
                                value={observaciones} onChange={e => setObservaciones(e.target.value)} disabled={modoVerDetalle}></textarea>
                        </Typography>
                        <br />
                        {modoVerDetalle ?
                            <div className='row'>
                                <div className={` text-center`}>
                                    <button className='btn btn-outline-danger' onClick={() => { handleCloseModalIncorrecto() }}>CERRAR</button>
                                </div>
                            </div>
                            :
                            <div className='row'>
                                <div className='col-md-2'>
                                    <button className='btn btn-outline-success' onClick={() => { botonGuardar() }}>GUARDAR</button>
                                </div>
                                <div className={`${estilos.botonCancelarModal} col-md-2`}>
                                    <button className='btn btn-outline-danger' onClick={() => { handleCloseModalIncorrecto() }}>CANCELAR</button>
                                </div>
                            </div>
                        }
                    </Box>
                </Modal>
            </div>
        )
    }
    const [campo, setCampo] = React.useState('')
    const [valor, setValor] = React.useState('')
    const [observaciones, setObservaciones] = React.useState('')
    const [correcto, setCorrecto] = React.useState('')
    const [incorrecto, setIncorrecto] = React.useState('')
    const [id, setId] = React.useState('')
    const [rowSeleccionada, setRowSeleccionada] = React.useState(false)
    const [openModalCorrecto, setOpenModalCorrecto] = React.useState(false);
    const [documentacion, setDocumentacion] = React.useState('')
    const [estadoVigencia, setEstadoVigencia] = React.useState('')
    const [fechaInicio, setFechaInicio] = React.useState('')
    const [fechaTermino, setFechaTermino] = React.useState('')

    const handleOpenModalCorrecto = (params) => {

        setDocumentacion(params.row.documentacion)
        setId(params.row.id)
        setCorrecto(true)
        setIncorrecto(false)
        setCampo(params.row.Campo)
        setObservaciones(params.row.observaciones)
        setOpenModalCorrecto(true)
        setValor(params.row.valor)
        setFechaInicio((params.row.fechaInicio !== null && params.row.fechaInicio !== '') ? (params.row.fechaInicio) : '')
        setFechaTermino((params.row.fechaTermino !== null && params.row.fechaTermino !== '') ? (params.row.fechaTermino) : '')
        setEstadoVigencia((params.row.estatus !== null && params.row.estatus !== undefined) ? params.row.estatus : 'Agregar')
        if (params.row.tabla) {
            setRowSeleccionada(true)
            setValor(params.row.nameDoc)
        }
        // if (params.row.arrayDocumentacion) setRowSeleccionada({ arrayDocumentacion: params.row.arrayDocumentacion })
    }

    const handleCloseModalCorrecto = () => {
        setFechaInicio('')
        setFechaTermino('')
        setEstadoVigencia('')
        setOpenModalCorrecto(false)
        setVigencia(false)
        setRowSeleccionada(false)
        setNumeroSocioCliente()
        setNombreRazon('')
        setExitoBusqueda(false)
        setFailedBusqueda(false)
    }
    const modalComponentCorrecto = () => {
        return (
            <div>
                <Modal
                    open={openModalCorrecto}
                    onClose={handleCloseModalCorrecto}
                    hideBackdrop={true}

                >
                    <Box sx={styleCorrecto}>
                        <Typography id="modal-modal-description" component="h2" sx={{ color: 'black' }}>
                            {campo == 'Tipo de inscripción' ?
                                <div className="row">
                                    <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 text-center'>
                                        <input className={`form-check-input me-1 escalar `}
                                            type="checkbox"
                                            onChange={e => setasociado(e.target.checked)}
                                            checked={asociado} id="asociado"
                                            name="asociado"
                                        />
                                        <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                            Asociado
                                        </label>
                                    </div>
                                    <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 text-center'>
                                        <input className={`form-check-input me-1 escalar `}
                                            type="checkbox"
                                            onChange={e => setnoasociado(e.target.checked)}
                                            checked={noasociado} id="noasociado"
                                            name="noasociado"
                                        />
                                        <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                            No asociado
                                        </label>
                                    </div>
                                    <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 text-center'>
                                        <input className={`form-check-input me-1 escalar `}
                                            type="checkbox"
                                            onChange={e => setinscrito(e.target.checked)}
                                            checked={inscrito} id="inscrito"
                                            name="inscrito"
                                        />
                                        <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                            Inscrito
                                        </label>
                                    </div>
                                    {
                                        inscrito &&
                                        <div className="form-floating mb-3" color='black'>
                                            <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" style={{ height: "50px" }} value={numerosocio} onChange={e => setnumerosocio(e.target.value)} disabled={modoVerDetalle} />
                                            <label htmlFor="floatingInput">Número de socio</label>
                                        </div>
                                    }

                                </div>
                                :
                                <div className="form-floating mb-3" color='black'>
                                    <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" style={{ height: "80px" }} value={valor} onChange={e => setValor(e.target.value)} disabled={modoVerDetalle} />
                                    {/* <input type="text" className={`form-control `} id="floatinginput" placeholder='Campo' value={valor} onChange={e => setValor(e.target.value)} /> */}
                                    <label htmlFor="floatingInput">Campo</label>
                                </div>
                            }


                            <div className="form-floating mb-3">
                                <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" value={observaciones} onChange={e => setObservaciones(e.target.value)} disabled={modoVerDetalle}></textarea>
                                <label htmlFor="floatingInput">Observaciones</label>
                            </div>
                            <br /><br />
                            {
                                nombresParaPaginas[paginaActiva - 1] === 'Documentación' &&
                                <>
                                    <label htmlFor="floatingInput">Vigencia: </label>
                                    <button className={
                                        (estadoVigencia === '' || estadoVigencia === 'Agregar') ? (
                                            `${estilos.agregarVigencia} btn ms-3`
                                        ) : estadoVigencia === 'Vigente' ? (
                                            'btn btn-success ms-3'
                                        ) : 'btn btn-danger ms-3'
                                        //     fechaInicio.length===0?
                                        // ('btn btn-outline-warning ms-3'):
                                        // fechaTermino.length===0?('btn btn-outline-success ms-3'):
                                        // ((estadoVigencia.length===0 || estadoVigencia==='Vigente')?( 'btn btn-outline-success ms-3'))
                                        // :('btn btn-outline-danger ms-3')
                                    } onClick={() => { botonVigencia() }} disabled={modoVerDetalle}>{`${estadoVigencia}`}</button><br />
                                </>
                            }

                            {
                                vigencia &&
                                <>
                                    <br />
                                    <div className='row justify-content-center'>
                                        <div className="form-floating col-md-6">
                                            <input type="date" className={`form-control `} id="floatinginput" placeholder='Inicio'
                                                value={fechaInicio} onChange={e => setFechaInicio(e.target.value)} />
                                            <label htmlFor="floatingInput"> Fecha inicio</label>
                                        </div>
                                        <div className="form-floating col-md-6">
                                            <input type="date" className={`form-control `} id="floatinginput" placeholder='Termino'
                                                value={fechaTermino} onChange={e => setFechaTermino(e.target.value)} />
                                            <label htmlFor="floatingInput">Fecha termino</label>

                                        </div>
                                        <div className=" text-center" >
                                            <br />
                                            <button className='btn btn-warning' onClick={() => { botonCerrarVigencia() }}>Establecer</button>
                                        </div>
                                    </div>
                                </>
                            }<br />
                        </Typography>
                        <br />
                        {modoVerDetalle ?
                            <div className='row'>
                                <div className={` text-center`}>
                                    <button className='btn btn-outline-danger' onClick={() => { handleCloseModalCorrecto() }}>CERRAR</button>
                                </div>
                            </div>
                            :
                            <div className='row'>
                                <div className='col-md-2'>
                                    <button className='btn btn-outline-success' onClick={() => { botonGuardar() }}>GUARDAR</button>
                                </div>
                                <div className={`${estilos.botonCancelarModal} col-md-2`}>
                                    <button className='btn btn-outline-danger' onClick={() => { handleCloseModalCorrecto() }}>CANCELAR</button>
                                </div>
                            </div>
                        }
                        {/* <div className='row'>
                            <div className='col-md-2'>
                                <button className='btn btn-outline-success' onClick={() => { botonGuardar() }}>GUARDAR</button>
                            </div>
                            <div className={`${estilos.botonCancelarModal} col-md-2`}>
                                <button className='btn btn-outline-danger' onClick={() => { handleCloseModalCorrecto() }}>CANCELAR</button>
                            </div>
                        </div> */}
                    </Box>
                </Modal>
            </div >
        )
    }
    const [openModalRelacion, setOpenModalRelacion] = React.useState(false);
    const [marcaRelacion, setMarcaRelacion] = React.useState(false);
    const handleOpenModalRelacion = (params) => {
        setId(params.row.id)
        setCampo(params.row.Campo)
        setValor(params.row.valor)
        setMarcaRelacion(params.row.nombreMarca)
        setOpenModalRelacion(true)
    }
    const handleCloseModalRelacion = () => {
        setOpenModalRelacion(false)
        setNumeroSocioCliente()
        setNombreRazon('')
        setExitoBusqueda(false)
        setFailedBusqueda(false)
        setRelacionExistente(false)

    }
    const modalComponentRelacion = () => {
        return (
            <div>
                <Modal
                    open={openModalRelacion}
                    onClose={handleCloseModalRelacion}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    hideBackdrop={true}
                >
                    <Box sx={styleCorrecto}>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 0 }} className='text-center'>
                            {
                                campo === 'Maquilador autorizado' || campo === 'Productor autorizado' ?
                                    <div className="row">
                                        <div className='form-floating mb-3 col-md-7'>
                                            <input className={`form-control`}
                                                type="number"
                                                onChange={e => setNumeroSocioCliente(e.target.value)}
                                                value={numeroSocioCliente} id="numerosociocliente"
                                                name="numerosociocliente"
                                                onWheel={event => event.currentTarget.blur()}
                                            />
                                            <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                                Número Socio
                                            </label>
                                        </div>
                                        <div className='form-floating col-md-3 mb-3'>
                                            <button className={'btn btn-success'}
                                                onClick={() => { busquedaCliente() }}>Buscar</button>
                                        </div>
                                        {exitoBusqueda &&
                                            <div className='form-floating mb-3 col-md-12'>
                                                <input className={`form-control`}
                                                    type="text"
                                                    onChange={e => setNombreRazon(e.target.value)}
                                                    value={nombreRazon} id="nombrerazon"
                                                    name="nombrerazon"
                                                />
                                                <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                                    {campo}
                                                </label>
                                            </div>
                                        }
                                        <br />

                                        {filedBusqueda && <span className='text-danger'>Socio no encontrado<br /></span>}

                                    </div>
                                    : ''

                            }
                        </Typography>
                        <br />
                        {modoVerDetalle ?
                            <div className='row'>
                                <div className={` text-center`}>
                                    <button className='btn btn-outline-danger' onClick={() => { handleCloseModalRelacion() }}>CERRAR</button>
                                </div>
                            </div>
                            :
                            <div className='row'>
                                <div className='col-md-8'>
                                    <button className='btn btn-outline-success' onClick={() => { botonAgregarRelacion() }}>Agregar relación</button>
                                </div>
                                <div className={`col-md-2`} style={{ marginLeft: '-7%' }}>
                                    <button className='btn btn-outline-danger' onClick={() => { handleCloseModalRelacion() }}>CANCELAR</button>
                                </div>
                                {relacionExistente && <span className='text-danger text-center' style={{ fontSize: 18 }}> <br /><br />LA RELACIÓN YA EXISTE</span>}
                            </div>
                        }
                        <br />
                        <div style={{ height: (130 + (relaciones.length * 50)), width: '100%' }}>
                            <DataGrid
                                rows={rowsRelacion}
                                columns={columnsRelacion}
                                pageSize={6}
                                sx={{
                                    boxShadow: 0,
                                    color: 'black',
                                    border: 0,
                                    '& .MuiDataGrid-cell': {
                                        display: 'block',
                                        position: 'relative',
                                        textAlign: 'center',
                                    },
                                }}
                            />
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }



    const [exitoBusqueda, setExitoBusqueda] = React.useState(false)
    const [numeroSocioCliente, setNumeroSocioCliente] = React.useState()
    const [nombreRazon, setNombreRazon] = React.useState('')
    const [filedBusqueda, setFailedBusqueda] = React.useState(false)

    const busquedaCliente = async () => {
        const data = await dispatch(obtenerClientePorNoSocio(numeroSocioCliente))
        if (data?.payload?.[0] && data.payload.length > 0) {
            setNombreRazon(data?.payload?.[0]?.nombrerazonsocial)
            setExitoBusqueda(true)
            setFailedBusqueda(false)
        } else {
            setFailedBusqueda(true)
        }

    }
    const [relaciones, setRelaciones] = useState([])
    let rowsRelacion = []

    relaciones?.map(datos => {
        rowsRelacion.push({ id: uuidv4(), numero: datos.numero, marca: datos.marca, tipo: datos.tipo === 'maquilador' ? 'Maquilador' : datos.tipo === 'productor' ? 'Productor' : datos.tipo })
    })
    const [relacionExistente, setRelacionExistente] = React.useState(false)
    const botonAgregarRelacion = async () => {
        let tipoMarca = ''
        if (campo === 'Productor autorizado') tipoMarca = 'productor'
        if (campo === 'Maquilador autorizado') tipoMarca = 'maquilador'

        //const filtro = relaciones.filter(relacion => relacion.numero === numeroSocioCliente && relacion.marca === marcaRelacion)
        {/*if (filtro.length > 0) {
            setRelacionExistente(true)
        } else {*/}
        const data = { numero: numeroSocioCliente, marca: marcaRelacion, tipo: tipoMarca }
        relaciones.push(JSON.parse(JSON.stringify(data)))
        //setRelaciones()
        setRelacionExistente(false)
        setOpenModalRelacion(false)
        setNumeroSocioCliente()
        setNombreRazon('')
        //}
    }

    const obtenerVigencia = () => {

        let bandera = false
        let fecha1 = new Date(fechaTermino)
        let fecha2 = new Date(moment().format('YYYY-MM-DD'))

        let milisegundosDia = 24 * 60 * 60 * 1000
        let milisegundosTrascurridos = Math.abs(fecha1.getTime() - fecha2.getTime())
        let diasTranscurridos = Math.round(milisegundosTrascurridos / milisegundosDia)
        let milisegundos = fecha1.getTime() - fecha2.getTime()
        if (milisegundos > 0) {
            setEstadoVigencia('Vigente')
        } else {
            setEstadoVigencia('Vencido')
        }
        return bandera
    }
    const botonGuardar = () => {
        obtenerVigencia()
        for (const cambio of rowsPrincipal) {
            if (cambio.id === id) {
                if (cambio.Campo === 'Tipo de inscripción') {
                    if (inscrito) {
                        cambio.valor = 'Ya se encuentra inscrito'
                    }
                    if (asociado) {
                        cambio.valor = 'Cliente Asociado'
                    }
                    if (noasociado) {
                        cambio.valor = 'Cliente No Asociado'
                    }
                    cambio.correcto = correcto
                    cambio.incorrecto = incorrecto
                    cambio.observaciones = observaciones
                } else {
                    cambio.valor = valor
                    cambio.correcto = correcto
                    cambio.incorrecto = incorrecto
                    cambio.observaciones = observaciones
                }

            }
        }
        for (const cambio of rowsVivero) {
            if (cambio.id === id) {
                cambio.valor = valor
                cambio.correcto = correcto
                cambio.incorrecto = incorrecto
                cambio.observaciones = observaciones
            }
        }
        for (const cambio of rowsProductor) {
            if (cambio.id === id) {
                cambio.valor = valor
                cambio.correcto = correcto
                cambio.incorrecto = incorrecto
                cambio.observaciones = observaciones
            }
        }
        for (const cambio of rowsMarcaDeMezcal) {
            if (cambio.id === id) {
                cambio.valor = valor
                cambio.correcto = correcto
                cambio.incorrecto = incorrecto
                cambio.observaciones = observaciones
            }
        }
        for (const cambio of rowsMarcaProductosConMezcal) {
            if (cambio.id === id) {
                cambio.valor = valor
                cambio.correcto = correcto
                cambio.incorrecto = incorrecto
                cambio.observaciones = observaciones
            }
        }
        for (const cambio of rowsAnexos) {
            if (cambio.id === id) {
                cambio.valor = valor
                cambio.correcto = correcto
                cambio.incorrecto = incorrecto
                cambio.observaciones = observaciones
            }
        }

        for (const cambio of rowDocumentacion) {
            if (cambio.id === id) {
                cambio.correcto = correcto
                cambio.incorrecto = incorrecto
                cambio.observaciones = observaciones
                cambio.fechaInicio = fechaInicio
                cambio.fechaTermino = fechaTermino
                if (fechaInicio !== '' && fechaTermino === '') { cambio.estatus = 'Vigente' }
                else { cambio.estatus = estadoVigencia }

            }
        }
        setVigencia(false)
        setFechaInicio('')
        setFechaTermino('')
        setEstadoVigencia('')
        setOpenModalCorrecto(false)
        setOpenModalIncorrecto(false)
    }
    const obtenerAncho = () => {
        const anchoPantalla = window.innerWidth
        return anchoPantalla
    }
    const tablaDataGrid = (rows) => {
        return (
            <div className='container'>
                <div className='row justify-content-center'>
                    <div className='col-12 mt-1 ms-3 text-center'>
                        <div style={{ height: (130 + (rows.length * 50)), width: obtenerAncho() < 1500 ? '100%' : '88%', color: 'black' }}>
                            <DataGrid
                                rows={rows}
                                columns={columns}
                                rowsPerPageOptions={[50]}
                                // pageSize={30}
                                // rowClassRules={'sick-days-breach'}
                                // disableColumnFilter
                                sx={{
                                    boxShadow: 0,
                                    color: 'black',
                                    border: 0,
                                    // '& .MuiDataGrid-cell': {
                                    //     display: 'block',
                                    //     position: 'relative',
                                    //     textAlign: 'center',
                                    // },
                                }}
                            />
                        </div>
                    </div>
                    <br />
                </div>
            </div>
        )
    }
    const tablaDocumentacion = (rows) => {
        return (
            <div className='container'>
                <div className='row justify-content-center'>
                    <div className='col-12 mt-1 ms-3 text-center'>
                        <div style={{ height: (130 + (rows.length * 50)), width: obtenerAncho() < 1500 ? '100%' : '87%', color: 'black' }}>
                            <DataGrid
                                rows={rows}
                                columns={columnsDocumentacion}
                                rowsPerPageOptions={[50]}
                                sx={{
                                    boxShadow: 0,
                                    color: 'black',
                                    border: 0,
                                    // '& .MuiDataGrid-cell': {
                                    //     display: 'block',
                                    //     position: 'relative',
                                    //     textAlign: 'center',
                                    // },
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    const [paginaActiva, setPaginaActiva] = useStateIfMounted(1)
    const [paginas, setPaginas] = useStateIfMounted([1])
    const [nombresParaPaginas, setNombresParaPaginas] = useStateIfMounted(['Datos generales'])

    const cambiarPagina = (pagina) => {
        setPaginaActiva(pagina)
    }
    React.useEffect(() => {
        let totalDePaginas = 1
        const nuevosApartados = ['Datos generales']
        if (solicitud.viverista || solicitud.productormaguey) {
            totalDePaginas++
            let nombreApartado = ''
            if (solicitud.viverista && solicitud.productormaguey) nombreApartado = 'Viverista/Productor de maguey'
            else if (solicitud.viverista) nombreApartado = 'Viverista'
            else nombreApartado = 'Productor de maguey'
            nuevosApartados.push(nombreApartado)
        }
        if (solicitud.productormezcal || solicitud.envasador || solicitud.comercializadormezcal || solicitud.comercializadorbebidasconmezcal) {
            totalDePaginas++
            nuevosApartados.push('Instalaciones')
        }
        if (solicitud.comercializadormezcal || solicitud.comercializadorbebidasconmezcal) {
            totalDePaginas++
            nuevosApartados.push('Marcas')
        }
        totalDePaginas++
        nuevosApartados.push('Documentación')
        let nuevasPaginas = []
        for (let index = 1; index <= totalDePaginas; index++) {
            nuevasPaginas.push(index)
        }
        setPaginas(nuevasPaginas)
        setNombresParaPaginas(nuevosApartados)
    }, [])
    const botonAceptar = async () => {
    }
    let [tipoAnexo, setTipoAnexo] = React.useState('')
    const botonDevolver = async () => {
        await actualizarFC_01ModoProceso()
        await dispatch(actualizarFC_01Estatus({ data: { idSolicitud: solicitud.idfc01_solicitudregistro, estatus: 5, folio: solicitud.folio } }))
        await dispatch(resetDataFC_01())

        const idRol = currentUser.user[0].rol
        if (idRol === 1) await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 5 }))
        else if (idRol === 2) await dispatch(obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado({ status: 5, revisor: dataUser[0]?.datoslogin.nombre + ' ' + dataUser[0]?.datoslogin.apellidos, idLogin: currentUser.user[0].id }))
        props.history.push('/AtencionAClientesComponent')
    }
    const botonGuardarBorrador = async () => {
        await actualizarFC_01ModoProceso()
        if (solicitud.idestatusdesolicitudes === 2) {
            await dispatch(actualizarFC_01Estatus({ data: { idSolicitud: solicitud.idfc01_solicitudregistro, estatus: 3, folio: solicitud.folio } }))
        } else {
            await dispatch(actualizarFC_01Estatus({ data: { idSolicitud: solicitud.idfc01_solicitudregistro, estatus: solicitud.idestatusdesolicitudes, folio: solicitud.folio } }))

        }
        await dispatch(resetDataFC_01())
        const idRol = currentUser.user[0].rol
        if (solicitud.idestatusdesolicitudes === 2) {
            if (idRol === 1) await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 3 }))
            else if (idRol === 2) await dispatch(obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado({ status: 3, revisor: dataUser[0]?.datoslogin.nombre + ' ' + dataUser[0]?.datoslogin.apellidos, idLogin: currentUser.user[0].id }))

        } else {
            if (idRol === 1) await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: solicitud.idestatusdesolicitudes }))
            else if (idRol === 2) await dispatch(obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado({ status: solicitud.idestatusdesolicitudes, revisor: dataUser[0]?.datoslogin.nombre + ' ' + dataUser[0]?.datoslogin.apellidos, idLogin: currentUser.user[0].id }))

        }


        props.history.push('/AtencionAClientesComponent')
    }
    const botonDevolverCorreciones = async () => {
        await actualizarFC_01ModoCorrecion()
        await dispatch(actualizarFC_01Estatus({ data: { idSolicitud: solicitud.idfc01_solicitudregistro, estatus: 5, folio: solicitud.folio } }))
        await dispatch(resetDataFC_01())

        const idRol = currentUser.user[0].rol
        if (idRol === 1) await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 5 }))
        else if (idRol === 2) await dispatch(obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado({ status: 5, revisor: dataUser[0]?.datoslogin.nombre + ' ' + dataUser[0]?.datoslogin.apellidos, idLogin: currentUser.user[0].id }))
        props.history.push('/AtencionAClientesComponent')
    }
    const botonGuardarCorrecionesBorrador = async () => {
        await actualizarFC_01ModoCorrecion()
        await dispatch(actualizarFC_01Estatus({ data: { idSolicitud: solicitud.idfc01_solicitudregistro, estatus: solicitud.idestatusdesolicitudes, folio: solicitud.folio } }))
        await dispatch(resetDataFC_01())
        const idRol = currentUser.user[0].rol
        if (idRol === 1) await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: solicitud.idestatusdesolicitudes }))
        else if (idRol === 2) await dispatch(obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado({ status: solicitud.idestatusdesolicitudes, revisor: dataUser[0]?.datoslogin.nombre + ' ' + dataUser[0]?.datoslogin.apellidos, idLogin: currentUser.user[0].id }))
        props.history.push('/AtencionAClientesComponent')
    }
    const actualizarFC_01ModoProceso = async () => {
        await dispatch(actualizarLoadingApp_true())
        const principal = []
        const principalMap = []
        const personaAutorizada = []
        const personaAutorizadaMap = []
        const apoderadoLegal = []
        const apoderadoLegalMap = []
        const representante = []
        const representanteMap = []
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()
        let domicilioFiscal = rowsPrincipal[rowsPrincipal.length - 1].valor.split(';')
        if (solicitud.personamoral) {
            if (solicitud.calle === 'Otro') {
                // if ((solicitud.asociado === true || solicitud.noasociado === true) && asociado === false && noasociado === false && inscrito === false) {
                principal.push({
                    idfc01_solicitudregistro: solicitud.idfc01_solicitudregistro, //fechasolicitud: fechaSolicitudAceptada,
                    asociado: asociado, noasociado: noasociado, inscrito: inscrito, numerosocio: numerosocio,
                    nombrerazonsocial: rowsPrincipal[1].valor, rfc: rowsPrincipal[2].valor, telefono: rowsPrincipal[3].valor, correoelectronico: rowsPrincipal[4].valor,
                    representantelegal: rowsPrincipal[5].valor, empresacertificadora: rowsPrincipal[6].Campo === 'Empresa Certificadora' ? (rowsPrincipal[6].valor) : (''),
                    otracalle: domicilioFiscal[0], numerointerior: domicilioFiscal[1], numeroexterior: domicilioFiscal[2],
                    colonia: domicilioFiscal[3], localidad: domicilioFiscal[4], municipioalcaldia: domicilioFiscal[5],
                    estado: domicilioFiscal[6], codigopostal: domicilioFiscal[7]
                })
                // } else {

                //     principal.push({
                //         idfc01_solicitudregistro: solicitud.idfc01_solicitudregistro,
                //         // asociado: asociado, noasociado: noasociado, inscrito: inscrito, numerosocio: numerosocio, 
                //         nombrerazonsocial: rowsPrincipal[0].valor, rfc: rowsPrincipal[1].valor, telefono: rowsPrincipal[2].valor, correoelectronico: rowsPrincipal[3].valor,
                //         representantelegal: rowsPrincipal[4].valor, empresacertificadora: rowsPrincipal[5].Campo === 'Empresa Certificadora' ? (rowsPrincipal[5].valor) : (''),
                //         otracalle: domicilioFiscal[0], numerointerior: domicilioFiscal[1], numeroexterior: domicilioFiscal[2],
                //         colonia: domicilioFiscal[3], codigopostal: domicilioFiscal[4], localidad: domicilioFiscal[5], municipioalcaldia: domicilioFiscal[6],
                //         estado: domicilioFiscal[7]
                //     })
                // }

            } else {
                principal.push({
                    idfc01_solicitudregistro: solicitud.idfc01_solicitudregistro, //fechasolicitud: fechaSolicitudAceptada,
                    asociado: asociado, noasociado: noasociado, inscrito: inscrito, numerosocio: numerosocio,
                    nombrerazonsocial: rowsPrincipal[1].valor, rfc: rowsPrincipal[2].valor, telefono: rowsPrincipal[3].valor, correoelectronico: rowsPrincipal[4].valor,
                    representantelegal: rowsPrincipal[5].valor, empresacertificadora: rowsPrincipal[6].Campo === 'Empresa Certificadora' ? (rowsPrincipal[6].valor) : (''),
                    calle: domicilioFiscal[0], numerointerior: domicilioFiscal[1], numeroexterior: domicilioFiscal[2],
                    colonia: domicilioFiscal[3], localidad: domicilioFiscal[4], municipioalcaldia: domicilioFiscal[5],
                    estado: domicilioFiscal[6], codigopostal: domicilioFiscal[7]
                })


            }

            principalMap.push({
                idfc01_solicitudregistro: solicitud.idfc01_solicitudregistro,
                tipocliente: rowsPrincipal[0].observaciones,
                nombrerazonsocial: rowsPrincipal[1].observaciones, rfc: rowsPrincipal[2].observaciones, telefono: rowsPrincipal[3].observaciones,
                correoelectronico: rowsPrincipal[4].observaciones, representantelegal: rowsPrincipal[5].observaciones,
                empresacertificadora: rowsPrincipal[6].Campo === 'Empresa Certificadora' ? (rowsPrincipal[6].observaciones) : (''),
                cadenaproductiva: rowsPrincipal[rowsPrincipal.length - 2].observaciones,
                domiciliofiscal: rowsPrincipal[rowsPrincipal.length - 1].observaciones,
                tipoclientecheck: rowsPrincipal[0].incorrecto,
                nombrerazonsocialcheck: rowsPrincipal[1].incorrecto, rfccheck: rowsPrincipal[2].incorrecto, telefonocheck: rowsPrincipal[3].incorrecto,
                correoelectronicocheck: rowsPrincipal[4].incorrecto, representantelegalcheck: rowsPrincipal[5].incorrecto,
                empresacertificadoracheck: rowsPrincipal[6].Campo === 'Empresa Certificadora' ? (rowsPrincipal[6].incorrecto) : (false),
                cadenaproductivacheck: rowsPrincipal[rowsPrincipal.length - 2].incorrecto, domiciliofiscalcheck: rowsPrincipal[rowsPrincipal.length - 1].incorrecto,

            })
            // if (solicitud.certificacionsi) {
            //     principalMap.push({
            //         empresacertificadora: rowsPrincipal[5].observaciones,
            //         empresacertificadoracheck: rowsPrincipal[5].incorrecto
            //     })
            // }
            for (const datos of rowsPrincipal) {
                if (datos.Campo === 'Apoderado Legal') {
                    apoderadoLegalMap.push({ idfc01_anexorepresentantelegal: datos.idfc01_anexorepresentantelegal, representantelegal: datos.observaciones, representantelegalcheck: datos.incorrecto })
                    apoderadoLegal.push({ idfc01_anexorepresentantelegal: datos.idfc01_anexorepresentantelegal, representantelegal: datos.valor })
                } else {
                    if (datos.Campo === 'Persona Autorizada') {
                        personaAutorizadaMap.push({ idfc01_anexopersonaatorizadatramites: datos.idfc01_anexopersonaatorizadatramites, personaautoriazadaparatramites: datos.observaciones, personaautoriazadaparatramitescheck: datos.incorrecto })
                        personaAutorizada.push({ idfc01_anexopersonaatorizadatramites: datos.idfc01_anexopersonaatorizadatramites, personaautoriazadaparatramites: datos.valor })
                    }
                }

            }
        } else {
            if (solicitud.calle === 'Otro') {
                const data = {
                    idfc01_solicitudregistro: solicitud.idfc01_solicitudregistro, nombrerazonsocial: rowsPrincipal[1].valor, rfc: rowsPrincipal[2].valor, telefono: rowsPrincipal[3].valor, correoelectronico: rowsPrincipal[4].valor,
                    otracalle: domicilioFiscal[0], numerointerior: domicilioFiscal[1], numeroexterior: domicilioFiscal[2],
                    colonia: domicilioFiscal[3], localidad: domicilioFiscal[4], municipioalcaldia: domicilioFiscal[5],
                    estado: domicilioFiscal[6], codigopostal: domicilioFiscal[7]
                }
                if (solicitud.representantelegalsi) {
                    data.representantelegal = rowsPrincipal[5].valor
                }
                if (solicitud.certificacionsi && solicitud.representantelegalsi) {
                    data.empresacertificadora = rowsPrincipal[6].valor
                } else if (solicitud.certificacionsi && !solicitud.representantelegalsi) {
                    data.empresacertificadora = rowsPrincipal[5].valor
                }
                principal.push(data)
            } else {
                const data = {
                    idfc01_solicitudregistro: solicitud.idfc01_solicitudregistro, nombrerazonsocial: rowsPrincipal[1].valor, rfc: rowsPrincipal[2].valor, telefono: rowsPrincipal[3].valor, correoelectronico: rowsPrincipal[4].valor,
                    calle: domicilioFiscal[0], numerointerior: domicilioFiscal[1], numeroexterior: domicilioFiscal[2],
                    colonia: domicilioFiscal[3], localidad: domicilioFiscal[4], municipioalcaldia: domicilioFiscal[5],
                    estado: domicilioFiscal[6], codigopostal: domicilioFiscal[7]
                }
                if (solicitud.representantelegalsi) {
                    data.representantelegal = rowsPrincipal[5].valor
                }
                if (solicitud.certificacionsi && solicitud.representantelegalsi) {
                    data.empresacertificadora = rowsPrincipal[6].valor
                } else if (solicitud.certificacionsi && !solicitud.representantelegalsi) {
                    data.empresacertificadora = rowsPrincipal[5].valor
                }
                principal.push(data)
            }

            principalMap.push({
                idfc01_solicitudregistro: solicitud.idfc01_solicitudregistro,
                tipocliente: rowsPrincipal[0].observaciones,
                nombrerazonsocial: rowsPrincipal[1].observaciones, rfc: rowsPrincipal[2].observaciones, telefono: rowsPrincipal[3].observaciones,
                correoelectronico: rowsPrincipal[4].observaciones, representantelegal: rowsPrincipal[5].observaciones,
                empresacertificadora: rowsPrincipal[6].Campo === 'Empresa Certificadora' ? (rowsPrincipal[6].observaciones) : (''),
                cadenaproductiva: rowsPrincipal[rowsPrincipal.length - 2].observaciones,
                domiciliofiscal: rowsPrincipal[rowsPrincipal.length - 1].observaciones,
                tipoclientecheck: rowsPrincipal[0].incorrecto,
                nombrerazonsocialcheck: rowsPrincipal[1].incorrecto, rfccheck: rowsPrincipal[2].incorrecto, telefonocheck: rowsPrincipal[3].incorrecto,
                correoelectronicocheck: rowsPrincipal[4].incorrecto, representantelegalcheck: rowsPrincipal[5].incorrecto,
                empresacertificadoracheck: rowsPrincipal[6].Campo === 'Empresa Certificadora' ? (rowsPrincipal[6].incorrecto) : (false),
                cadenaproductivacheck: rowsPrincipal[rowsPrincipal.length - 2].incorrecto, domiciliofiscalcheck: rowsPrincipal[rowsPrincipal.length - 1].incorrecto,

            })
            if (solicitud.certificacionsi) {
                principalMap.push({
                    empresacertificadora: rowsPrincipal[5].observaciones,
                    empresacertificadoracheck: rowsPrincipal[5].incorrecto
                })
            }
            for (const datos of rowsPrincipal) {
                if (datos.Campo === 'Persona Autorizada') {
                    personaAutorizadaMap.push({ idfc01_anexopersonaatorizadatramites: datos.idfc01_anexopersonaatorizadatramites, personaautoriazadaparatramites: datos.observaciones, personaautoriazadaparatramitescheck: datos.incorrecto })
                    personaAutorizada.push({ idfc01_anexopersonaatorizadatramites: datos.idfc01_anexopersonaatorizadatramites, personaautoriazadaparatramites: datos.valor })
                }
            }
        }
        const productor = []
        const productorMap = []
        for (const datos of rowsProductor) {
            if (datos.Campo) {
                let domicilio = datos.valor.split(';')
                productor.push({ idfc01_anexoproductor: datos.idfc01_anexoproductor, localidad: domicilio[0], municipio: domicilio[1], distrito: domicilio[2], estado: domicilio[3] })
                productorMap.push({ idfc01_anexoproductor: datos.idfc01_anexoproductor, domicilio: datos.observaciones, domiciliocheck: datos.incorrecto })
            }
        }
        const vivero = []
        const viveroMap = []
        for (const datos of rowsVivero) {
            if (datos.Campo) {
                let domicilio = datos.valor.split(';')
                vivero.push({
                    idfc01_anexopredios: datos.idfc01_anexopredios, calle: domicilio[0], numeroexterior: domicilio[1], codigopostal: domicilio[2], localidad: domicilio[3],
                    municipio: domicilio[4], distrito: domicilio[5], estado: domicilio[6]
                })
                viveroMap.push({ idfc01_anexopredios: datos.idfc01_anexopredios, domicilio: datos.observaciones, domiciliocheck: datos.incorrecto })
            }
        }
        const marcaDeMezcal = []
        const marcaDeMezcalMap = []
        for (const datos in rowsMarcaDeMezcal) {
            if (rowsMarcaDeMezcal[datos].Campo === 'Nombre de la marca') {
                // const pos1 = Number(datos )+ Number(1)

                marcaDeMezcal.push({
                    idfc01_anexomarcas: rowsMarcaDeMezcal[Number(datos)].idfc01_anexomarcas,
                    marca: rowsMarcaDeMezcal[Number(datos)].valor, anexoexistente: rowsMarcaDeMezcal[Number(datos)]?.anexoexistente,
                    numeroderegistroimpi: rowsMarcaDeMezcal[Number(datos) + Number(1)].valor,
                    // idtipomarca: rowsMarcaDeMezcal[Number(datos) + Number(2)]?.valor, idtitularidaddemarca: rowsMarcaDeMezcal[Number(datos) + Number(3)].valor,
                    productor: rowsMarcaDeMezcal[Number(datos) + Number(4)]?.Campo === 'Productor autorizado' ? (rowsMarcaDeMezcal[Number(datos) + Number(4)]?.valor) : '',
                    maquilador: rowsMarcaDeMezcal[Number(datos) + Number(5)]?.Campo === 'Maquilador autorizado' ? (rowsMarcaDeMezcal[Number(datos) + Number(5)]?.valor) : (rowsMarcaDeMezcal[Number(datos) + Number(4)]?.Campo === 'Maquilador autorizado' ? (rowsMarcaDeMezcal[Number(datos) + Number(4)]?.valor) : ''),
                })
                marcaDeMezcalMap.push({
                    idfc01_anexomarcas: rowsMarcaDeMezcal[Number(datos)].idfc01_anexomarcas,
                    marca: rowsMarcaDeMezcal[Number(datos)].observaciones, numeroderegistroimpi: rowsMarcaDeMezcal[Number(datos) + Number(1)].observaciones,
                    idtipomarca: rowsMarcaDeMezcal[Number(datos) + Number(2)]?.observaciones, idtitularidaddemarca: rowsMarcaDeMezcal[Number(datos) + Number(3)].observaciones,
                    productor: rowsMarcaDeMezcal[Number(datos) + Number(4)]?.Campo === 'Productor autorizado' ? (rowsMarcaDeMezcal[Number(datos) + Number(4)]?.observaciones) : '',
                    maquilador: rowsMarcaDeMezcal[Number(datos) + Number(5)]?.Campo === 'Maquilador autorizado' ? (rowsMarcaDeMezcal[Number(datos) + Number(5)]?.observaciones) : (rowsMarcaDeMezcal[Number(datos) + Number(4)]?.Campo === 'Maquilador autorizado' ? (rowsMarcaDeMezcal[Number(datos) + Number(4)]?.observaciones) : ''),

                    marcacheck: rowsMarcaDeMezcal[Number(datos)].incorrecto, numeroderegistroimpicheck: rowsMarcaDeMezcal[Number(datos) + Number(1)].incorrecto,
                    idtitularidaddemarcacheck: rowsMarcaDeMezcal[Number(datos) + Number(2)].incorrecto, idtipomarcacheck: rowsMarcaDeMezcal[Number(datos) + Number(3)].incorrecto,
                    productorcheck: rowsMarcaDeMezcal[Number(datos) + Number(4)]?.Campo === 'Productor autorizado' ? (rowsMarcaDeMezcal[Number(datos) + Number(4)]?.incorrecto) : false,
                    maquiladorcheck: rowsMarcaDeMezcal[Number(datos) + Number(5)]?.Campo === 'Maquilador autorizado' ? (rowsMarcaDeMezcal[Number(datos) + Number(5)]?.incorrecto) : (rowsMarcaDeMezcal[Number(datos) + Number(4)]?.Campo === 'Maquilador autorizado' ? (rowsMarcaDeMezcal[Number(datos) + Number(4)]?.incorrecto) : false),
                })
            }
        }

        const marcaProductoConMezcal = []
        const marcaProductoConMezcalMap = []
        for (const datos in rowsMarcaProductosConMezcal) {
            if (rowsMarcaProductosConMezcal[datos].Campo === 'Nombre de la marca') {
                marcaProductoConMezcal.push({
                    idfc01_anexomarcasproductoconmezcal: rowsMarcaProductosConMezcal[Number(datos)].idfc01_anexomarcasproductoconmezcal,
                    anexoexistente: rowsMarcaDeMezcal[Number(datos)]?.anexoexistente,
                    marca: rowsMarcaProductosConMezcal[Number(datos)].valor, numeroderegistroimpi: rowsMarcaProductosConMezcal[Number(datos) + Number(1)].valor,
                    // idtipomarca: rowsMarcaProductosConMezcal[Number(datos) + Number(2)].observaciones, idtitularidaddemarca: rowsMarcaProductosConMezcal[Number(datos) + Number(3)].observaciones,
                    productor: rowsMarcaProductosConMezcal[Number(datos) + Number(4)]?.Campo === 'Productor autorizado' ? (rowsMarcaProductosConMezcal[Number(datos) + Number(4)]?.valor) : '',
                    maquilador: rowsMarcaProductosConMezcal[Number(datos) + Number(5)]?.Campo === 'Maquilador autorizado' ? (rowsMarcaProductosConMezcal[Number(datos) + Number(5)]?.valor) : (rowsMarcaProductosConMezcal[Number(datos) + Number(4)]?.Campo === 'Maquilador autorizado' ? (rowsMarcaProductosConMezcal[Number(datos) + Number(4)]?.valor) : ''),
                })
                marcaProductoConMezcalMap.push({
                    idfc01_anexomarcasproductoconmezcal: rowsMarcaProductosConMezcal[Number(datos)].idfc01_anexomarcasproductoconmezcal,
                    marca: rowsMarcaProductosConMezcal[Number(datos)].observaciones, numeroderegistroimpi: rowsMarcaProductosConMezcal[Number(datos) + Number(1)].observaciones,
                    idtipomarca: rowsMarcaProductosConMezcal[Number(datos) + Number(2)].observaciones, idtitularidaddemarca: rowsMarcaProductosConMezcal[Number(datos) + Number(3)].observaciones,
                    productor: rowsMarcaProductosConMezcal[Number(datos) + Number(4)]?.Campo === 'Productor autorizado' ? (rowsMarcaProductosConMezcal[Number(datos) + Number(4)]?.observaciones) : '',
                    maquilador: rowsMarcaProductosConMezcal[Number(datos) + Number(5)]?.Campo === 'Maquilador autorizado' ? (rowsMarcaProductosConMezcal[Number(datos) + Number(5)]?.observaciones) : (rowsMarcaProductosConMezcal[Number(datos) + Number(4)]?.Campo === 'Maquilador autorizado' ? (rowsMarcaProductosConMezcal[Number(datos) + Number(4)]?.observaciones) : ''),

                    marcacheck: rowsMarcaProductosConMezcal[Number(datos)].incorrecto, numeroderegistroimpicheck: rowsMarcaProductosConMezcal[Number(datos) + Number(1)].incorrecto,
                    idtipomarcacheck: rowsMarcaProductosConMezcal[Number(datos) + Number(2)].incorrecto, idtitularidaddemarcacheck: rowsMarcaProductosConMezcal[Number(datos) + Number(3)].incorrecto,
                    productorcheck: rowsMarcaProductosConMezcal[Number(datos) + Number(4)]?.Campo === 'Productor autorizado' ? (rowsMarcaProductosConMezcal[Number(datos) + Number(4)]?.incorrecto) : false,
                    maquiladorcheck: rowsMarcaProductosConMezcal[Number(datos) + Number(5)]?.Campo === 'Maquilador autorizado' ? (rowsMarcaProductosConMezcal[Number(datos) + Number(5)]?.incorrecto) : (rowsMarcaProductosConMezcal[Number(datos) + Number(4)]?.Campo === 'Maquilador autorizado' ? (rowsMarcaProductosConMezcal[Number(datos) + Number(4)]?.incorrecto) : false),
                })
            }
        }

        const anexoPrincipalMap = []
        const anexoResponsableMap = []
        const anexoPrincipal = []
        const anexoResponsable = []
        for (const anexo of rowsAnexos) {

            if (anexo.Campo == "Domicilio de instalación") {
                const domicilio = anexo.valor.split(';')
                let opcionCalle = ''
                for (const i in solicitud.anexo) {
                    if (solicitud.anexo[i]?.informaciongeneral.idiformaciongeneral === anexo.idiformaciongeneral) {
                        opcionCalle = solicitud.anexo[i]?.informaciongeneral.calle
                        break;
                    }
                }

                if (opcionCalle === 'Otro') {
                    anexoPrincipal.push({
                        idiformaciongeneral: anexo.idiformaciongeneral, otracalle: domicilio[0], numerointerior: domicilio[1],
                        numeroexterior: domicilio[2], colonia: domicilio[3], codigopostal: domicilio[4], localidad: domicilio[5],
                        municipio: domicilio[6], estado: domicilio[7], anexoexistente: anexo.anexoexistente
                        // anexoexistente: prop.informaciongeneral.anexoexistente
                    })
                } else {
                    anexoPrincipal.push({
                        idiformaciongeneral: anexo.idiformaciongeneral, calle: domicilio[0], numerointerior: domicilio[1],
                        numeroexterior: domicilio[2], colonia: domicilio[3], codigopostal: domicilio[4], localidad: domicilio[5],
                        municipio: domicilio[6], estado: domicilio[7], anexoexistente: anexo.anexoexistente
                    })
                }


                anexoPrincipalMap.push({ idiformaciongeneral: anexo.idiformaciongeneral, domicilio: anexo.observaciones, domiciliocheck: anexo.incorrecto })
            }
            if (anexo.Campo == "Nombre del responsable") {
                anexoResponsable.push({ idresponsabledeinstalacion: anexo.idresponsabledeinstalacion, nombreresponsable: anexo.valor })

                anexoResponsableMap.push({ idresponsabledeinstalacion: anexo.idresponsabledeinstalacion, nombreresponsable: anexo.observaciones, nombreresponsablecheck: anexo.incorrecto })
            }
        }
        const ObjetoObservacionesMap = [{
            principalMap, apoderadoLegalMap, personaAutorizadaMap, viveroMap, productorMap,
            marcaProductoConMezcalMap, marcaDeMezcalMap, anexoPrincipalMap, anexoResponsableMap
        }]

        const ObjetoActualizarDatos = [{
            principal, apoderadoLegal, personaAutorizada, vivero, productor,
            marcaProductoConMezcal, marcaDeMezcal, anexoPrincipal, anexoResponsable
        }]
        await dispatch(agregarMapFC_01Accion(ObjetoObservacionesMap[0]))
        await dispatch(actualizarFC_01(ObjetoActualizarDatos[0]))
        await dispatch(guardarVigenciasDocumentacion({ documentacion: rowDocumentacion, archivosGenerales: solicitud.fc_01_anexos }))
        let dataDOM = {
            numerodom: numerodom, opcionDom: opcionDom, fechainiciodom: fechainiciodom, fechafindom: fechafindom, estatusdom: estatusdom,
            observacionesdom: observacionesdom, file: files, idfc01_solicitudregistro: solicitud.idfc01_solicitudregistro
        }
        await dispatch(AgregarDOMMap(dataDOM))
        await dispatch(actualizarLoadingApp_false())
    }
    const actualizarFC_01ModoCorrecion = async () => {
        await dispatch(actualizarLoadingApp_true())
        const principal = []
        const principalMap = []
        const personaAutorizada = []
        const personaAutorizadaMap = []
        const apoderadoLegal = []
        const apoderadoLegalMap = []
        const representante = []
        const representanteMap = []
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()

        let domicilioFiscal = rowsPrincipal[rowsPrincipal.length - 1].valor.split(';')
        if (solicitud.personamoral) {
            if (solicitud.calle === 'Otro') {
                principal.push({
                    idfc01_solicitudregistro: solicitud.idfc01_solicitudregistro, //fechasolicitud: fechaSolicitudAceptada,
                    asociado: asociado, noasociado: noasociado, inscrito: inscrito, numerosocio: numerosocio,
                    nombrerazonsocial: rowsPrincipal[1].valor, rfc: rowsPrincipal[2].valor, telefono: rowsPrincipal[3].valor, correoelectronico: rowsPrincipal[4].valor,
                    representantelegal: rowsPrincipal[5].valor, empresacertificadora: rowsPrincipal[6].Campo === 'Empresa Certificadora' ? (rowsPrincipal[6].valor) : (''),
                    otracalle: domicilioFiscal[0], numerointerior: domicilioFiscal[1], numeroexterior: domicilioFiscal[2],
                    colonia: domicilioFiscal[3], localidad: domicilioFiscal[4], municipioalcaldia: domicilioFiscal[5],
                    estado: domicilioFiscal[6], codigopostal: domicilioFiscal[7], numerodom: numerodom, opciondom: opcionDom
                })
            } else {
                principal.push({
                    idfc01_solicitudregistro: solicitud.idfc01_solicitudregistro, //fechasolicitud: fechaSolicitudAceptada,
                    asociado: asociado, noasociado: noasociado, inscrito: inscrito, numerosocio: numerosocio,
                    nombrerazonsocial: rowsPrincipal[1].valor, rfc: rowsPrincipal[2].valor, telefono: rowsPrincipal[3].valor, correoelectronico: rowsPrincipal[4].valor,
                    representantelegal: rowsPrincipal[5].valor, empresacertificadora: rowsPrincipal[6].Campo === 'Empresa Certificadora' ? (rowsPrincipal[6].valor) : (''),
                    calle: domicilioFiscal[0], numerointerior: domicilioFiscal[1], numeroexterior: domicilioFiscal[2],
                    colonia: domicilioFiscal[3], localidad: domicilioFiscal[4], municipioalcaldia: domicilioFiscal[5],
                    estado: domicilioFiscal[6], codigopostal: domicilioFiscal[7], numerodom: numerodom, opciondom: opcionDom
                })
            }

            principalMap.push({
                idfc01_solicitudregistromap: solicitud.fc_01_solicitudderegistromap[0]?.idfc01_solicitudregistromap,
                idfc01_solicitudregistro: solicitud.idfc01_solicitudregistro,
                tipocliente: rowsPrincipal[0].observaciones,
                nombrerazonsocial: rowsPrincipal[1].observaciones, rfc: rowsPrincipal[2].observaciones, telefono: rowsPrincipal[3].observaciones,
                correoelectronico: rowsPrincipal[4].observaciones, representantelegal: rowsPrincipal[5].observaciones,
                empresacertificadora: rowsPrincipal[6].Campo === 'Empresa Certificadora' ? (rowsPrincipal[6].observaciones) : (''),
                cadenaproductiva: rowsPrincipal[rowsPrincipal.length - 2].observaciones,
                domiciliofiscal: rowsPrincipal[rowsPrincipal.length - 1].observaciones,
                tipoclientecheck: rowsPrincipal[0].incorrecto,
                nombrerazonsocialcheck: rowsPrincipal[1].incorrecto, rfccheck: rowsPrincipal[2].incorrecto, telefonocheck: rowsPrincipal[3].incorrecto,
                correoelectronicocheck: rowsPrincipal[4].incorrecto, representantelegalcheck: rowsPrincipal[5].incorrecto,
                empresacertificadoracheck: rowsPrincipal[6].Campo === 'Empresa Certificadora' ? (rowsPrincipal[6].incorrecto) : (false),
                cadenaproductivacheck: rowsPrincipal[rowsPrincipal.length - 2].incorrecto, domiciliofiscalcheck: rowsPrincipal[rowsPrincipal.length - 1].incorrecto,

            })
            // if (solicitud.certificacionsi) {
            //     principalMap.push({
            //         empresacertificadora: rowsPrincipal[5].observaciones,
            //         empresacertificadoracheck: rowsPrincipal[5].incorrecto
            //     })
            // }
            for (const datos of rowsPrincipal) {

                if (datos.Campo === 'Apoderado Legal') {
                    apoderadoLegalMap.push({ idfc01_anexorepresentantelegalmap: datos.idMap, representantelegal: datos.observaciones, representantelegalcheck: datos.incorrecto })
                    apoderadoLegal.push({ idfc01_anexorepresentantelegal: datos.idfc01_anexorepresentantelegal, representantelegal: datos.valor })
                } else {
                    if (datos.Campo === 'Persona Autorizada') {
                        personaAutorizadaMap.push({ idfc01_anexopersonaatorizadatramitesmap: datos.idMap, personaautoriazadaparatramites: datos.observaciones, personaautoriazadaparatramitescheck: datos.incorrecto })
                        personaAutorizada.push({ idfc01_anexopersonaatorizadatramites: datos.idfc01_anexopersonaatorizadatramites, personaautoriazadaparatramites: datos.valor })
                    }
                }

            }
        } else {
            if (solicitud.calle === 'Otro') {
                const data = {
                    idfc01_solicitudregistro: solicitud.idfc01_solicitudregistro, nombrerazonsocial: rowsPrincipal[1].valor, rfc: rowsPrincipal[2].valor, telefono: rowsPrincipal[3].valor, correoelectronico: rowsPrincipal[4].valor,
                    otracalle: domicilioFiscal[0], numerointerior: domicilioFiscal[1], numeroexterior: domicilioFiscal[2],
                    colonia: domicilioFiscal[3], localidad: domicilioFiscal[4], municipioalcaldia: domicilioFiscal[5],
                    estado: domicilioFiscal[6], codigopostal: domicilioFiscal[7],
                    asociado: asociado, noasociado: noasociado, inscrito: inscrito, numerosocio: numerosocio,
                }
                if (solicitud.representantelegalsi) {
                    data.representantelegal = rowsPrincipal[5].valor
                }
                if (solicitud.certificacionsi && solicitud.representantelegalsi) {
                    data.empresacertificadora = rowsPrincipal[6].valor
                } else if (solicitud.certificacionsi && !solicitud.representantelegalsi) {
                    data.empresacertificadora = rowsPrincipal[5].valor
                }

                principal.push(data)
            } else {
                const data = {
                    idfc01_solicitudregistro: solicitud.idfc01_solicitudregistro, nombrerazonsocial: rowsPrincipal[1].valor, rfc: rowsPrincipal[2].valor, telefono: rowsPrincipal[3].valor, correoelectronico: rowsPrincipal[4].valor,
                    calle: domicilioFiscal[0], numerointerior: domicilioFiscal[1], numeroexterior: domicilioFiscal[2],
                    colonia: domicilioFiscal[3], localidad: domicilioFiscal[4], municipioalcaldia: domicilioFiscal[5],
                    estado: domicilioFiscal[6], codigopostal: domicilioFiscal[7],
                    asociado: asociado, noasociado: noasociado, inscrito: inscrito, numerosocio: numerosocio,
                }
                if (solicitud.representantelegalsi) {
                    data.representantelegal = rowsPrincipal[5].valor
                }
                if (solicitud.certificacionsi && solicitud.representantelegalsi) {
                    data.empresacertificadora = rowsPrincipal[6].valor
                } else if (solicitud.certificacionsi && !solicitud.representantelegalsi) {
                    data.empresacertificadora = rowsPrincipal[5].valor
                }
                principal.push(data)
            }
            principalMap.push({
                idfc01_solicitudregistromap: solicitud.fc_01_solicitudderegistromap[0]?.idfc01_solicitudregistromap,
                tipocliente: rowsPrincipal[0].observaciones,
                nombrerazonsocial: rowsPrincipal[1].observaciones, rfc: rowsPrincipal[2].observaciones, telefono: rowsPrincipal[3].observaciones,
                correoelectronico: rowsPrincipal[4].observaciones, representantelegal: rowsPrincipal[5].observaciones,
                empresacertificadora: rowsPrincipal[6].Campo === 'Empresa Certificadora' ? (rowsPrincipal[6].observaciones) : (''),
                cadenaproductiva: rowsPrincipal[rowsPrincipal.length - 2].observaciones,
                domiciliofiscal: rowsPrincipal[rowsPrincipal.length - 1].observaciones,
                tipoclientecheck: rowsPrincipal[0].incorrecto,
                nombrerazonsocialcheck: rowsPrincipal[1].incorrecto, rfccheck: rowsPrincipal[2].incorrecto, telefonocheck: rowsPrincipal[3].incorrecto,
                correoelectronicocheck: rowsPrincipal[4].incorrecto, representantelegalcheck: rowsPrincipal[5].incorrecto,
                empresacertificadoracheck: rowsPrincipal[6].Campo === 'Empresa Certificadora' ? (rowsPrincipal[6].incorrecto) : (false),
                cadenaproductivacheck: rowsPrincipal[rowsPrincipal.length - 2].incorrecto, domiciliofiscalcheck: rowsPrincipal[rowsPrincipal.length - 1].incorrecto,

            })
            // if (solicitud.certificacionsi) {
            //     principalMap.push({
            //         empresacertificadora: rowsPrincipal[5].observaciones,
            //         empresacertificadoracheck: rowsPrincipal[5].incorrecto
            //     })
            // }
            for (const datos of rowsPrincipal) {
                if (datos.Campo === 'Persona Autorizada') {
                    personaAutorizadaMap.push({ idfc01_anexopersonaatorizadatramitesmap: datos.idMap, personaautoriazadaparatramites: datos.observaciones, personaautoriazadaparatramitescheck: datos.incorrecto })
                    personaAutorizada.push({ idfc01_anexopersonaatorizadatramites: datos.idfc01_anexopersonaatorizadatramites, personaautoriazadaparatramites: datos.valor })
                }
            }
        }

        const productor = []
        const productorMap = []
        for (const datos of rowsProductor) {
            if (datos.Campo) {
                let domicilio = datos.valor.split(';')
                productor.push({ idfc01_anexoproductor: datos.idfc01_anexoproductor, localidad: domicilio[0], municipio: domicilio[1], distrito: domicilio[2], estado: domicilio[3] })
                productorMap.push({ idfc01_anexoproductormap: datos.idMap, domicilio: datos.observaciones, domiciliocheck: datos.incorrecto })
            }
        }
        const vivero = []
        const viveroMap = []
        for (const datos of rowsVivero) {
            if (datos.Campo) {
                let domicilio = datos.valor.split(';')
                vivero.push({
                    idfc01_anexopredios: datos.idfc01_anexopredios, calle: domicilio[0], numeroexterior: domicilio[1], codigopostal: domicilio[2], localidad: domicilio[3],
                    municipio: domicilio[4], distrito: domicilio[5], estado: domicilio[6]
                })
                viveroMap.push({ idfc01_anexoprediosmap: datos.idMap, domicilio: datos.observaciones, domiciliocheck: datos.incorrecto })
            }
        }
        const marcaDeMezcal = []
        const marcaDeMezcalMap = []
        for (const datos in rowsMarcaDeMezcal) {
            if (rowsMarcaDeMezcal[datos].Campo === 'Nombre de la marca') {
                // const pos1 = Number(datos )+ Number(1)
                marcaDeMezcal.push({
                    idfc01_anexomarcas: rowsMarcaDeMezcal[Number(datos)].idfc01_anexomarcas,
                    marca: rowsMarcaDeMezcal[Number(datos)].valor, anexoexistente: rowsMarcaDeMezcal[Number(datos)]?.anexoexistente,
                    numeroderegistroimpi: rowsMarcaDeMezcal[Number(datos) + Number(1)].valor,
                    // idtipomarca: rowsMarcaDeMezcal[Number(datos) + Number(2)]?.valor, idtitularidaddemarca: rowsMarcaDeMezcal[Number(datos) + Number(3)].valor,
                    productor: rowsMarcaDeMezcal[Number(datos) + Number(4)]?.Campo === 'Productor autorizado' ? (rowsMarcaDeMezcal[Number(datos) + Number(4)]?.valor) : '',
                    maquilador: rowsMarcaDeMezcal[Number(datos) + Number(5)]?.Campo === 'Maquilador autorizado' ? (rowsMarcaDeMezcal[Number(datos) + Number(5)]?.valor) : (rowsMarcaDeMezcal[Number(datos) + Number(4)]?.Campo === 'Maquilador autorizado' ? (rowsMarcaDeMezcal[Number(datos) + Number(4)]?.valor) : ''),
                })
                marcaDeMezcalMap.push({
                    idfc01_anexomarcasmap: rowsMarcaDeMezcal[datos].idMap,
                    marca: rowsMarcaDeMezcal[Number(datos)].observaciones, numeroderegistroimpi: rowsMarcaDeMezcal[Number(datos) + Number(1)].observaciones,
                    idtipomarca: rowsMarcaDeMezcal[Number(datos) + Number(2)]?.observaciones, idtitularidaddemarca: rowsMarcaDeMezcal[Number(datos) + Number(3)].observaciones,
                    productor: rowsMarcaDeMezcal[Number(datos) + Number(4)]?.Campo === 'Productor autorizado' ? (rowsMarcaDeMezcal[Number(datos) + Number(4)]?.observaciones) : '',
                    maquilador: rowsMarcaDeMezcal[Number(datos) + Number(5)]?.Campo === 'Maquilador autorizado' ? (rowsMarcaDeMezcal[Number(datos) + Number(5)]?.observaciones) : (rowsMarcaDeMezcal[Number(datos) + Number(4)]?.Campo === 'Maquilador autorizado' ? (rowsMarcaDeMezcal[Number(datos) + Number(4)]?.observaciones) : ''),

                    marcacheck: rowsMarcaDeMezcal[Number(datos)].incorrecto, numeroderegistroimpicheck: rowsMarcaDeMezcal[Number(datos) + Number(1)].incorrecto,
                    idtitularidaddemarcacheck: rowsMarcaDeMezcal[Number(datos) + Number(2)].incorrecto, idtipomarcacheck: rowsMarcaDeMezcal[Number(datos) + Number(3)].incorrecto,
                    productorcheck: rowsMarcaDeMezcal[Number(datos) + Number(4)]?.Campo === 'Productor autorizado' ? (rowsMarcaDeMezcal[Number(datos) + Number(4)]?.incorrecto) : false,
                    maquiladorcheck: rowsMarcaDeMezcal[Number(datos) + Number(5)]?.Campo === 'Maquilador autorizado' ? (rowsMarcaDeMezcal[Number(datos) + Number(5)]?.incorrecto) : (rowsMarcaDeMezcal[Number(datos) + Number(4)]?.Campo === 'Maquilador autorizado' ? (rowsMarcaDeMezcal[Number(datos) + Number(4)]?.incorrecto) : false),

                })
            }
        }
        const marcaProductoConMezcal = []
        const marcaProductoConMezcalMap = []
        for (const datos in rowsMarcaProductosConMezcal) {
            if (rowsMarcaProductosConMezcal[datos].Campo === 'Nombre de la marca') {
                marcaProductoConMezcal.push({
                    idfc01_anexomarcasproductoconmezcal: rowsMarcaProductosConMezcal[Number(datos)].idfc01_anexomarcasproductoconmezcal,
                    anexoexistente: rowsMarcaDeMezcal[Number(datos)]?.anexoexistente,
                    marca: rowsMarcaProductosConMezcal[Number(datos)].valor, numeroderegistroimpi: rowsMarcaProductosConMezcal[Number(datos) + Number(1)].valor,
                    // idtipomarca: rowsMarcaProductosConMezcal[Number(datos) + Number(2)].observaciones, idtitularidaddemarca: rowsMarcaProductosConMezcal[Number(datos) + Number(3)].observaciones,
                    productor: rowsMarcaProductosConMezcal[Number(datos) + Number(4)]?.Campo === 'Productor autorizado' ? (rowsMarcaProductosConMezcal[Number(datos) + Number(4)]?.valor) : '',
                    maquilador: rowsMarcaProductosConMezcal[Number(datos) + Number(5)]?.Campo === 'Maquilador autorizado' ? (rowsMarcaProductosConMezcal[Number(datos) + Number(5)]?.valor) : (rowsMarcaProductosConMezcal[Number(datos) + Number(4)]?.Campo === 'Maquilador autorizado' ? (rowsMarcaProductosConMezcal[Number(datos) + Number(4)]?.valor) : ''),
                })
                marcaProductoConMezcalMap.push({
                    idfc01_anexomarcasproductoconmezcalmap: rowsMarcaProductosConMezcal[datos].idMap,
                    marca: rowsMarcaProductosConMezcal[Number(datos)].observaciones, numeroderegistroimpi: rowsMarcaProductosConMezcal[Number(datos) + Number(1)].observaciones,
                    idtipomarca: rowsMarcaProductosConMezcal[Number(datos) + Number(2)].observaciones, idtitularidaddemarca: rowsMarcaProductosConMezcal[Number(datos) + Number(3)].observaciones,
                    productor: rowsMarcaProductosConMezcal[Number(datos) + Number(4)]?.Campo === 'Productor autorizado' ? (rowsMarcaProductosConMezcal[Number(datos) + Number(4)]?.observaciones) : '',
                    maquilador: rowsMarcaProductosConMezcal[Number(datos) + Number(5)]?.Campo === 'Maquilador autorizado' ? (rowsMarcaProductosConMezcal[Number(datos) + Number(5)]?.observaciones) : (rowsMarcaProductosConMezcal[Number(datos) + Number(4)]?.Campo === 'Maquilador autorizado' ? (rowsMarcaProductosConMezcal[Number(datos) + Number(4)]?.observaciones) : ''),

                    marcacheck: rowsMarcaProductosConMezcal[Number(datos)].incorrecto, numeroderegistroimpicheck: rowsMarcaProductosConMezcal[Number(datos) + Number(1)].incorrecto,
                    idtipomarcacheck: rowsMarcaProductosConMezcal[Number(datos) + Number(2)].incorrecto, idtitularidaddemarcacheck: rowsMarcaProductosConMezcal[Number(datos) + Number(3)].incorrecto,
                    productorcheck: rowsMarcaProductosConMezcal[Number(datos) + Number(4)]?.Campo === 'Productor autorizado' ? (rowsMarcaProductosConMezcal[Number(datos) + Number(4)]?.incorrecto) : false,
                    maquiladorcheck: rowsMarcaProductosConMezcal[Number(datos) + Number(5)]?.Campo === 'Maquilador autorizado' ? (rowsMarcaProductosConMezcal[Number(datos) + Number(5)]?.incorrecto) : (rowsMarcaProductosConMezcal[Number(datos) + Number(4)]?.Campo === 'Maquilador autorizado' ? (rowsMarcaProductosConMezcal[Number(datos) + Number(4)]?.incorrecto) : false),

                })
            }
        }

        const anexoPrincipalMap = []
        const anexoResponsableMap = []
        const anexoPrincipal = []
        const anexoResponsable = []
        for (const anexo of rowsAnexos) {
            if (anexo.Campo == "Domicilio de instalación") {
                const domicilio = anexo.valor.split(';')
                let opcionCalle = ''
                for (const i in solicitud.anexo) {
                    if (solicitud.anexo[i]?.informaciongeneral.idiformaciongeneral === anexo.idiformaciongeneral) {
                        opcionCalle = solicitud.anexo[i]?.informaciongeneral.calle
                        break;
                    }
                }
                if (opcionCalle === 'Otro') {
                    anexoPrincipal.push({
                        idiformaciongeneral: anexo.idiformaciongeneral, otracalle: domicilio[0], numerointerior: domicilio[1],
                        numeroexterior: domicilio[2], colonia: domicilio[3], codigopostal: domicilio[4], localidad: domicilio[5],
                        municipio: domicilio[6], estado: domicilio[7], anexoexistente: anexo.anexoexistente
                    })
                } else {
                    anexoPrincipal.push({
                        idiformaciongeneral: anexo.idiformaciongeneral, calle: domicilio[0], numerointerior: domicilio[1],
                        numeroexterior: domicilio[2], colonia: domicilio[3], codigopostal: domicilio[4], localidad: domicilio[5],
                        municipio: domicilio[6], estado: domicilio[7], anexoexistente: anexo.anexoexistente
                    })
                }


                anexoPrincipalMap.push({ idiformaciongeneralmap: anexo.idMap, domicilio: anexo.observaciones, domiciliocheck: anexo.incorrecto })
            }
            if (anexo.Campo == "Nombre del responsable") {
                anexoResponsable.push({ idresponsabledeinstalacion: anexo.idresponsabledeinstalacion, nombreresponsable: anexo.valor })

                anexoResponsableMap.push({ idresponsabledeinstalacionmap: anexo.idMap, nombreresponsable: anexo.observaciones, nombreresponsablecheck: anexo.incorrecto })
            }
        }
        const ObjetoObservacionesMap = [{
            principalMap, apoderadoLegalMap, personaAutorizadaMap, viveroMap, productorMap,
            marcaProductoConMezcalMap, marcaDeMezcalMap, anexoPrincipalMap, anexoResponsableMap
        }]

        const ObjetoActualizarDatos = [{
            principal, apoderadoLegal, personaAutorizada, vivero, productor,
            marcaProductoConMezcal, marcaDeMezcal, anexoPrincipal, anexoResponsable
        }]
        await dispatch(actualizarMapFC_01Accion(ObjetoObservacionesMap[0]))
        await dispatch(actualizarFC_01(ObjetoActualizarDatos[0]))
        await dispatch(actualizarMapsDocumentacion({ documentacion: rowDocumentacion, archivosGenerales: solicitud.fc_01_anexos }))
        await dispatch(actualizarLoadingApp_false())
        let dataDOM = {
            numerodom: numerodom, opcionDom: opcionDom, fechainiciodom: fechainiciodom, fechafindom: fechafindom, estatusdom: estatusdom,
            observacionesdom: observacionesdom, file: files, idfc01_solicitudregistro: solicitud.idfc01_solicitudregistro, fileMap: fileMap
        }
        await dispatch(actualizarDOMap(dataDOM))
    }


    const [openModalAceptar, setOpenModalAceptar] = React.useState(false);
    const [dataModal, setDataModal] = React.useState('')
    const handleOpenModalAceptar = () => setOpenModalAceptar(true);
    const handleCloseModalAceptar = () => setOpenModalAceptar(false);

    const [openModalDevolver, setOpenModalDevolver] = React.useState(false);
    const handleOpenModalDevolver = () => setOpenModalDevolver(true);
    const handleCloseModalDevolver = () => setOpenModalDevolver(false);
    const botonAceptarModal = async () => {
        let domicilioFiscal = rowsPrincipal[rowsPrincipal.length - 1].valor.split(';')
        const dataFomulario = {
            regimenfiscal: solicitud.personafisica === true ? 'Persona fisica' : 'Persona moral',
            calle: domicilioFiscal[0], numerointerior: domicilioFiscal[1] !== null ? domicilioFiscal[1] : '', numeroexterior: domicilioFiscal[2] !== null ? domicilioFiscal[2] : '',
            colonia: domicilioFiscal[3], localidad: domicilioFiscal[4], municipio: domicilioFiscal[5],
            estado: domicilioFiscal[6], codigopostal: domicilioFiscal[7], viverista: solicitud.viverista, productormaguey: solicitud.productormaguey,
            productormezcal: solicitud.productormezcal, envasador: solicitud.envasador,
            comercializadormezcal: solicitud.comercializadormezcal, comercializadorbebidasconmezcal: solicitud.comercializadorbebidasconmezcal,
            razonsocial: rowsPrincipal[1].valor, telefono: rowsPrincipal[3].valor, correoelectronico: rowsPrincipal[4].valor,
            representantelegal: rowsPrincipal[5].valor, passwordNom: solicitud.passwordnomsi
        }

        let hacerFormatos = false
        for (const anexo of rowsAnexos) {
            if (anexo.Campo == "Domicilio de instalación") {
                if (anexo.anexoexistente === false) {
                    hacerFormatos = true
                    break
                }
            }
        }

        for (const datos in rowsMarcaDeMezcal) {
            if (rowsMarcaDeMezcal[datos].Campo === 'Nombre de la marca') {
                if (rowsMarcaDeMezcal[Number(datos)]?.anexoexistente === false) {
                    hacerFormatos = true
                    break
                }
            }
        }

        for (const datos in rowsMarcaProductosConMezcal) {
            if (rowsMarcaProductosConMezcal[datos].Campo === 'Nombre de la marca') {
                if (rowsMarcaProductosConMezcal[Number(datos)]?.anexoexistente === false) {
                    hacerFormatos = true
                    break
                }
            }
        }

        dataFomulario.hacerFormatos = hacerFormatos
        setDataModal(dataFomulario)
        handleOpenModalAceptar()
    }
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });

    const zeroFill = (number) => {
        let width = 4
        width -= number.length
        if (width > 0) {
            return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number;
        }
        return number + "";
    }
    const botonRegresar = async () => {
        await dispatch(resetDataFC_01())
        props.history.push('/AtencionAClientesComponent')
    }

    const botonContinuar = async (dataForm) => {
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()
        if (modoProceso) await actualizarFC_01ModoProceso()
        else if (modoRecibidasCorregidas) await actualizarFC_01ModoCorrecion()
        await dispatch(actualizarLoadingApp_true())
        const idSolicitud = solicitud.idfc01_solicitudregistro
        const estatusNuevo = 4
        const actualizarFC_01 = {
            numerosocio: dataForm.numeroDeCliente
        }
        const resSolicitud = await dispatch(obtenerSolicitudFC_01ParaAceptar(idSolicitud))
        const solicitudParaAceptar = resSolicitud.payload
        const dataRevisor = await dispatch(obtenerRevisor(solicitudParaAceptar.revisor))
        let idtipocliente = 2
        if (solicitudParaAceptar.noasociado) idtipocliente = 1
        if (solicitudParaAceptar.asociado) idtipocliente = 2
        //if (solicitudParaAceptar.inscrito) idtipocliente = 3

        let dataMetricas = {
            estatus_procedencia: "Solicitudes Recibidas Procedentes",
            fecha: moment().format('YYYY-MM-DD HH:mm:ss'),
            id_solicitud: "1", id_usuario: dataUser?.[0].idlogin,
            motivo: "Cargado automatico del sistema",
            numero_cliente: dataForm?.numeroDeCliente,
            numero_solicitud: dataForm.numeroSolicitud, origen: "Sistema"
        }
        await dispatch(crearMetricas(dataMetricas))
        let informacionmodalaceptada = {
            numerocliente: dataForm?.numeroDeCliente, tipoidentificacion: dataForm?.tipoDeIdentificacion,
            numeroidentificacion: dataForm?.numeroDeIdentificacion, emisionacreditacion: dataForm?.emisionDeAcreditacion,
            datosactaconstitutiva: dataForm?.datosDelActa, objetosocial: dataForm?.objetoSocial,
            contraseñanom: dataForm?.passwordNom,
            numerosolicitudservicios: dataForm?.numeroSolicitud, numcertificadonom: '',
            numerotraslado: '', otrosservicios: dataForm?.otrosServicios,
            fechainspeccion: dataForm?.fechaInspeccion,
            numeroplanevaluacion: dataForm?.numeroPlanEvaluacion,
            inspectorasignado: dataForm?.inspectorAsignado, credencialinspector: dataForm?.credencialInspector,
            telefonoinspector: dataForm?.telefonoInspector, poderNotarial: dataForm?.poderNotarial
        }
        let modal = { idfc01_solicitudregistro: solicitud.idfc01_solicitudregistro, informacionmodalaceptada: informacionmodalaceptada }
        await (dispatch(actualizarFC_01Formulario(modal)))

        let numeroDeSocio = dataForm.numeroDeCliente + ''
        if (numeroDeSocio.length < 5) numeroDeSocio = zeroFill(numeroDeSocio)
        let idcartera = null
        if (dataRevisor.payload.idcartera !== undefined || dataRevisor.payload.idcartera !== null) idcartera = dataRevisor.payload.idcartera
        const actualizarSolicitudPrincipal = {
            idfc01_solicitudregistro: solicitud.idfc01_solicitudregistro, //fechasolicitud: fechaSolicitudAceptada,
            fechaaceptada: fechaSolicitudAceptada,
            numerosocio: numeroDeSocio, numerodom: numerodom, opciondom: opcionDom
        }
        await dispatch(actualizarFC_01NumSocio(actualizarSolicitudPrincipal))
        const solicitudPrincipal = {
            idlogin: solicitudParaAceptar.idlogin,
            numerosocio: numeroDeSocio, personafisica: solicitudParaAceptar.personafisica, personamoral: solicitudParaAceptar.personamoral,
            nombrerazonsocial: solicitudParaAceptar.nombrerazonsocial, fechasolicitud: fechaSolicitudAceptada, rfc: solicitudParaAceptar.rfc,
            telefono: solicitudParaAceptar.telefono, correoelectronico: solicitudParaAceptar.correoelectronico, idtipocliente, idcartera,
            numerodom: numerodom, opciondom: opcionDom
        }
        if (solicitud.personamoral) {
            solicitudPrincipal.nombrerepresentantelegal = solicitudParaAceptar.representantelegal
            solicitudPrincipal.telefonorepresentante = solicitudParaAceptar.telefonorepresentante
            solicitudPrincipal.correoelectronicorepresentante = solicitudParaAceptar.correoelectronicorepresentante
        } else {
            if (solicitud.representantelegalsi) solicitudPrincipal.nombrerepresentantelegal = solicitudParaAceptar.representantelegal
            else solicitudPrincipal.nombrerepresentantelegal = solicitudParaAceptar.representantelegal
            solicitudPrincipal.telefonorepresentante = solicitudParaAceptar.telefonorepresentante
            solicitudPrincipal.correoelectronicorepresentante = solicitudParaAceptar.correoelectronicorepresentante
        }

        if (solicitudParaAceptar.certificacionsi) solicitudPrincipal.empresacertificadora = solicitudParaAceptar.empresacertificadora
        const actividadCliente = {
            viverista: solicitudParaAceptar.viverista, productormaguey: solicitudParaAceptar.productormaguey, productormezcal: solicitudParaAceptar.productormezcal,
            envasador: solicitudParaAceptar.envasador, comercializadormezcal: solicitudParaAceptar.comercializadormezcal, comercializadorbebidasconmezcal: solicitudParaAceptar.comercializadorbebidasconmezcal,
        }

        const domicilioFiscal = {
            calle: solicitudParaAceptar.calle, numeroexterior: solicitudParaAceptar.numeroexterior !== null ? solicitudParaAceptar.numeroexterior : '',
            numerointerior: solicitudParaAceptar.numerointerior !== null ? solicitudParaAceptar.numerointerior : '',
            colonia: solicitudParaAceptar.colonia, localidad: solicitudParaAceptar.localidad, municipioalcaldia: solicitudParaAceptar.municipioalcaldia,
            estado: solicitudParaAceptar.estado, codigopostal: solicitudParaAceptar.codigopostal,
        }
        if (solicitud.calle === 'Otro') {
            domicilioFiscal.calle = solicitudParaAceptar.otracalle
        }
        const informacioFisica = {
            fechadenacimiento: solicitudParaAceptar.fechadenacimiento, sexo: solicitudParaAceptar.sexo, estadocivil: solicitudParaAceptar.estadocivil, escolaridad: solicitudParaAceptar.escolaridad,
            discapacidadno: solicitudParaAceptar.discapacidadno, discapacidadsi: solicitudParaAceptar.discapacidadsi, tipodiscapacidad: solicitudParaAceptar.tipodiscapacidad.length === 0 ? 'Ninguno' : solicitudParaAceptar.tipodiscapacidad,
            lenguaindijenasi: solicitudParaAceptar.lenguaindijenasi, lenguaindijenano: solicitudParaAceptar.lenguaindijenano, tipolengua: solicitudParaAceptar.tipolengua.length === 0 ? 'Ninguno' : solicitudParaAceptar.tipolengua,
            ocupacion: solicitudParaAceptar.ocupacion, numerohijos: solicitudParaAceptar.numerohijos
        }

        const estadisticaSocial = {
            numerohombres: solicitudParaAceptar.numerohombres, numeromujeres: solicitudParaAceptar.numeromujeres,
            numerodiscapacitados: solicitudParaAceptar.numerodiscapacitados, numerobase: solicitudParaAceptar.numerobase,
            numeroeventuales: solicitudParaAceptar.numeroeventuales
        }

        const objetoCompletoFC_01 = {
            solicitudPrincipal,
            actividadCliente,
            domicilioFiscal,
            informacioFisica,
            instalaciones: solicitudParaAceptar.anexo,
            estadisticaSocial,
            marcas: solicitudParaAceptar.fc_01_anexomarcas,
            marcasProduct: solicitudParaAceptar.fc_01_anexomarcasproductoconmezcal,
            personasAutorizadas: solicitudParaAceptar.fc_01_anexopersonaautorizadatramites,
            representantesLegales: solicitudParaAceptar.fc_01_anexorepresentantelegal,
            files: solicitudParaAceptar.fc_01_anexos,
            mediosDeContacto: solicitudParaAceptar.fc_01_anexomediosdecontacto,
            predios: solicitudParaAceptar.fc_01_anexoproductor,
            viveros: solicitudParaAceptar.fc_01_anexovivero,
            observacionComprobantePago: solicitudParaAceptar.comprobantepagotext,
        }

        const newIntalaciones = []
        for (const i in solicitudParaAceptar.anexo) {
            if (solicitudParaAceptar.anexo[i].informaciongeneral.anexoexistente === false) newIntalaciones.push(solicitudParaAceptar.anexo[i])
        }

        let activarCheckMarcario = false
        for (const i in solicitudParaAceptar.fc_01_anexomarcas) {
            if (solicitudParaAceptar.fc_01_anexomarcas[i].anexoexistente === false) activarCheckMarcario = true
        }
        for (const i in solicitudParaAceptar.fc_01_anexomarcasproductoconmezcal) {
            if (solicitudParaAceptar.fc_01_anexomarcasproductoconmezcal[i].anexoexistente === false) activarCheckMarcario = true
        }
        const resultCliente = await dispatch(aceptarSolicitudFC_01(
            { data: { idSolicitud: idSolicitud, estatus: estatusNuevo, folio: solicitudParaAceptar.folio }, objetoCompletoFC_01 }
        ))
        let datosInscripcion = ''
        if (solicitudParaAceptar.asociado) datosInscripcion = 'asociado'
        else if (solicitudParaAceptar.noasociado) datosInscripcion = 'no asociado'
        const idCliente = resultCliente.payload?.data?.data?.idcliente
        let objetoRelacion = {
            relaciones,
            numeroDeSocio,
            idCliente
        }
        await dispatch(agregarRelaciones(objetoRelacion))

        await generarOficios(dataForm, solicitudPrincipal, actividadCliente,
            solicitudParaAceptar.fc_01_anexomediosdecontacto, domicilioFiscal,
            solicitudParaAceptar.passwordnomsi, solicitudParaAceptar, newIntalaciones,
            objetoCompletoFC_01,
            idSolicitud,
            idCliente, activarCheckMarcario, datosInscripcion)
        await enviarEmail(solicitudPrincipal, solicitudParaAceptar.fc_01_anexomediosdecontacto, solicitudParaAceptar.passwordnomsi, idCliente)
        await dispatch(actualizarTipoUsuario({ idlogin: solicitudParaAceptar.idlogin, idtipousuario: 2 }))
        await dispatch(resetDataFC_01())

        const idRol = currentUser.user[0].rol
        if (idRol === 1) await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 4 }))
        else if (idRol === 2) await dispatch(obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado({ status: 4, revisor: dataUser[0]?.datoslogin.nombre + ' ' + dataUser[0]?.datoslogin.apellidos, idLogin: currentUser.user[0].id }))
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/AtencionAClientesComponent')
    }
    const modalComponentAceptar = () => {
        return (
            <div>
                <Modal
                    open={openModalAceptar}
                    onClose={handleCloseModalAceptar}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={styleParaModalDeDocumentos}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" color="black !important" align='center'>
                            Para finalizar el trámite ingrese los siguientes datos
                        </Typography>

                        <FormularioDocumentacion
                            data={dataModal}
                            functionAcept={botonContinuar}
                        ></FormularioDocumentacion>

                        <br />

                    </Box>
                </Modal>
            </div>

        )
    }
    const enviarEmail = async (solicitudPrincipal, mediosDeContacto, passwordNomSiNO, idCliente) => {
        const result = await dispatch(obtenerLogin(solicitud.idlogin))

        const correoLogin = result.data?.data?.usuario
        let correos = solicitudPrincipal.correoelectronico//colocar un correo valido si todos los datos de la sol. son ficticios para ver las pruebas
        let tipoPersona = ''
        if (solicitudPrincipal.personafisica) tipoPersona = 'Fisica'
        else tipoPersona = 'Moral'
        const passwordNom = passwordNomSiNO //Aun no esta en la base true-Envia archivo/ false-No envia archivo
        for (const i in mediosDeContacto) {
            correos += ', ' + mediosDeContacto[i].correoelectronico
        }
        if (correoLogin) {
            const arrayCorreos = correos.split(',')
            const correoResult = arrayCorreos.filter(correo => correo === correoLogin)
            if (correoResult.length === 0) correos += ", " + correoLogin
        }
        await dispatch(enviarCorreo({ correosDest: correos, tipoPersona, passwordNom, idCliente }))
    }
    const generarOficios = async (dataForm, solicitudPrincipal, actividadCliente, arrayMediosDeContacto,
        domicilioFiscalP, passwordNom, solicitudParaAceptar, instalaciones, objetoCompletoFC_01,
        idSolicitud, idCliente, activarCheckMarcario, datosInscripcion) => {

        if (solicitudPrincipal.personafisica) {
            const tipoPersona = 'Fisica'
            const oficioPassword = passwordNom
            const nombreRazonSocial = (solicitudPrincipal.nombrerazonsocial).toUpperCase()
            let cadenaProductiva = ''
            const arrayCadena = []
            if (actividadCliente.viverista) arrayCadena.push('VIVERISTA')
            if (actividadCliente.productormaguey) arrayCadena.push('Productor de maguey')
            if (actividadCliente.productormezcal) arrayCadena.push('Productor de mezcal')
            if (actividadCliente.envasador) arrayCadena.push('Envasador')
            if (actividadCliente.comercializadormezcal) arrayCadena.push('Comercializador de mezcal')
            if (actividadCliente.comercializadorbebidasconmezcal) arrayCadena.push('Comercializador de productos con mezcal')

            if (arrayCadena.length > 1) {
                for (const i in arrayCadena) {
                    if (Number(i) === 0) {
                        cadenaProductiva += arrayCadena[i]
                    } else if (Number(i) + Number(1) === arrayCadena.length) {
                        cadenaProductiva += ' y ' + arrayCadena[i]
                    } else {
                        cadenaProductiva += ', ' + arrayCadena[i]
                    }
                }
            } else {
                cadenaProductiva = arrayCadena[0]
            }

            const numeroSocio = dataForm.numeroDeCliente
            let numerointerior = ''
            if (domicilioFiscalP.numerointerior !== null && domicilioFiscalP.numerointerior !== undefined && domicilioFiscalP.numerointerior !== '') numerointerior = domicilioFiscalP.numerointerior
            else numerointerior = 'S/N'
            let numeroexterior = ''
            if (domicilioFiscalP.numeroexterior !== null && domicilioFiscalP.numeroexterior !== undefined && domicilioFiscalP.numeroexterior !== '') numeroexterior = domicilioFiscalP.numeroexterior
            else numeroexterior = 'S/N'

            const domicilioFiscal = domicilioFiscalP.calle + ", " + numerointerior + ', ' + numeroexterior + ', '
                + domicilioFiscalP.colonia + ', ' + domicilioFiscalP.localidad + ';' + domicilioFiscalP.municipioalcaldia + ', '
                + domicilioFiscalP.estado + ', C.P. ' + domicilioFiscalP.codigopostal

            let telefonos = solicitudPrincipal.telefono
            for (const i in arrayMediosDeContacto) {
                telefonos += ' ' + arrayMediosDeContacto[i].telefono
            }
            let tipoIdentificacion = ''
            if (dataForm.tipoDeIdentificacion === 'OTRO') {
                tipoIdentificacion = dataForm.otroTipoDeIdentificacion
            } else {
                tipoIdentificacion = dataForm.tipoDeIdentificacion
            }

            const numeroIdentificacion = dataForm.numeroDeIdentificacion
            const folioAsignacion = await dispatch(obtenerFolio(1))
            // const folioPrestacion = await dispatch(obtenerFolio(2))
            await dispatch(actualizarFolioOficio({ idSolicitud: 1, folio: await cambiarFolio(folioAsignacion.payload.folio) }))
            const data = {
                tipoSolicitud: 'FC_01',
                tipoPersona,
                oficioPassword,
                nombreRazonSocial: nombreRazonSocial.toUpperCase(),
                cadenaProductiva: cadenaProductiva.toUpperCase(),
                numeroSocio,
                domicilioFiscal: domicilioFiscal.toUpperCase(),
                telefonos,
                tipoIdentificacion: tipoIdentificacion.toUpperCase(),
                numeroIdentificacion,
                emisionDeAcreditacion: (dataForm.emisionDeAcreditacion).toUpperCase(),
                nombrerepresentantelegal: solicitudPrincipal.nombrerepresentantelegal,
                folioAsignacion: folioAsignacion.payload.folio,
                objetoCompletoFC_01,
                idSolicitud,
                idCliente,
                datosInscripcion,
                poderNotarial: dataForm?.poderNotarial
                // folioPrestacion: folioPrestacion.payload.folio,
            }
            let folioPasswordNom = null
            if (oficioPassword) {
                data.password = (dataForm.passwordNom).toUpperCase()
                folioPasswordNom = await dispatch(obtenerFolio(3))
                data.folioPasswordNom = folioPasswordNom.payload.folio
            }


            const dataSolicitudInspeccion = {
                numeroSolicitud: dataForm.numeroSolicitud,
                telefonoEmpresa: solicitud.telefono,
                correoElectronicoEmpresa: solicitud.correoelectronico,
                checkFabrica: false,
                checkProductor: false,
                checkNacional: false,
                checkEnvasadora: false,
                checkEnvasador: false,
                checkExportacion: false,
                checkGranel: false,
                checkComercializador: false,
                checkPromocion: false,
                checkProductoTerminado: false,
                checkTraslado: false,
                checkMaduracion: false,
                checkDitamenMarcario: activarCheckMarcario,
                numCertificadoNOM: '',
                numeroTraslado: '',
                otrosServicios: dataForm.otrosServicios,
                fechaInspeccion: dataForm.fechaInspeccion,
                instalaciones,
                numeroPlanEvaluacion: dataForm.numeroPlanEvaluacion,
                inspectorAsignado: dataForm.inspectorAsignado,
                credencialInspector: dataForm.credencialInspector,
                telefonoInspector: dataForm.telefonoInspector,
            }
            if (solicitudParaAceptar.representantelegalsi) {
                dataSolicitudInspeccion.telefonoRepresentante = solicitud.telefonorepresentante
                dataSolicitudInspeccion.correoElectronicoRepresentante = solicitud.correoelectronicorepresentante
            }

            // if(actividadCliente.comercializadormezcal || actividadCliente.comercializadorbebidasconmezcal) dataSolicitudInspeccion.checkDitamenMarcario = true, 
            data.dataSolicitudInspeccion = dataSolicitudInspeccion
            await dispatch(generarDocumentos(data))
            if (oficioPassword) {
                await dispatch(actualizarFolioOficio({ idSolicitud: 3, folio: await cambiarFolio(folioPasswordNom.payload.folio) }))
            }
        } else {
            const tipoPersona = 'Moral'
            const oficioPassword = passwordNom
            const representanteLegal = (solicitudPrincipal.nombrerepresentantelegal).toUpperCase()
            const nombreRazonSocial = (solicitudPrincipal.nombrerazonsocial).toUpperCase()
            let cadenaProductiva = ''
            const arrayCadena = []
            if (actividadCliente.viverista) arrayCadena.push('VIVERISTA')
            if (actividadCliente.productormaguey) arrayCadena.push('Productor de maguey')
            if (actividadCliente.productormezcal) arrayCadena.push('Productor de mezcal')
            if (actividadCliente.envasador) arrayCadena.push('Envasador')
            if (actividadCliente.comercializadormezcal) arrayCadena.push('Comercializador de mezcal')
            if (actividadCliente.comercializadorbebidasconmezcal) arrayCadena.push('Comercializador de productos con mezcal')
            if (arrayCadena.length > 1) {
                for (const i in arrayCadena) {
                    if (Number(i) === 0) {
                        cadenaProductiva += arrayCadena[i]
                    } else if (Number(i) + Number(1) === arrayCadena.length) {
                        cadenaProductiva += ' y ' + arrayCadena[i]
                    } else {
                        cadenaProductiva += ', ' + arrayCadena[i]
                    }
                }
            } else {
                cadenaProductiva = arrayCadena[0]
            }

            const numeroSocio = dataForm.numeroDeCliente

            let numerointerior = ''
            if (domicilioFiscalP.numerointerior !== null && domicilioFiscalP.numerointerior !== undefined && domicilioFiscalP.numerointerior !== '') numerointerior = domicilioFiscalP.numerointerior
            else numerointerior = 'S/N'
            let numeroexterior = ''
            if (domicilioFiscalP.numeroexterior !== null && domicilioFiscalP.numeroexterior !== undefined && domicilioFiscalP.numeroexterior !== '') numeroexterior = domicilioFiscalP.numeroexterior
            else numeroexterior = 'S/N'

            const domicilioFiscal = domicilioFiscalP.calle + ", " + numerointerior + ', ' + numeroexterior + ', '
                + domicilioFiscalP.colonia + ', ' + domicilioFiscalP.localidad + ';' + domicilioFiscalP.municipioalcaldia + ', '
                + domicilioFiscalP.estado + ', C.P. ' + domicilioFiscalP.codigopostal


            let telefonos = solicitudPrincipal.telefono + " " + solicitudPrincipal.telefonorepresentante
            for (const i in arrayMediosDeContacto) {
                telefonos += ' ' + arrayMediosDeContacto[i].telefono
            }

            let tipoIdentificacion = ''
            if (dataForm.tipoDeIdentificacion === 'OTRO') {
                tipoIdentificacion = dataForm.otroTipoDeIdentificacion
            } else {
                tipoIdentificacion = dataForm.tipoDeIdentificacion
            }

            const numeroIdentificacion = dataForm.numeroDeIdentificacion

            const folioAsignacion = await dispatch(obtenerFolio(1))
            await dispatch(actualizarFolioOficio({ idSolicitud: 1, folio: await cambiarFolio(folioAsignacion.payload.folio) }))

            // const folioPrestacion = await dispatch(obtenerFolio(2))
            // const tipoPersona = ''
            const data = {
                tipoSolicitud: 'FC_01',
                tipoPersona,
                oficioPassword,
                representanteLegal,
                nombreRazonSocial: nombreRazonSocial.toUpperCase(),
                cadenaProductiva: cadenaProductiva.toUpperCase(),
                numeroSocio,
                domicilioFiscal: domicilioFiscal.toUpperCase(),
                telefonos,
                tipoIdentificacion: tipoIdentificacion.toUpperCase(),
                numeroIdentificacion,
                emisionDeAcreditacion: (dataForm.emisionDeAcreditacion).toUpperCase(),
                objetoSocial: (dataForm.objetoSocial).toUpperCase(),
                datosDelActa: (dataForm.datosDelActa).toUpperCase(),
                folioAsignacion: folioAsignacion.payload.folio,
                objetoCompletoFC_01,
                idSolicitud,
                idCliente,
                datosInscripcion,
                poderNotarial: dataForm?.poderNotarial
                // folioPrestacion: folioPrestacion.payload.folio,
            }
            let folioPasswordNom = null
            if (oficioPassword) {
                data.password = (dataForm.passwordNom).toUpperCase()
                folioPasswordNom = await dispatch(obtenerFolio(3))
                data.folioPasswordNom = folioPasswordNom.payload.folio
            }

            const dataSolicitudInspeccion = {
                numeroSolicitud: dataForm.numeroSolicitud,
                telefonoRepresentante: solicitud.telefonorepresentante,
                correoElectronicoRepresentante: solicitud.correoelectronicorepresentante,
                checkFabrica: false,
                checkProductor: false,
                checkNacional: false,
                checkEnvasadora: false,
                checkEnvasador: false,
                checkExportacion: false,
                checkGranel: false,
                checkComercializador: false,
                checkPromocion: false,
                checkProductoTerminado: false,
                checkTraslado: false,
                checkMaduracion: false,
                checkDitamenMarcario: activarCheckMarcario,
                numCertificadoNOM: '',
                numeroTraslado: '',
                otrosServicios: dataForm.otrosServicios,
                fechaInspeccion: dataForm.fechaInspeccion,
                instalaciones,
                numeroPlanEvaluacion: dataForm.numeroPlanEvaluacion,
                inspectorAsignado: dataForm.inspectorAsignado,
                credencialInspector: dataForm.credencialInspector,
                telefonoInspector: dataForm.telefonoInspector,

            }
            // if(actividadCliente.comercializadormezcal || actividadCliente.comercializadorbebidasconmezcal) dataSolicitudInspeccion.checkDitamenMarcario = true, 

            data.dataSolicitudInspeccion = dataSolicitudInspeccion

            await dispatch(generarDocumentos(data))

            if (oficioPassword) {
                await dispatch(actualizarFolioOficio({ idSolicitud: 3, folio: await cambiarFolio(folioPasswordNom.payload.folio) }))
            }
        }

    }

    const cambiarFolio = async (folio) => {
        const nuevoFolio = ('000' + (parseInt(folio, 10) + 1)).slice(-4)
        return nuevoFolio
    }


    const [files, setFile] = React.useState([])
    const [fileMap, setFileMap] = React.useState([])
    const handdleFile = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_01/agregarAnexosArchivosFC_01'
        }
        const result = await dispatch(agregarFileFC_01(data))
        if (result.payload?.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idfc01_anexos
            objectFile.estatus = true
            setFile(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }


    }
    const handdleRemovePrev = async (objectFile) => {
        if (objectFile) {
            const newFiles = files.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_01/actualizarFileFC_01'
                }
                let result = await dispatch(actualizarFileFC_01(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_01/agregarAnexosArchivosFC_01'
                    }
                    result = await dispatch(agregarFileFC_01(data))
                }
                if (result.payload.data?.data) {
                    setFile(newFiles)
                    return true
                } else {
                    const newFiles = files.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFile(newFiles)
                    return false
                }
            }
        }
    }
    const [opcionDom, setopcionDom] = React.useState('')
    const [numerodom, setnumeroDom] = React.useState('')
    const [fechafindom, setFechaFinDom] = React.useState('')
    const [fechainiciodom, setFechaInicioDom] = React.useState('')
    const [estatusdom, setEstatusDom] = React.useState('')
    const [observacionesdom, setObservacionesDom] = React.useState('')
    const DenominacionFile = () => {
        return (
            <div>
                <Collapsible trigger="Agregar autorización de denominación de origen" className='mb-3'>
                    <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                        <div className={`col-md-12 ${estilos.selectorFile} text-center`}>
                            <div className="form-floating mb-2 text-center">
                                <select className={`form-select form-select-sm`} value={opcionDom} onChange={e => setopcionDom(e.target.value)} >
                                    <option value="">Seleccione una opción</option>
                                    <option value="Autorizado">Autorizado</option>
                                    <option value="En Trámite">En Trámite</option>
                                    <option value="No Cuenta">No Cuenta</option>
                                </select>
                            </div>
                        </div>
                        {(opcionDom === 'Autorizado' || opcionDom === 'En Trámite') &&
                            <div className='row'>
                                <div className={`col-md-10`}>
                                    <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGDO'} tabla={"FC_01_anexoat"}
                                        textLabel={opcionDom === 'Autorizado' ? `Denominación de origen` : 'Acuse de trámite ingresado ante el IMPI'} idAnexoFK={solicitud.idfc01_solicitudregistro} />
                                </div>
                                <div className={`col-md-1`}>
                                    <button className={('btn btn-outline-success ms-5')} onClick={() => handleOpenModalDOM()}>✓</button>
                                </div>
                            </div>
                        }
                    </div>
                </Collapsible>
            </div>
        )
    }

    const [openModalDOM, setOpenModalDOM] = React.useState(false);

    const handleOpenModalDOM = () => {
        setOpenModalDOM(true)
    }
    const handleCloseModalDOM = () => {
        setOpenModalDOM(false)

    }
    const botonAgregarDOM = () => {
        setEstatusDom(estadoVigencia)
        setOpenModalDOM(false)

    }
    const modalComponentDOM = () => {
        return (
            <div>
                <Modal
                    open={openModalDOM}
                    onClose={handleCloseModalDOM}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    hideBackdrop={true}
                >
                    <Box sx={styleCorrecto}>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 0 }} className='text-center'>

                            <div className="row">
                                <div className='form-floating mb-3 col-md-12'>
                                    <input className={`form-control`}
                                        type="number"
                                        onChange={e => setnumeroDom(e.target.value)}
                                        value={numerodom} id="numerosociocliente"
                                        name="numerosociocliente"
                                        onWheel={event => event.currentTarget.blur()}
                                        placeholder='numero'
                                    />
                                    <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                        Número de Denominacion de origen
                                    </label>
                                </div>
                                <div className="form-floating mb-3">
                                    <textarea className="form-control" id="exampleFormControlTextarea1"
                                        rows="3" value={observacionesdom} onChange={e => setObservacionesDom(e.target.value)}
                                        disabled={modoVerDetalle}
                                        placeholder='obs'></textarea>
                                    <label htmlFor="floatingInput">Observaciones</label>
                                </div>

                                <div className='form-floating mb-3'>
                                    <label htmlFor="floatingInput">Vigencia: </label>
                                    <button className={
                                        (estatusdom === '' || estatusdom === 'Agregar' || estatusdom === null) ? (
                                            `${estilos.agregarVigencia} btn ms-3`
                                        ) : estatusdom === 'Vigente' ? (
                                            'btn btn-success ms-3'
                                        ) : 'btn btn-danger ms-3'
                                    } onClick={() => { botonVigenciaDOM() }} disabled={modoVerDetalle}>{`${(estatusdom === '' || estatusdom === null) ? 'Agregar' : estatusdom}`}</button><br />
                                </div>


                                {
                                    vigenciaDOM &&
                                    <>
                                        <br />
                                        <div className='row justify-content-center'>
                                            <div className="form-floating col-md-6">
                                                <input type="date" className={`form-control `} id="floatinginput" placeholder='Inicio'
                                                    value={fechainiciodom} onChange={e => setFechaInicioDom(e.target.value)} />
                                                <label htmlFor="floatingInput"> Fecha inicio</label>
                                            </div>
                                            <div className="form-floating col-md-6">
                                                <input type="date" className={`form-control `} id="floatinginput" placeholder='Termino'
                                                    value={fechafindom} onChange={e => setFechaFinDom(e.target.value)} />
                                                <label htmlFor="floatingInput">Fecha termino</label>

                                            </div>
                                            <div className=" text-center" >
                                                <br />
                                                <button className='btn btn-warning' onClick={() => { botonCerrarVigenciaDOM() }}>Establecer</button>
                                            </div>
                                        </div>
                                    </>
                                }<br />
                            </div>
                        </Typography>
                        <br />
                        {modoVerDetalle ?
                            <div className='row'>
                                <div className={` text-center`}>
                                    <button className='btn btn-outline-danger' onClick={() => { handleCloseModalDOM() }}>CERRAR</button>
                                </div>
                            </div>
                            :
                            <div className='row'>
                                <div className='col-md-8'>
                                    <button className='btn btn-outline-success' onClick={() => { botonAgregarDOM() }}>AGREGAR</button>
                                </div>
                                <div className={`col-md-2`} style={{ marginLeft: '-7%' }}>
                                    <button className='btn btn-outline-danger' onClick={() => { handleCloseModalDOM() }}>CANCELAR</button>
                                </div>
                            </div>
                        }
                        <br />
                    </Box>
                </Modal>
            </div>
        )
    }
    const obtenerVigenciaDOM = () => {

        let bandera = false
        let fecha1 = new Date(fechafindom)
        let fecha2 = new Date(fechainiciodom)
        let milisegundosDia = 24 * 60 * 60 * 1000
        let milisegundosTrascurridos = Math.abs(fecha1.getTime() - fecha2.getTime())
        let diasTranscurridos = Math.round(milisegundosTrascurridos / milisegundosDia)
        let milisegundos = fecha1.getTime() - fecha2.getTime()
        let mili = milisegundos + ''
        if (milisegundos > 0 || mili == 'NaN') {
            setEstatusDom('Vigente')
        } else {
            setEstatusDom('Vencido')
        }
        return bandera
    }
    const [vigenciaDOM, setVigenciaDOM] = React.useState(false);
    const botonVigenciaDOM = () => {
        setVigenciaDOM(true)
    }
    const botonCerrarVigenciaDOM = () => {
        obtenerVigenciaDOM()
        setVigenciaDOM(false)
    }

    return (
        <div className='container-fluid mt-1 ms-5'>
            <div className='text-center'>
                <PaginacionAtencionAClientesComponent paginas={paginas} nombreParaPaginas={nombresParaPaginas} paginaActiva={paginaActiva} cambiarPagina={cambiarPagina} />
            </div>

            <div className="col-xs-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 text-end ">
                <IconButton sx={{ color: '#c88b3e' }} size="large" edge="end"
                    aria-label="Guardar cambios" aria-haspopup="true" onClick={() => solicitud?.fc_01_solicitudderegistromap?.[0] ? botonGuardarCorrecionesBorrador() : botonGuardarBorrador()}
                >
                    <SaveIcon />
                    {
                        solicitud?.fc_01_solicitudderegistromap?.[0] ? (
                            <div className="badge text-dark textoNormal textoModal">
                                Guardar cambios
                            </div>) : (
                            <div className="badge text-dark textoNormal textoModal">
                                Guardar cambios
                            </div>
                        )
                    }
                </IconButton>
            </div>

            {
                nombresParaPaginas[paginaActiva - 1] === 'Datos generales' ?
                    <>{tablaDataGrid(rowsPrincipal)}</>
                    :
                    (nombresParaPaginas[paginaActiva - 1] === 'Viverista' ||
                        nombresParaPaginas[paginaActiva - 1] === 'Productor de maguey' ||
                        nombresParaPaginas[paginaActiva - 1] === 'Viverista/Productor de maguey') ?
                        <div>
                            {
                                rowsProductor.length > 0 && <>{tablaDataGrid(rowsProductor)}</>
                            }

                            {
                                rowsVivero.length > 0 && <>{tablaDataGrid(rowsVivero)}</>
                            }

                        </div>
                        :
                        nombresParaPaginas[paginaActiva - 1] === 'Instalaciones' ? <>
                            {tablaDataGrid(rowsAnexos)}
                        </>

                            :
                            nombresParaPaginas[paginaActiva - 1] === 'Marcas' ?
                                <div>
                                    <h5 className='text-center'>Marcas de mezcal</h5>

                                    {tablaDataGrid(rowsMarcaDeMezcal)}

                                    <h5 className='text-center'>Marcas de productos con mezcal</h5>

                                    {tablaDataGrid(rowsMarcaProductosConMezcal)}


                                </div>
                                :
                                <div>

                                    {
                                        tablaDocumentacion(rowDocumentacion)
                                    }
                                    {
                                        solicitud.productormezcal &&
                                        <div className="row text-center" style={{ marginLeft: '5%', marginRight: '5%' }}>
                                            <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                {DenominacionFile()}
                                            </div>
                                        </div>
                                    }


                                    {modoVerDetalle ?
                                        <div className="row text-center">
                                            <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={botonRegresar} >Regresar</button>
                                            </div>
                                        </div>
                                        :
                                        <div className="row text-center mt-4 mb-4">
                                            <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={botonAceptarModal} >Aceptar solicitud</button>
                                            </div>

                                            <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={modoRecibidasCorregidas ? botonDevolverCorreciones : botonDevolver}>Devolver solicitud</button>
                                            </div>
                                        </div>
                                    }

                                    {modalComponentAceptar()}

                                </div>
            }
            {modalComponentCorrecto()}
            {modalComponentIncorrecto()}
            {modalComponentRelacion()}
            {modalComponentDOM()}
            {/* <button onClick={() => enviarEmail()}>Enviar Correo</button>
            <button onClick={() => generarOficios()}>Generar oficios</button> */}

        </div>
    )
}

export default FC_01AtencionAClientesComponent
